import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./App.css";
// ==================== FULL SERVICES DATA WITH DETAILED SUB-SERVICES ====================
const servicesData = {
  electrical: {
    title: "Electrical Works",
    titleAr: "الأعمال الكهربائية",
    description: "Complete electrical engineering solutions for industrial and commercial projects",
    icon: "fa-bolt",
    mainImage: "/image/service-electrical.jpg",
    urlSlug: "electrical",
    subServices: [
      {
        id: "power-distribution",
        urlSlug: "power-distribution",
        title: "Industrial Power Distribution",
        titleAr: "توزيع الطاقة الصناعية",
        shortDesc: "Complete power distribution systems for industrial facilities with advanced monitoring and control.",
        mainImage: "/image/ipd.jpg",
        images: ["/image/ipd.jpg", "/image/ipd1.jpg", "/image/ipd2.jpg"],
        fullDescription: `Our Industrial Power Distribution services provide comprehensive electrical power management solutions designed for large-scale industrial facilities, manufacturing plants, and commercial complexes.

We specialize in designing, installing, and commissioning complete power distribution networks that ensure reliable, efficient, and safe electricity supply throughout your facility. Our systems incorporate the latest technologies in power management, monitoring, and control.

Our power distribution solutions include main distribution boards (MDB), sub-distribution boards (SDB), motor control centers (MCC), and power control centers (PCC). We utilize state-of-the-art switchgear, circuit breakers, and protection devices from leading international manufacturers.

Key features of our power distribution systems include real-time monitoring, remote control capabilities, power quality analysis, energy consumption tracking, and predictive maintenance alerts. We implement comprehensive earthing and lightning protection systems to safeguard your equipment and personnel.

Our experienced engineers conduct thorough load analysis, fault calculations, and system studies to optimize your power distribution network. We ensure compliance with all Saudi Arabian electrical codes, international standards including IEC, IEEE, and NFPA requirements.

We provide complete documentation including single-line diagrams, schematic drawings, panel layouts, cable schedules, and comprehensive operation and maintenance manuals. Our after-sales support includes preventive maintenance, emergency repair services, and system upgrades to keep your power distribution infrastructure operating at peak performance.`,
        features: [
          "Complete MDB/SDB/MCC/PCC design and installation",
          "Real-time power monitoring systems",
          "Advanced protection and control devices",
          "Energy management and optimization",
          "Comprehensive earthing and lightning protection",
          "24/7 emergency support and maintenance"
        ]
      },
      {
        id: "lighting-design",
        urlSlug: "lighting-design",
        title: "Lighting Design & Installation",
        titleAr: "تصميم وتركيب الإضاءة",
        shortDesc: "Energy-efficient lighting solutions with modern LED technology and smart controls.",
        mainImage: "/image/ldi.jpg",
        images: ["/image/ldi.jpg", "/image/ldi1.jpg", "/image/ldi2.jpg"],
        fullDescription: `Transform your spaces with our cutting-edge Lighting Design & Installation services that combine aesthetic excellence with energy efficiency and advanced control systems.

Our lighting solutions incorporate the latest LED technology, delivering superior illumination while reducing energy consumption by up to 80% compared to traditional lighting systems. We design custom lighting schemes tailored to your specific requirements, whether for industrial warehouses, commercial offices, retail spaces, or outdoor facilities.

We conduct comprehensive lighting surveys and calculations using industry-leading software to ensure optimal illuminance levels, uniformity, and color rendering throughout your facility. Our designs comply with all relevant lighting standards and regulations.

Our smart lighting control systems include daylight harvesting, occupancy sensing, dimming controls, and centralized management platforms that allow you to monitor and control your entire lighting infrastructure from a single interface. These intelligent systems significantly reduce energy costs while enhancing user comfort and productivity.

For industrial facilities, we provide specialized lighting solutions including high-bay LED fixtures, explosion-proof lighting for hazardous areas, emergency lighting systems, and task lighting for precision work areas.

Our exterior lighting solutions encompass architectural lighting, landscape illumination, parking lot lighting, sports field lighting, and perimeter security lighting. All exterior fixtures are carefully selected for durability, weather resistance, and long-term reliability in harsh environmental conditions.

We handle every aspect of your lighting project from initial concept and design through installation, programming, commissioning, and ongoing maintenance. Our team ensures minimal disruption to your operations during installation and provides comprehensive training on system operation.`,
        features: [
          "LED lighting systems with up to 80% energy savings",
          "Smart controls and automation integration",
          "Daylight harvesting and occupancy sensing",
          "Emergency and exit lighting systems",
          "Architectural and decorative lighting",
          "Maintenance and retrofit services"
        ]
      },
      {
        id: "substation-construction",
        urlSlug: "substation-construction",
        title: "Substation Construction",
        titleAr: "إنشاء محطات التحويل",
        shortDesc: "Design and construction of electrical substations from 11kV to 400kV.",
        mainImage: "/image/sc.jpg",
        images: ["/image/sc.jpg", "/image/sc1.jpg", "/image/sc2.jpg"],
        fullDescription: `Our Substation Construction services deliver turnkey solutions for electrical substations ranging from 11kV distribution substations to 400kV transmission substations, serving industrial, commercial, and utility sector clients.

We provide complete engineering, procurement, construction, and commissioning (EPCC) services for greenfield substation projects as well as expansion and modernization of existing facilities. Our expertise covers all aspects of substation design including single-line diagrams, layout optimization, equipment selection, protection schemes, and control system integration.

Our substation solutions incorporate the latest technologies including gas-insulated switchgear (GIS), air-insulated switchgear (AIS), hybrid switchgear systems, and advanced protection relays. We work with world-class manufacturers to supply transformers, circuit breakers, isolators, instrument transformers, and auxiliary equipment that meet international quality standards.

The civil works for substations include site preparation, foundation design and construction, cable trenching, equipment foundations, control room buildings, drainage systems, and perimeter fencing with security systems. We ensure all civil structures are designed to withstand local environmental conditions and seismic requirements.

Our electrical installation teams are highly skilled in handling high-voltage equipment, cable termination and jointing, earthing grid installation, lightning protection systems, and DC systems. We conduct comprehensive testing including transformer tests, circuit breaker timing tests, protection relay settings, earth resistance measurements, and insulation resistance tests.

We implement modern SCADA systems for remote monitoring and control of substation equipment, providing real-time data acquisition, alarm management, event logging, and reporting capabilities. Our fiber optic communication networks ensure reliable data transmission between substations and control centers.

Safety is paramount in all our substation projects. We implement stringent safety protocols, provide comprehensive training to client personnel, and ensure compliance with all electrical safety regulations and industry best practices.`,
        features: [
          "11kV to 400kV substation design and construction",
          "GIS and AIS switchgear installation",
          "Transformer installation and commissioning",
          "SCADA and automation systems",
          "Protection and control systems",
          "Comprehensive testing and commissioning"
        ]
      },
      {
        id: "hv-cable-installation",
        urlSlug: "hv-cable-installation",
        title: "High-Voltage Cable Installation",
        titleAr: "تركيب كابلات الجهد العالي",
        shortDesc: "Professional installation of HV cables with proper testing and commissioning.",
        mainImage: "/image/hvci.jpg",
        images: ["/image/hvci.jpg", "/image/hvci1.jpg", "/image/hvci2.jpg"],
        fullDescription: `Our High-Voltage Cable Installation services provide comprehensive solutions for power transmission and distribution networks, ensuring reliable and efficient electricity supply for industrial, commercial, and infrastructure projects.

We specialize in the installation of HV cables ranging from 11kV to 400kV, including XLPE cables, oil-filled cables, and gas-insulated cables. Our experienced teams handle all aspects of cable installation including route surveying, trench excavation, cable laying, jointing, termination, testing, and commissioning.

Cable route planning is conducted using advanced surveying equipment and GIS mapping to optimize cable paths, minimize costs, and avoid conflicts with existing utilities. We coordinate with relevant authorities to obtain necessary permits and ensure compliance with all regulations.

Our cable installation methods include direct burial, duct installation, cable tray systems, and tunnel installations. For each project, we select the most appropriate installation method based on technical requirements, environmental conditions, and cost considerations. We implement proper cable protection measures including concrete encasement, warning tape, and marker posts.

Cable jointing and termination are critical activities that require specialized skills and equipment. Our certified jointing teams use quality materials and proven techniques to create reliable joints and terminations. We install outdoor terminations with surge arresters, stress cones, and weather-resistant enclosures to ensure long-term performance.

Comprehensive testing is conducted at every stage of cable installation. We perform insulation resistance tests, high-voltage tests, partial discharge tests, tan delta tests, and sheath integrity tests to verify cable quality and installation workmanship. All test results are documented and provided to clients with detailed test reports.

For existing cable networks, we provide fault location services using advanced cable fault locators, time domain reflectometers (TDR), and acoustic detection equipment. Our repair teams can quickly locate and repair cable faults, minimizing downtime and restoring power supply.

We also offer cable condition monitoring services including online partial discharge monitoring, temperature monitoring, and periodic diagnostic testing to assess cable health and predict potential failures before they occur.`,
        features: [
          "11kV to 400kV cable installation",
          "Cable jointing and termination",
          "Underground and overhead cable routing",
          "Cable testing and commissioning",
          "Fault location and repair services",
          "Cable condition monitoring"
        ]
      },
      {
        id: "emergency-power",
        urlSlug: "emergency-power",
        title: "Emergency Power Systems",
        titleAr: "أنظمة الطاقة الطارئة",
        shortDesc: "Backup power solutions including generators, UPS systems, and transfer switches.",
        mainImage: "/image/eps.jpg",
        images: ["/image/eps.jpg", "/image/eps1.jpg", "/image/eps2.jpg"],
        fullDescription: `Our Emergency Power Systems provide reliable backup power solutions that ensure business continuity and protect critical operations during utility power outages. We design, install, and maintain comprehensive backup power infrastructure for hospitals, data centers, industrial facilities, commercial buildings, and essential services.

Diesel and gas generator systems form the backbone of our emergency power solutions. We supply generators ranging from small portable units to large containerized generator sets capable of providing megawatts of power. Our generator installations include all necessary auxiliary systems such as fuel storage tanks, fuel transfer pumps, cooling systems, exhaust systems, and acoustic enclosures for noise reduction.

Generator control systems include automatic mains failure (AMF) panels, synchronization systems for paralleling multiple generators, load management systems, and remote monitoring capabilities. These intelligent controls ensure seamless power transfer during outages and optimal generator operation under varying load conditions.

Uninterruptible Power Supply (UPS) systems provide instantaneous backup power for critical loads that cannot tolerate even brief power interruptions. We offer UPS systems in various configurations including standalone units, modular scalable systems, and N+1 redundant configurations. Our UPS installations include battery banks, battery monitoring systems, and bypass arrangements for maintenance without interrupting power supply.

Automatic Transfer Switches (ATS) are critical components that detect power failures and automatically switch loads between normal and emergency power sources. We install both open transition and closed transition transfer switches depending on application requirements. Our ATS installations include comprehensive interlocking and control systems to prevent parallel operation of utility and generator sources.

For facilities requiring uninterrupted power, we design hybrid systems combining UPS for instantaneous backup and generators for extended runtime. These integrated systems provide complete power protection against all types of power disturbances including blackouts, brownouts, voltage sags, surges, and frequency variations.

Our maintenance programs include regular inspections, load bank testing, battery testing, fuel quality checks, and preventive maintenance of all system components. We provide 24/7 emergency support to address any issues and ensure your backup power systems are always ready to perform when needed.`,
        features: [
          "Diesel and gas generator installation",
          "UPS systems with battery backup",
          "Automatic transfer switches (ATS)",
          "Load bank testing and commissioning",
          "Remote monitoring and control",
          "24/7 maintenance and support"
        ]
      },
      {
        id: "panel-manufacturing",
        urlSlug: "panel-manufacturing",
        title: "Electrical Panel Manufacturing",
        titleAr: "تصنيع اللوحات الكهربائية",
        shortDesc: "Custom electrical panel design and manufacturing to international standards.",
        mainImage: "/image/epm.jpg",
        images: ["/image/epm.jpg", "/image/epm1.jpg", "/image/epm2.jpg"],
        fullDescription: `Our Electrical Panel Manufacturing facility produces custom-engineered electrical panels and control systems designed to meet the specific requirements of industrial, commercial, and infrastructure projects across Saudi Arabia.

We manufacture a comprehensive range of electrical panels including Main Distribution Boards (MDB), Sub-Distribution Boards (SDB), Motor Control Centers (MCC), Power Control Centers (PCC), Power Factor Correction (PFC) panels, Automatic Mains Failure (AMF) panels, and specialized control panels for various applications.

Our design process begins with detailed discussions with clients to understand their requirements, operating conditions, and technical specifications. Our experienced electrical engineers prepare comprehensive design drawings including single-line diagrams, schematic diagrams, panel layouts, wiring diagrams, and bill of materials.

We use high-quality components from internationally recognized manufacturers including circuit breakers, contactors, relays, meters, and control devices. All materials are carefully selected to ensure long-term reliability, easy maintenance, and compliance with international standards including IEC 61439, UL, and relevant Saudi Arabian regulations.

Our state-of-the-art manufacturing facility is equipped with modern machinery for cutting, bending, punching, and powder coating of panel enclosures. We manufacture panels in various enclosure types including floor-standing, wall-mounted, and weatherproof outdoor enclosures with appropriate IP ratings for different environmental conditions.

Panel assembly is performed by skilled technicians following strict quality control procedures. All wiring is done using color-coded cables with proper cable management, ferruling, and labeling. We conduct point-to-point continuity checks to verify correct wiring before energization.

Every panel undergoes rigorous testing before dispatch including insulation resistance tests, high-voltage tests, circuit breaker operation tests, interlock verification, and functional testing of all control circuits. Test certificates and quality documentation are provided with each panel.

We also offer panel retrofitting and modernization services for existing installations, replacing obsolete components with modern equivalents, upgrading protection systems, and improving safety features while maintaining compatibility with existing infrastructure.`,
        features: [
          "Custom panel design and engineering",
          "MDB, SDB, MCC, PCC manufacturing",
          "IEC 61439 compliant construction",
          "Factory acceptance testing (FAT)",
          "Complete documentation and drawings",
          "Installation and commissioning support"
        ]
      }
    ]
  },
  civil: {
    title: "Civil Works & Infrastructure",
    titleAr: "الأعمال المدنية والبنية التحتية",
    description: "Comprehensive civil engineering and infrastructure development solutions",
    icon: "fa-building",
    mainImage: "/image/service-civil.jpg",
    urlSlug: "civil",
    subServices: [
      {
        id: "foundation-works",
        urlSlug: "foundation-works",
        title: "Foundation Works",
        titleAr: "أعمال الأساسات",
        shortDesc: "Deep foundations, pile driving, and ground improvement for large structures.",
        mainImage: "/image/fw.jpg",
        images: ["/image/civil-1.jpg", "/image/civil-2.jpg", "/image/civil-3.jpg"],
        fullDescription: `Our Foundation Works services provide comprehensive solutions for all types of foundation systems, ensuring stable and long-lasting support for buildings, industrial structures, and infrastructure projects throughout Saudi Arabia.

We specialize in the design and construction of shallow foundations including isolated footings, combined footings, strap footings, mat foundations, and strip footings. Our engineering team conducts thorough soil investigations and geotechnical analysis to determine the most appropriate and cost-effective foundation solution for each project.

For projects requiring deep foundations, we have extensive experience in driven piles, bored piles, continuous flight auger (CFA) piles, and micro-piles. Our pile driving equipment includes modern hydraulic hammers, diesel hammers, and vibratory hammers capable of installing piles of various sizes and types in different soil conditions.`,
        features: [
          "Shallow and deep foundation systems",
          "Driven piles and bored piles",
          "Ground improvement solutions",
          "Pile testing and quality assurance",
          "Equipment foundation and base plates",
          "Marine and waterfront foundations"
        ]
      },
      {
        id: "steel-erection",
        urlSlug: "steel-erection",
        title: "Structural Steel Erection",
        titleAr: "تركيب الهياكل الفولاذية",
        shortDesc: "Professional steel structure installation for industrial and commercial buildings.",
        mainImage: "/image/sse.jpg",
        images: ["/image/civil-2.jpg", "/image/civil-4.jpg", "/image/civil-5.jpg"],
        fullDescription: `Our Structural Steel Erection services deliver precision steel structure installation for industrial facilities, commercial buildings, warehouses, and infrastructure projects across the Kingdom of Saudi Arabia.

We handle all aspects of steel erection from planning and logistics through assembly, installation, alignment, and final connection. Our experienced erection crews are trained in the latest industry practices and work safely and efficiently to meet project schedules.`,
        features: [
          "Heavy steel structure erection",
          "High-rise building steel installation",
          "Industrial plant structures",
          "Bolted and welded connections",
          "Comprehensive safety protocols",
          "Quality inspection and documentation"
        ]
      },
      {
        id: "road-construction",
        urlSlug: "road-construction",
        title: "Road & Highway Construction",
        titleAr: "إنشاء الطرق والطرق السريعة",
        shortDesc: "Complete road construction services including asphalt paving and road marking.",
        mainImage: "/image/rhc.jpg",
        images: ["/image/civil-3.jpg", "/image/civil-1.jpg", "/image/civil-6.jpg"],
        fullDescription: `Our Road & Highway Construction services provide complete solutions for the design, construction, and rehabilitation of roads, highways, streets, and parking facilities throughout Saudi Arabia, supporting the Kingdom's infrastructure development goals.

We execute road projects of all scales from small access roads to multi-lane highways, applying international standards and best practices to deliver durable, safe, and cost-effective transportation infrastructure.`,
        features: [
          "Highway and road design and construction",
          "Asphalt and concrete paving",
          "Earthwork and grading operations",
          "Drainage system installation",
          "Road marking and signage",
          "Pavement rehabilitation and maintenance"
        ]
      }
    ]
  },
  mechanical: {
    title: "Mechanical & Plumbing",
    titleAr: "الأعمال الميكانيكية والسباكة",
    description: "Complete mechanical and plumbing solutions",
    icon: "fa-cog",
    mainImage: "/image/service-mech.jpg",
    urlSlug: "mechanical",
    subServices: [
      {
        id: "hvac-systems",
        urlSlug: "hvac-systems",
        title: "HVAC Systems",
        titleAr: "أنظمة التدفئة والتهوية وتكييف الهواء",
        shortDesc: "Complete HVAC design, installation, and commissioning for all types of buildings.",
        mainImage: "/image/hvac.jpg",
        images: ["/image/mech-1.jpg", "/image/mech-2.jpg", "/image/mech-3.jpg"],
        fullDescription: `Our HVAC Systems services provide comprehensive heating, ventilation, and air conditioning solutions for residential, commercial, and industrial facilities across Saudi Arabia, ensuring optimal indoor climate control, energy efficiency, and occupant comfort.

We offer complete HVAC services including system design, equipment selection, installation, testing, commissioning, and ongoing maintenance. Our experienced HVAC engineers utilize advanced load calculation software and building energy modeling tools to design systems that meet specific project requirements while optimizing energy consumption and operating costs.`,
        features: [
          "Complete HVAC system design and engineering",
          "VRF, chilled water, and packaged systems",
          "Energy-efficient equipment selection",
          "Ductwork fabrication and installation",
          "Building automation and controls",
          "Testing, balancing, and commissioning"
        ]
      }
    ]
  },
  instrumentation: {
    title: "Instrumentation Systems",
    titleAr: "أنظمة الأجهزة",
    description: "Industrial instrumentation and control systems",
    icon: "fa-tachometer-alt",
    mainImage: "/image/service-inst.jpg",
    urlSlug: "instrumentation",
    subServices: [ {
        id: "process-instrumentation",
        urlSlug: "process-instrumentation",
        title: "Process Instrumentation & Field Devices",
        titleAr: "أجهزة القياس والتحكم الصناعية",
        shortDesc: "Complete field instrumentation including sensors, transmitters, and analyzers for process control.",
        mainImage: "/image/pifd.jpg",
        images: ["/image/inst-1.jpg", "/image/inst-2.jpg", "/image/inst-3.jpg"],
        fullDescription: `Our Process Instrumentation & Field Devices services provide comprehensive solutions for industrial measurement and control, delivering accurate, reliable field instrumentation for oil & gas, petrochemical, power generation, water treatment, and manufacturing facilities across Saudi Arabia.

We design, procure, install, calibrate, and commission complete field instrumentation systems including temperature, pressure, flow, level measurement devices, analytical instruments, and smart transmitters that form the foundation of modern process control systems.

Temperature measurement solutions include thermocouples, resistance temperature detectors (RTDs), thermowells, temperature transmitters, and non-contact infrared temperature sensors. We select appropriate sensor types, materials, and protection methods based on process conditions, accuracy requirements, and hazardous area classifications.

Pressure instrumentation encompasses pressure transmitters, differential pressure transmitters, pressure gauges, pressure switches, and specialized high-accuracy pressure measurement devices. We install pressure measurement systems for static pressure, differential pressure, gauge pressure, absolute pressure, and vacuum applications with appropriate impulse piping, manifolds, and isolation valves.

Flow measurement systems include electromagnetic flowmeters, vortex flowmeters, ultrasonic flowmeters, Coriolis mass flowmeters, turbine flowmeters, and differential pressure flow devices including orifice plates, venturi tubes, and flow nozzles. We conduct detailed flow calculations, select optimal flowmeter technologies, and install complete flow measurement systems with flow computers and totalizers.

Level measurement solutions utilize guided wave radar, non-contact radar, ultrasonic level transmitters, capacitance level sensors, float level switches, displacer level transmitters, and hydrostatic pressure level measurement. We design level measurement systems for liquids, solids, slurries, and interfaces in tanks, vessels, silos, and open channels under various process conditions.

Analytical instrumentation includes pH meters, conductivity analyzers, dissolved oxygen analyzers, turbidity meters, gas analyzers, moisture analyzers, and specialized process analyzers. We install complete analyzer systems including sample conditioning panels, analyzer shelters, and calibration gas systems ensuring accurate, reliable analytical measurements.

Control valves and actuators regulate process variables. We specify and install pneumatic control valves, electric actuated valves, hydraulic actuators, and specialized control valve assemblies including globe valves, ball valves, butterfly valves, and rotary valves with appropriate valve sizing, trim selection, and actuator specifications.

Smart transmitters with HART, Foundation Fieldbus, or Profibus communication protocols provide digital communication capabilities enabling remote configuration, diagnostics, and advanced functionality. We implement smart instrument systems with asset management software tracking instrument performance, calibration history, and predictive maintenance requirements.

Instrument installation includes proper mounting, impulse piping installation, instrument enclosures, junction boxes, and cable termination. We follow industry standards including ISA, IEC, and API requirements ensuring installations meet safety, reliability, and maintainability requirements.

Calibration services ensure measurement accuracy. We provide field calibration using traceable standards, calibration management systems tracking calibration schedules, and calibration certificates documenting instrument performance meeting quality and regulatory requirements.

Loop checking and commissioning verify complete measurement and control loops. We conduct point-to-point checks, loop tests, functional tests, and integrated system testing ensuring instruments operate correctly within overall control systems.

Hazardous area instrumentation meets explosion protection requirements. We install intrinsically safe instruments, flameproof enclosures, purged and pressurized enclosures, and dust-ignition proof equipment complying with ATEX, IECEx, and local regulations protecting personnel and facilities.

Maintenance services include preventive maintenance, troubleshooting, repair, and instrument replacement. We provide ongoing support ensuring field instrumentation maintains accuracy, reliability, and regulatory compliance throughout operational life.`,
        features: [
          "Temperature, pressure, flow, and level measurement",
          "Smart transmitters with digital communication",
          "Analytical instrumentation and sampling systems",
          "Control valves and valve actuators",
          "Hazardous area certified instruments",
          "Calibration and loop commissioning services"
        ]
      },
      {
        id: "dcs-scada",
        urlSlug: "dcs-scada",
        title: "DCS & SCADA Systems",
        titleAr: "أنظمة التحكم الموزعة والمراقبة",
        shortDesc: "Distributed control systems and SCADA platforms for centralized process monitoring and control.",
        mainImage: "/image/dss.jpg",
        images: ["/image/inst-2.jpg", "/image/inst-4.jpg", "/image/inst-5.jpg"],
        fullDescription: `Our DCS & SCADA Systems services deliver advanced process automation solutions providing centralized monitoring, control, and optimization of industrial processes for oil & gas facilities, power plants, chemical plants, water treatment facilities, and manufacturing operations.

We design, implement, and support complete distributed control systems (DCS) and supervisory control and data acquisition (SCADA) platforms that integrate field instrumentation, control logic, operator interfaces, and information management creating comprehensive process automation solutions.

Distributed Control Systems provide integrated control for continuous processes. We implement DCS platforms from leading manufacturers including Honeywell, Emerson DeltaV, Yokogawa, ABB, and Siemens offering redundant controllers, high-availability architectures, and comprehensive control capabilities for complex industrial processes.

DCS controller architecture includes redundant process controllers, input/output (I/O) modules, communication networks, and power supplies ensuring reliable control system operation. We design controller configurations, I/O allocation, redundancy schemes, and network topologies optimizing system performance, reliability, and maintenance access.

Control strategies implement advanced process control. We develop control logic including regulatory control loops (PID control), cascade control, ratio control, feedforward control, and multivariable control strategies optimizing process performance, product quality, and energy efficiency.

Operator workstations provide human-machine interface (HMI) for process monitoring and control. We design intuitive graphical displays including process overview displays, detailed unit displays, trend displays, alarm displays, and batch displays enabling operators to efficiently monitor and control processes.

Alarm management systems prioritize and present process alarms. We implement alarm philosophies, alarm rationalization, alarm prioritization, and advanced alarm management techniques reducing alarm floods, improving operator response, and enhancing process safety.

SCADA systems provide supervisory control for distributed processes. We implement SCADA platforms monitoring and controlling geographically distributed assets including pipelines, remote wellheads, distributed utilities, and multi-site facilities using various communication technologies.

SCADA architecture includes master stations, remote terminal units (RTUs), programmable logic controllers (PLCs), communication networks, and redundant servers. We design SCADA architectures considering communication reliability, data security, scalability, and disaster recovery requirements.

Communication systems connect field devices to control systems. We implement industrial Ethernet networks, fieldbus networks (Foundation Fieldbus, Profibus), wireless communication systems, and serial communication links providing reliable data transmission throughout control systems.

Cybersecurity protection safeguards control systems. We implement defense-in-depth security strategies including network segmentation, firewalls, intrusion detection systems, access control, encryption, and security monitoring protecting control systems from cyber threats while maintaining operational functionality.

Historical data systems archive process data. We implement process historians storing real-time data, calculated data, and event data supporting process optimization, regulatory compliance reporting, production accounting, and long-term performance analysis.

Integration with business systems connects process data to enterprise systems. We implement interfaces between control systems and enterprise resource planning (ERP), manufacturing execution systems (MES), laboratory information management systems (LIMS), and asset management systems enabling data-driven decision making.

Batch control systems manage recipe-based production. We implement batch management systems following ISA-88 standards automating batch processes, recipe management, material tracking, and batch reporting for pharmaceutical, food & beverage, and specialty chemical production.

Testing and commissioning verifies system functionality. We conduct factory acceptance testing (FAT), site acceptance testing (SAT), integrated system testing, performance testing, and operational readiness reviews ensuring control systems meet functional requirements and performance specifications.

Training services prepare operations and maintenance personnel. We provide comprehensive training including system overview, operator training, engineering training, and maintenance training ensuring personnel can effectively operate and maintain control systems.

Ongoing support includes system monitoring, troubleshooting, software updates, spare parts management, and continuous improvement services maintaining control system performance throughout operational life.`,
        features: [
          "DCS platforms from leading manufacturers",
          "SCADA systems for distributed assets",
          "Advanced process control strategies",
          "Redundant and high-availability architectures",
          "Cybersecurity and network protection",
          "Process historians and data management"
        ]
      },
      {
        id: "plc-automation",
        urlSlug: "plc-automation",
        title: "PLC & Automation Systems",
        titleAr: "أنظمة المتحكمات المنطقية القابلة للبرمجة",
        shortDesc: "Programmable logic controllers and discrete automation for manufacturing and process industries.",
        mainImage: "/image/plc.jpg",
        images: ["/image/inst-3.jpg", "/image/inst-1.jpg", "/image/inst-6.jpg"],
        fullDescription: `Our PLC & Automation Systems services provide comprehensive programmable logic controller solutions for discrete manufacturing, batch processes, packaging lines, material handling systems, and utility automation delivering reliable, flexible automation across diverse industrial applications.

We design, program, install, and commission complete PLC-based automation systems utilizing controllers from leading manufacturers including Siemens, Allen-Bradley/Rockwell, Schneider Electric, Mitsubishi, and Omron creating custom automation solutions tailored to specific application requirements.

PLC hardware selection considers application complexity, I/O requirements, communication needs, and environmental conditions. We specify appropriate PLC platforms including compact PLCs for simple applications, modular PLCs for larger systems, and safety PLCs for safety-critical applications ensuring optimal hardware configurations.

Input/output (I/O) systems connect PLCs to field devices. We design I/O architectures including digital inputs, digital outputs, analog inputs, analog outputs, and specialty I/O modules. We implement distributed I/O using remote I/O modules, fieldbus networks, and industrial Ethernet reducing wiring costs and improving system flexibility.

PLC programming implements control logic using industry-standard programming languages including ladder logic, structured text, function block diagrams, sequential function charts, and instruction lists following IEC 61131-3 standards. We develop well-structured, documented programs facilitating maintenance and future modifications.

Control strategies automate machine operations, sequential processes, and batch operations. We implement logic for motor control, valve control, sequential operations, interlock logic, recipe management, and process control creating efficient, reliable automation systems.

Human-machine interfaces (HMI) provide operator interaction. We design and implement HMI systems using industrial touch panels, PC-based HMI software, and mobile HMI applications providing intuitive interfaces for monitoring, control, recipe management, alarm viewing, and reporting.

Motion control systems position and control mechanical systems. We implement servo drives, stepper motors, variable frequency drives (VFDs), and motion controllers for precise positioning, coordinated motion, and speed control in packaging, material handling, and manufacturing applications.

Safety automation protects personnel and equipment. We design and implement safety-rated PLCs, safety relays, safety light curtains, emergency stop circuits, and safety interlocks complying with ISO 13849, IEC 62061, and machinery safety directives ensuring safe machine operation.

Industrial networking connects automation components. We implement Ethernet/IP, Profinet, Modbus TCP, DeviceNet, and other industrial protocols enabling communication between PLCs, HMIs, drives, instruments, and supervisory systems creating integrated automation architectures.

SCADA integration provides centralized monitoring. We integrate PLCs with SCADA systems enabling plant-wide visibility, historical trending, alarm management, and centralized control of distributed processes and equipment.

Manufacturing execution system (MES) integration connects automation to production management. We implement interfaces between PLCs and MES platforms providing real-time production data, downtime tracking, quality data, and material traceability supporting operational intelligence and continuous improvement.

Panel design and fabrication creates organized control enclosures. We design control panels, motor control centers (MCC), and electrical enclosures housing PLCs, drives, power supplies, and associated equipment. Our panel fabrication follows UL508A standards ensuring code-compliant installations.

Programming standards ensure maintainable code. We follow consistent naming conventions, structured programming practices, comprehensive documentation, and version control creating programs that are understandable and maintainable by operations and engineering personnel.

Testing and commissioning validates system operation. We conduct thorough testing including logic simulation, point-to-point checks, functional tests, integrated testing, and performance verification ensuring automation systems operate correctly before production startup.

Troubleshooting and support maintain system operation. We provide emergency support, remote diagnostics, on-site troubleshooting, spare parts recommendations, and system modifications addressing issues quickly and minimizing production impacts.

System upgrades modernize aging automation. We replace obsolete PLCs, migrate programs to new platforms, add new functionality, and improve system performance extending automation system life and improving capabilities.`,
        features: [
          "PLC programming and system integration",
          "HMI design and implementation",
          "Motion control and VFD integration",
          "Safety-rated automation systems",
          "Industrial networking and communication",
          "Panel design and UL508A fabrication"
        ]
      },
      {
        id: "safety-systems",
        urlSlug: "safety-systems",
        title: "Safety Instrumented Systems (SIS)",
        titleAr: "أنظمة السلامة الآلية",
        shortDesc: "Safety instrumented systems providing independent protection layers for process facilities.",
        mainImage: "/image/sis.jpg",
        images: ["/image/inst-4.jpg", "/image/inst-2.jpg", "/image/inst-5.jpg"],
        fullDescription: `Our Safety Instrumented Systems (SIS) services provide independent protection layers ensuring safe operation of industrial processes, protecting personnel, environment, and assets through automatic safety actions when dangerous conditions are detected.

We design, implement, and maintain safety instrumented systems complying with IEC 61511 (process industry) and IEC 61508 (functional safety) standards ensuring safety systems achieve required safety integrity levels (SIL) for process safety applications.

Safety lifecycle management follows IEC 61511 requirements. We support all safety lifecycle phases including concept, definition, design, implementation, commissioning, operation, maintenance, modification, and decommissioning ensuring safety systems maintain integrity throughout operational life.

Hazard analysis identifies safety requirements. We participate in process hazard analysis (PHA), hazard and operability studies (HAZOP), layers of protection analysis (LOPA), and safety integrity level (SIL) determination establishing safety instrumented function (SIF) requirements and performance targets.

Safety requirement specifications (SRS) document safety functions. We develop comprehensive SRS documents defining safety instrumented functions, safety integrity levels, operation modes, response times, and proof test requirements providing clear specifications for safety system design and implementation.

Safety logic solver selection considers application requirements. We specify safety PLCs, programmable safety systems, relay-based systems, or dedicated safety systems from certified manufacturers including Honeywell, Siemens, Emerson, ABB, and Schneider Electric meeting required SIL ratings.

Safety instrumented function (SIF) design implements protection logic. We design SIF logic including voting configurations (1oo1, 1oo2, 2oo3), partial stroke testing, diagnostic coverage, and spurious trip rate optimization achieving required risk reduction while minimizing nuisance trips.

Safety-rated field devices provide reliable inputs and outputs. We specify SIL-rated pressure transmitters, temperature sensors, level transmitters, flow meters, emergency shutdown valves, solenoid valves, and safety relays with appropriate redundancy and diagnostic capabilities.

Emergency shutdown (ESD) systems protect against major hazards. We design and implement ESD systems for process shutdown, equipment isolation, fire and gas detection response, and emergency depressurization providing rapid, reliable emergency response.

Fire and gas detection systems detect hazardous conditions. We integrate fire detectors, gas detectors, and flame detectors with safety systems implementing appropriate alarm and shutdown logic protecting personnel and facilities from fire and toxic gas release.

Burner management systems (BMS) ensure safe fired equipment operation. We implement BMS for boilers, furnaces, and heaters following NFPA 85/86 requirements automating startup, operation, and shutdown sequences preventing potentially hazardous conditions.

High integrity pressure protection systems (HIPPS) prevent overpressure. We design HIPPS as alternatives to pressure relief valves for pipeline protection, vessel protection, and equipment protection providing fast-acting pressure limitation.

Safety system architecture implements appropriate redundancy. We design 1oo1, 1oo2, 2oo3, and higher order voting configurations, fault-tolerant architectures, and segregated systems achieving required availability, reliability, and spurious trip rate targets.

Diagnostic coverage monitors system health. We implement comprehensive diagnostics detecting dangerous failures, safe failures, and spurious faults. Advanced diagnostics identify degraded conditions enabling proactive maintenance before safety availability is compromised.

Proof testing verifies safety function performance. We develop proof test procedures, conduct proof tests at required intervals, document proof test results, and calculate actual achieved SIL based on field experience maintaining required safety performance.

Bypass management controls safety system overrides. We implement secure bypass procedures, bypass monitoring, time-limited bypasses, and management of change procedures ensuring bypasses are controlled and safety system integrity is maintained.

Functional safety management provides organizational framework. We help establish competency requirements, training programs, verification processes, and documentation systems supporting ongoing safety system management.

Safety system modifications follow management of change. We assess safety impacts of modifications, update safety documentation, reverify safety functions, and maintain SIL ratings when changes are implemented ensuring modifications do not compromise safety.

Documentation deliverables include safety requirement specifications, design documents, cause and effect diagrams, logic diagrams, loop drawings, test procedures, operations procedures, and maintenance procedures providing comprehensive safety system documentation.

Training services prepare operations and maintenance personnel. We provide safety system operations training, proof testing training, and troubleshooting training ensuring personnel understand safety systems and can maintain them properly.`,
        features: [
          "IEC 61511 compliant SIS design",
          "Safety integrity level (SIL) assessment",
          "Emergency shutdown (ESD) systems",
          "Fire and gas detection integration",
          "Burner management systems (BMS)",
          "Proof testing and functional safety management"
        ]
      },
      {
        id: "analyzers-sampling",
        urlSlug: "analyzers-sampling",
        title: "Process Analyzers & Sampling Systems",
        titleAr: "أجهزة التحليل وأنظمة أخذ العينات",
        shortDesc: "Online process analyzers and sample conditioning systems for composition and quality monitoring.",
        mainImage: "/image/pass.jpg",
        images: ["/image/inst-5.jpg", "/image/pass.jpg", "/image/inst-6.jpg"],
        fullDescription: `Our Process Analyzers & Sampling Systems provide online measurement of process stream composition, properties, and quality parameters enabling real-time process monitoring, control optimization, and product quality assurance across petrochemical, refining, chemical manufacturing, and environmental monitoring applications.

We design, install, and maintain complete analyzer systems including analyzer selection, sample conditioning, sample transport, analyzer shelters, calibration systems, and data integration ensuring accurate, reliable analytical measurements in challenging industrial environments.

Gas chromatographs provide detailed compositional analysis. We install process gas chromatographs measuring hydrocarbon composition, natural gas quality, refinery gas analysis, and chemical process streams. Our GC installations include sample conditioning, carrier gas systems, calibration gas systems, and advanced data processing.

Gas analyzers measure specific components. We install infrared gas analyzers, thermal conductivity analyzers, paramagnetic oxygen analyzers, electrochemical gas analyzers, and photometric analyzers for CO, CO2, O2, H2S, NOx, SOx, and other gases supporting process control and emissions monitoring.

Liquid analyzers monitor water and chemical properties. We install pH analyzers, conductivity analyzers, turbidity analyzers, dissolved oxygen analyzers, oxidation-reduction potential (ORP) analyzers, and total organic carbon (TOC) analyzers for water quality monitoring and chemical process control.

Moisture analyzers measure water content. We install moisture analyzers using various measurement principles including capacitance, microwave, infrared, and electrolytic technologies measuring moisture in gases, liquids, and solids protecting processes from water contamination.

Density and viscosity analyzers monitor physical properties. We install Coriolis meters, vibrating element densitometers, ultrasonic densitometers, and online viscometers providing real-time measurement of density, specific gravity, viscosity, and related properties.

Composition analyzers measure properties correlating to composition. We install near-infrared (NIR) analyzers, Raman spectroscopy systems, and nuclear magnetic resonance (NMR) analyzers providing rapid, non-destructive measurement of properties including octane number, API gravity, and product specifications.

Sample conditioning systems prepare samples for analysis. We design and install sample conditioning panels including pressure reduction, temperature control, filtration, phase separation, vaporization, and dilution ensuring samples delivered to analyzers meet analyzer requirements while maintaining sample integrity.

Sample transport systems move samples from process to analyzers. We design fast-loop sampling systems, grab sampling systems, and continuous sampling systems minimizing sample transport time, preventing sample degradation, and maintaining representative samples.

Analyzer shelters house analyzers in appropriate environments. We design and install climate-controlled analyzer shelters, explosion-proof analyzer houses, and purged analyzer enclosures protecting analyzers from harsh environmental conditions and hazardous atmospheres.

Calibration gas systems provide reference gases. We install calibration gas delivery systems including gas cylinders, pressure regulation, flow control, gas blending, and calibration sequencing enabling automated analyzer calibration maintaining analyzer accuracy.

Flame ionization detectors (FID) measure total hydrocarbons. We install FID analyzers for volatile organic compound (VOC) monitoring, total hydrocarbon measurement, and emissions monitoring providing sensitive measurement of organic compounds.

Fourier-transform infrared (FTIR) spectroscopy provides multi-component analysis. We install FTIR analyzers simultaneously measuring multiple gas components supporting emissions monitoring, process optimization, and safety monitoring in chemical and petrochemical applications.

Mass spectrometers provide detailed molecular analysis. We install process mass spectrometers for high-speed, multi-component analysis measuring trace components, reaction monitoring, and advanced process control applications requiring rapid, accurate composition measurement.

Emissions monitoring systems ensure environmental compliance. We install continuous emissions monitoring systems (CEMS) measuring NOx, SO2, CO, CO2, O2, particulate matter, and opacity meeting regulatory requirements and reporting emissions data to authorities.

Analyzer maintenance ensures ongoing accuracy. We provide regular maintenance including sensor replacement, calibration verification, sample system maintenance, and troubleshooting. Predictive maintenance programs monitor analyzer performance identifying issues before failures occur.

Data integration connects analyzers to control systems. We implement communication protocols including Modbus, OPC, 4-20mA analog outputs, and digital protocols integrating analyzer data with DCS, SCADA, and information management systems.

Quality control integration uses analyzer data for product quality management. We integrate analyzers with statistical process control (SPC) systems, quality management systems, and production optimization systems enabling real-time quality assurance and process optimization.

Validation services verify analyzer performance. We conduct initial validation, periodic validation, and revalidation demonstrating analyzer accuracy, precision, linearity, and repeatability meeting quality system requirements for regulated industries.`,
        features: [
          "Process gas chromatography (GC)",
          "Online gas and liquid analyzers",
          "Sample conditioning and transport systems",
          "Analyzer shelters and environmental control",
          "Continuous emissions monitoring (CEMS)",
          "Calibration systems and maintenance services"
        ]
      },
      {
        id: "metering-systems",
        urlSlug: "metering-systems",
        title: "Custody Transfer & Fiscal Metering",
        titleAr: "أنظمة القياس التجاري ونقل الملكية",
        shortDesc: "High-accuracy metering systems for hydrocarbon custody transfer and fiscal measurement.",
        mainImage: "/image/ctfm.jpg",
        images: ["/image/inst-6.jpg", "/image/inst-1.jpg", "/image/inst-4.jpg"],
        fullDescription: `Our Custody Transfer & Fiscal Metering services provide high-accuracy measurement systems for hydrocarbon allocation, billing, and custody transfer meeting stringent regulatory requirements and international standards ensuring fair, accurate measurement for commercial transactions.

We design, install, and maintain complete custody transfer metering systems including flow meters, metering skids, proving systems, flow computers, and data management systems complying with API, ISO, OIML, and local regulatory requirements.

Turbine meters provide accurate liquid hydrocarbon measurement. We install turbine meters for crude oil, refined products, LPG, and natural gas liquids. Our turbine meter installations include strainers, flow conditioners, secondary instrumentation, and proving connections designed following API Chapter 5.3 requirements.

Coriolis meters offer high-accuracy mass measurement. We install Coriolis mass flowmeters providing direct mass measurement, density measurement, and temperature measurement in a single device. Coriolis meters excel in applications requiring highest accuracy, difficult fluids, or mass-based measurement.

Ultrasonic meters provide bidirectional flow measurement. We install multipath ultrasonic flowmeters for liquid and gas measurement offering high accuracy, wide rangeability, no pressure drop, and bidirectional capability. Ultrasonic meters are ideal for large diameter pipelines and high-value products.

Positive displacement meters measure volumetric flow. We install PD meters for viscous liquids, batch measurement, and applications requiring high accuracy at low flow rates. PD meters provide excellent repeatability and accuracy across wide viscosity ranges.

Orifice meters economically measure gas flow. We design and install orifice metering runs following AGA Report No. 3 and ISO 5167 standards. Our installations include orifice plates, orifice flanges or fittings, differential pressure transmitters, and secondary instrumentation for accurate gas measurement.

Prover systems verify meter accuracy. We install pipe provers, compact provers, tank provers, and master meter provers providing traceable meter verification. Proving systems comply with API Chapter 4 requirements enabling field verification of meter performance.

Flow computers calculate corrected flow. We install flow computers performing pressure compensation, temperature compensation, density compensation, and other corrections required for accurate custody transfer measurement. Flow computers store flow data, generate reports, and communicate with SCADA systems.

Sampling systems obtain representative samples. We install automatic sampling systems complying with API Chapter 8 and ISO 3171 standards. Sampling systems include sample probes, sample conditioning, composite samplers, and spot samplers providing samples for laboratory analysis.

Meter proving procedures verify metering accuracy. We conduct meter proving using pipe provers or master meters following API Chapter 4 procedures. Proving results document meter factors, repeatability, and calibration status ensuring meters meet accuracy requirements.

Metering skids integrate all metering components. We design and fabricate metering skids including meters, strainers, block valves, control valves, proving connections, instrumentation, and flow computers. Skids are factory tested, documented, and delivered ready for field installation.

Temperature measurement ensures accurate density correction. We install precision RTDs, thermowells, and temperature transmitters providing accurate temperature measurement required for density compensation and standard volume calculation.

Pressure measurement provides data for pressure correction. We install precision pressure transmitters measuring static pressure, differential pressure, and flowing pressure required for compressibility correction and standard volume calculation.

Density measurement improves measurement accuracy. We install densitometers, density meters, and online density analyzers providing real-time density measurement eliminating assumptions and improving accuracy of volume and mass calculations.

Gas metering systems measure natural gas flow. We install ultrasonic gas meters, turbine gas meters, rotary gas meters, and orifice meters designed following AGA and ISO standards. Gas metering systems include flow computers performing pressure, temperature, and compressibility corrections.

LNG metering addresses cryogenic measurement challenges. We install cryogenic flowmeters, vaporizers, and associated instrumentation for LNG custody transfer. LNG metering systems address unique challenges including boil-off gas, temperature stratification, and low-temperature operation.

Metering data management systems collect and manage flow data. We implement systems aggregating data from multiple meters, performing allocation calculations, generating custody transfer reports, and exporting data to accounting systems ensuring accurate, traceable flow measurement records.

Leak detection systems identify unauthorized product removal. We implement statistical leak detection, material balance calculations, and anomaly detection identifying discrepancies between meter readings indicating theft, leaks, or metering errors.

Regulatory compliance ensures measurement systems meet legal requirements. We design systems meeting requirements of weights and measures authorities, tax authorities, and regulatory agencies ensuring custody transfer measurements are legally defensible.

Uncertainty analysis quantifies measurement accuracy. We perform measurement uncertainty calculations following ISO 5168 and API Chapter 13 procedures quantifying overall measurement uncertainty and demonstrating compliance with accuracy requirements.

Maintenance programs ensure ongoing accuracy. We provide regular maintenance including meter inspection, proving, calibration verification, strainer cleaning, and instrumentation maintenance. Comprehensive maintenance programs ensure metering systems maintain required accuracy throughout operational life.`,
        features: [
          "API and ISO compliant metering systems",
          "Turbine, Coriolis, ultrasonic, and PD meters",
          "Meter proving and verification services",
          "Flow computers and data management",
          "Liquid and gas custody transfer systems",
          "Fiscal metering and regulatory compliance"
        ]
      }
    ]
  },
  telecom: {
    title: "Telecom & Data Networks",
    titleAr: "الاتصالات وشبكات البيانات",
    description: "Communication and data networking solutions",
    icon: "fa-broadcast-tower",
    mainImage: "/image/service-telecom.jpg",
    urlSlug: "telecom",
    subServices: [
  {
    id: "fiber-optic-networks",
    urlSlug: "fiber-optic-networks",
    title: "Fiber Optic Networks & Cabling",
    titleAr: "شبكات الألياف البصرية والكابلات",
    shortDesc: "High-speed fiber optic infrastructure with fusion splicing, testing, and maintenance services.",
    mainImage: "/image/fonc.jpg",
    images: ["/image/telecom-1.jpg", "/image/telecom-2.jpg", "/image/telecom-3.jpg"],
    fullDescription: `Our Fiber Optic Networks & Cabling services deliver cutting-edge optical fiber infrastructure for telecommunications, data centers, enterprise networks, and smart city applications across Saudi Arabia, providing ultra-high-speed connectivity supporting current and future bandwidth demands.

We provide complete fiber optic solutions including network design, fiber cable installation, fusion splicing, termination, testing, and ongoing maintenance. Our expertise covers indoor and outdoor fiber installations, from building backbone systems to long-haul telecommunications networks spanning hundreds of kilometers.

Network design and planning establishes optimal fiber architecture. We conduct site surveys, route planning, capacity analysis, and future-proofing assessments designing fiber networks that meet immediate requirements while accommodating future growth. Our designs consider topology (ring, star, mesh), redundancy requirements, fiber counts, and geographic factors.

Single-mode fiber provides long-distance, high-bandwidth transmission. We install OS2 single-mode fiber supporting transmission distances exceeding 100 kilometers and data rates from 1 Gbps to 400 Gbps and beyond. Single-mode fiber is ideal for campus backbone, metropolitan area networks (MAN), wide area networks (WAN), and telecommunications infrastructure.

Multimode fiber serves shorter distance, high-speed applications. We install OM3, OM4, and OM5 multimode fiber for data center interconnects, building backbones, and campus networks supporting 10 Gbps, 40 Gbps, and 100 Gbps transmission over distances up to 550 meters.

Outdoor fiber installation uses various deployment methods. We install aerial fiber on existing utility poles, underground fiber in HDPE conduits, direct burial fiber cable, and submarine fiber cables. Each installation method is selected based on terrain, existing infrastructure, environmental conditions, and project requirements.

Indoor fiber installations connect telecommunications rooms and equipment. We install indoor-outdoor (OSP) fiber cables, plenum-rated fiber cables, riser-rated fiber cables, and armored fiber cables following TIA-568 and building code requirements ensuring compliant, safe installations.

Fiber cable types are selected for specific applications. We install loose-tube fiber cables for outdoor applications, tight-buffered fiber cables for indoor use, ribbon fiber cables for high-density installations, and armored fiber cables for harsh environments or rodent protection.

Fusion splicing joins fiber cables with minimal loss. Our certified fiber optic technicians use precision fusion splicers achieving splice losses below 0.05 dB. We maintain comprehensive splice documentation including splice location, splice loss measurements, fiber identification, and OTDR traces for each splice point.

Mechanical splicing provides temporary or permanent fiber connections. We install mechanical splices for restoration, temporary connections, or applications where fusion splicing is impractical. Mechanical splices offer quick installation with typical losses of 0.2-0.5 dB.

Fiber termination includes various connector types. We install LC, SC, ST, FC, and MTP/MPO connectors using factory termination, field termination, or pre-terminated assemblies depending on project requirements. All terminations are tested and documented ensuring optimal performance.

Fiber distribution frames (FDF) organize fiber connections. We install wall-mounted and rack-mounted fiber distribution panels, splice enclosures, and patch panels providing organized fiber management, easy access for maintenance, and clear fiber identification.

High-density fiber systems maximize space utilization. We design and install MTP/MPO trunk systems, breakout modules, and high-density patch panels supporting 144-fiber, 288-fiber, and higher density installations in space-constrained data center and telecommunications room applications.

Fiber testing and certification verifies installation quality. We conduct comprehensive testing using Optical Time Domain Reflectometers (OTDR), optical power meters, light sources, and visual fault locators. Testing includes insertion loss, return loss, length measurement, and fiber characterization documenting compliance with TIA and ISO standards.

OTDR testing provides detailed fiber characterization. We perform bidirectional OTDR testing measuring fiber attenuation, splice losses, connector losses, and identifying fiber anomalies. OTDR traces document fiber quality and serve as baseline documentation for future troubleshooting.

Fiber network documentation includes as-built drawings, fiber route maps, splice documentation, test reports, and cable records. Comprehensive documentation facilitates maintenance, troubleshooting, and future network expansions.

Fiber optic network monitoring detects issues proactively. We install optical monitoring systems continuously monitoring fiber links, detecting fiber cuts, degradation, and security breaches enabling rapid response to network issues.

Wavelength division multiplexing (WDM) increases fiber capacity. We implement coarse wavelength division multiplexing (CWDM) and dense wavelength division multiplexing (DWDM) systems multiplying fiber capacity by transmitting multiple wavelengths over single fiber pairs.

Optical amplifiers extend transmission distances. We install erbium-doped fiber amplifiers (EDFA) and Raman amplifiers boosting optical signals enabling long-distance transmission without electrical regeneration maintaining signal quality over extended distances.

Fiber to the home (FTTH) delivers fiber connectivity to residences. We design and install passive optical networks (PON) including GPON and XG-PON systems providing high-speed internet, television, and voice services to residential customers.

Fiber troubleshooting and repair restores network connectivity. We provide 24/7 emergency response, fiber fault location, repair splicing, and restoration services minimizing downtime and restoring critical communications quickly.

Maintenance programs ensure ongoing fiber network performance. We provide regular testing, cleaning, inspection, and preventive maintenance identifying potential issues before failures occur and maintaining optimal network performance.`,
    features: [
      "Single-mode and multimode fiber installation",
      "Fusion splicing and precision termination",
      "OTDR testing and full certification",
      "Underground, aerial, and indoor deployment",
      "High-density MTP/MPO trunk systems",
      "24/7 fiber repair and maintenance"
    ]
  },
  {
    id: "wireless-systems",
    urlSlug: "wireless-systems",
    title: "Wireless Communication Systems",
    titleAr: "أنظمة الاتصالات اللاسلكية",
    shortDesc: "Enterprise wireless networks, point-to-point links, and mobile communication infrastructure.",
    mainImage: "/image/wcs.jpg",
    images: ["/image/telecom-2.jpg", "/image/telecom-4.jpg", "/image/telecom-5.jpg"],
    fullDescription: `Our Wireless Communication Systems provide comprehensive wireless connectivity solutions including enterprise Wi-Fi networks, point-to-point microwave links, distributed antenna systems (DAS), and mobile communication infrastructure delivering reliable wireless communications for industrial facilities, commercial buildings, campuses, and remote sites.

We design, install, and optimize wireless networks using professional RF planning tools, site surveys, and industry best practices ensuring optimal coverage, capacity, and performance for diverse wireless communication requirements.

Enterprise Wi-Fi systems provide seamless wireless connectivity. We deploy enterprise-grade wireless networks using equipment from leading manufacturers including Cisco, Aruba, Ruckus, and Ubiquiti. Our Wi-Fi deployments support Wi-Fi 6 (802.11ax) and Wi-Fi 6E standards delivering multi-gigabit wireless speeds, high user density support, and enhanced security.

RF site surveys establish optimal access point placement. We conduct predictive site surveys using professional RF planning software and validation site surveys with spectrum analyzers and survey tools. Site surveys identify optimal AP locations, channel allocations, transmit power settings, and potential interference sources ensuring reliable coverage.

Wireless network architecture includes controllers, access points, and management systems. We implement centralized wireless architectures with hardware controllers, cloud-managed solutions, and controller-less architectures depending on scale, management requirements, and deployment scenarios.

Indoor wireless coverage serves buildings and facilities. We install ceiling-mounted access points, wall-mounted APs, and desktop APs providing comprehensive coverage for offices, warehouses, manufacturing facilities, hospitals, schools, and public venues.

Outdoor wireless networks extend connectivity beyond buildings. We install weatherproof outdoor access points, directional antennas, and sector antennas providing wireless coverage for outdoor areas including parking lots, campuses, industrial yards, ports, and public spaces.

Point-to-point wireless links connect remote locations. We install microwave links, millimeter-wave links, and free-space optics (FSO) providing high-capacity wireless backhaul for distances from several hundred meters to over 50 kilometers. Wireless links eliminate need for fiber or leased lines connecting remote sites economically.

Point-to-multipoint wireless systems serve multiple remote sites. We deploy PMP systems connecting multiple remote locations to central sites using hub-and-spoke topologies. PMP solutions economically extend connectivity to dispersed locations including remote monitoring sites, cameras, and field equipment.

Licensed microwave links provide interference-free connectivity. We design and license microwave links operating in licensed frequency bands ensuring protected, reliable communication free from interference. Licensed links are ideal for critical communications requiring guaranteed availability.

Unlicensed wireless links utilize license-free spectrum. We install unlicensed links operating in 2.4 GHz, 5 GHz, and 60 GHz bands providing cost-effective wireless connectivity where licensed spectrum is unavailable or unnecessary. Proper frequency planning and interference mitigation ensure reliable unlicensed link operation.

Distributed antenna systems (DAS) enhance in-building mobile coverage. We design and install DAS systems distributing cellular signals throughout buildings improving mobile phone coverage, capacity, and data speeds. DAS solutions serve large buildings, tunnels, stadiums, and areas with poor outdoor signal penetration.

Wireless mesh networks provide flexible, self-healing connectivity. We deploy mesh networks for industrial automation, municipal networks, and temporary installations. Mesh networks automatically route traffic through multiple paths maintaining connectivity despite individual node failures.

Industrial wireless networks support automation applications. We install industrial-grade wireless equipment supporting process automation, asset tracking, remote monitoring, and mobile workforce applications. Industrial wireless solutions address harsh environments, electromagnetic interference, and reliability requirements.

Wireless security protects networks from unauthorized access. We implement WPA3 encryption, 802.1X authentication, wireless intrusion detection systems (WIDS), and network access control (NAC) securing wireless networks from attacks and unauthorized users.

Guest wireless networks provide visitor access. We implement secure guest networks with captive portals, bandwidth management, and isolation from corporate networks. Guest networks support bring-your-own-device (BYOD) initiatives and visitor connectivity without compromising network security.

Wireless site preparation includes power, mounting, and cabling. We install power over Ethernet (PoE) switches, midspan injectors, outdoor enclosures, antenna mounts, tower installations, and lightning protection ensuring proper wireless infrastructure installation.

RF spectrum analysis identifies interference sources. We use spectrum analyzers identifying non-Wi-Fi interference from microwave ovens, Bluetooth devices, wireless cameras, and other sources. Interference mitigation strategies optimize wireless performance in challenging RF environments.

Wireless network optimization fine-tunes performance. We adjust channel assignments, transmit power levels, roaming thresholds, and quality-of-service (QoS) parameters optimizing network performance for specific applications and user requirements.

Wireless location services enable asset tracking. We implement Wi-Fi-based location services, RFID systems, and Bluetooth Low Energy (BLE) beacons providing real-time location tracking for assets, equipment, and personnel supporting logistics and security applications.

Testing and commissioning validates wireless coverage and performance. We conduct coverage testing, throughput testing, roaming testing, and application testing documenting network performance and ensuring wireless systems meet design requirements.

Ongoing monitoring and management maintains network performance. We implement wireless network management systems providing real-time monitoring, performance analytics, user tracking, and automated alerts enabling proactive network management.`,
    features: [
      "Enterprise Wi-Fi 6/6E deployment",
      "Point-to-point and point-to-multipoint links",
      "Distributed antenna systems (DAS)",
      "RF site surveys and optimization",
      "Industrial wireless networks",
      "Wireless security and access control"
    ]
  },
  {
    id: "tower-infrastructure",
    urlSlug: "tower-infrastructure",
    title: "Telecom Towers & Infrastructure",
    titleAr: "أبراج الاتصالات والبنية التحتية",
    shortDesc: "Communication tower design, construction, and infrastructure for wireless networks.",
    mainImage: "/image/tti.jpg",
    images: ["/image/telecom-3.jpg", "/image/telecom-1.jpg", "/image/telecom-6.jpg"],
    fullDescription: `Our Telecom Towers & Infrastructure services provide comprehensive solutions for wireless communication infrastructure including tower design, fabrication, installation, and site development supporting mobile networks, broadcasting, microwave communications, and wireless broadband services across Saudi Arabia.

We deliver turnkey tower projects including site acquisition, regulatory approvals, civil works, tower supply and installation, antenna mounting systems, power systems, and shelter installations creating complete base station facilities for telecommunications operators and infrastructure providers.

Tower design and engineering ensures structural integrity. We design self-supporting towers, guyed towers, monopoles, and rooftop structures using professional structural analysis software. Designs comply with TIA-222 standards, local building codes, and seismic requirements ensuring towers safely support specified antenna loads and wind conditions.

Self-supporting towers provide stable antenna platforms. We install lattice towers in three-legged (triangular) and four-legged (square) configurations supporting heights from 20 meters to 80 meters. Self-supporting towers suit sites with adequate space and require no guy wires offering excellent structural stability.

Guyed towers achieve maximum heights economically. We install guyed towers reaching heights exceeding 100 meters using guy wires anchored to the ground. Guyed towers offer economical solutions for tall structures requiring large coverage areas while minimizing foundation costs.

Monopoles provide aesthetic tower solutions. We install tubular steel monopoles and tapered monopoles suitable for urban environments, rooftops, and locations where aesthetics are important. Monopoles occupy minimal ground space and present clean, professional appearance.

Rooftop towers extend coverage from existing buildings. We design and install rooftop monopoles, tripods, and frame structures supporting antennas on building rooftops. Rooftop installations require careful structural analysis ensuring buildings can support additional tower loads.

Tower foundations support tower structures. We design and construct reinforced concrete foundations including pier foundations, raft foundations, and spread footings. Foundation designs consider soil conditions, tower loads, seismic forces, and uplift forces ensuring stable tower support.

Guy anchor foundations support guyed tower systems. We install concrete anchor foundations or helical anchor systems resisting guy wire tension forces. Proper anchor design and installation ensures guyed tower stability under wind loading and operational conditions.

Tower fabrication produces quality structures. We fabricate towers from hot-dipped galvanized steel providing corrosion protection for long-term durability. Fabrication follows industry standards ensuring bolted connections, member sizing, and weld quality meet engineering specifications.

Tower installation includes lifting and assembly. We use cranes, gin poles, and lifting equipment safely erecting towers. Installation crews follow comprehensive safety procedures including fall protection, rigging inspections, and lift plans ensuring safe tower construction.

Antenna mounting systems support communication equipment. We install antenna mounts, pipe mounts, sector frames, and equipment platforms providing secure mounting for antennas, radios, microwave dishes, and auxiliary equipment. Mounting systems accommodate multiple operators (collocation) and future equipment additions.

Tower climbing safety systems protect workers. We install climbing ladders, rest platforms, safety climb systems, and fall arrest systems ensuring worker safety during installation and maintenance activities. Safety systems comply with OSHA and local safety regulations.

Grounding and lightning protection prevents equipment damage. We install comprehensive grounding systems including ground rods, ground rings, grounding conductors, and lightning arresters protecting towers, antennas, and electronics from lightning strikes and electrical faults.

Tower lighting ensures aviation safety. We install FAA/ICAO-compliant obstruction lighting including red beacon lights, medium-intensity white strobe lights, and lighting controllers. Tower lighting marks structures for aircraft safety complying with aviation authority requirements.

Microwave antenna installations provide backhaul connectivity. We install microwave dishes, waveguide, transmission lines, and microwave radios providing wireless backhaul connecting cell sites to core networks. Microwave link installations include precise antenna alignment achieving optimal link performance.

Shelter and equipment room construction houses telecommunications equipment. We install prefabricated shelters, containerized solutions, and equipment rooms providing climate-controlled environments protecting sensitive telecommunications equipment. Shelters include HVAC systems, power distribution, cable management, and security features.

Power systems ensure reliable telecommunications operation. We install AC power distribution, DC power plants, battery backup systems, and generators providing uninterruptible power for critical telecommunications equipment. Power systems include monitoring, load management, and remote control capabilities.

Cable management organizes tower and shelter cabling. We install cable trays, cable ladders, coaxial cables, fiber optic cables, and power cables connecting antennas to equipment. Proper cable management prevents damage, facilitates maintenance, and maintains system reliability.

Site preparation includes access roads, fencing, and drainage. We perform site grading, construct access roads, install perimeter fencing, and implement drainage systems creating secure, accessible tower sites protecting infrastructure and ensuring operational access.

Regulatory compliance obtains necessary approvals. We manage permit applications, environmental assessments, frequency coordination, aviation approvals, and local authority permits ensuring tower projects comply with all regulatory requirements.

Testing and commissioning validates tower installations. We conduct tower plumbness checks, structural inspections, grounding resistance tests, and climbing system tests documenting proper installation and code compliance.

Maintenance services ensure ongoing tower safety and performance. We provide tower inspections, structural assessments, painting, corrosion repair, guy wire tensioning, and bolt torque verification maintaining tower structural integrity throughout operational life.`,
    features: [
      "Self-supporting, guyed, and monopole towers",
      "Foundation design and construction",
      "Antenna mounting systems and platforms",
      "Lightning protection and grounding",
      "Shelter and power system installation",
      "FAA/ICAO aviation lighting compliance"
    ]
  }
]
  },
  qhse: {
    title: "QHSE Compliance",
    titleAr: "الجودة والصحة والسلامة والبيئة",
    description: "Quality, health, safety, and environmental management",
    icon: "fa-shield-alt",
    mainImage: "/image/service-qhse.jpg",
    urlSlug: "qhse",
    subServices: [
  {
    id: "iso-certifications",
    urlSlug: "iso-certifications",
    title: "ISO Certifications & Quality Management",
    titleAr: "شهادات الأيزو وإدارة الجودة",
    shortDesc: "ISO 9001, 14001, 45001 implementation and certification management for quality, environment, and safety.",
    mainImage: "/image/icqm.jpg",
    images: ["/image/qhse-1.jpg", "/image/qhse-2.jpg", "/image/qhse-3.jpg"],
    fullDescription: `Our ISO Certifications & Quality Management services provide comprehensive support for implementing, maintaining, and improving management systems complying with international ISO standards ensuring organizational excellence in quality, environmental management, and occupational health and safety.

We guide organizations through the complete certification lifecycle including gap analysis, system design, documentation development, implementation support, internal audits, management review, and certification audit preparation achieving and maintaining ISO certifications recognized globally.

ISO 9001 Quality Management System establishes quality excellence. We implement ISO 9001:2015 requirements including quality policy, quality objectives, process approach, risk-based thinking, documented information, and continual improvement. Our implementations create effective quality management systems ensuring consistent product and service quality meeting customer requirements and regulatory obligations.

Gap analysis identifies improvement opportunities. We conduct comprehensive assessments comparing current practices against ISO requirements identifying gaps, non-conformances, and improvement areas. Gap analysis establishes implementation roadmaps prioritizing actions and allocating resources effectively.

Quality Management System (QMS) design creates structured approaches. We design quality management systems defining organizational context, interested parties, scope, processes, process interactions, and system boundaries. QMS design establishes frameworks supporting quality objectives and organizational strategy.

Documentation development creates required records. We develop quality manuals, procedures, work instructions, forms, and records satisfying ISO documentation requirements. Documentation clearly communicates processes, responsibilities, authorities, and requirements enabling consistent implementation throughout organizations.

Process mapping establishes process understanding. We facilitate process identification, process mapping, process interaction analysis, and process performance measurement. Process mapping creates visual representations clarifying inputs, outputs, controls, resources, and interrelationships supporting process management and improvement.

Quality policy and objectives establish direction. We develop quality policies expressing organizational commitment to quality and customer satisfaction. Quality objectives translate policy into measurable targets establishing accountability and driving performance improvement.

Risk-based thinking identifies and manages threats and opportunities. We facilitate risk identification, risk analysis, risk evaluation, and risk treatment planning. Risk-based thinking ensures organizations proactively address factors affecting objectives rather than reacting to problems after occurrence.

Internal audit programs verify system effectiveness. We establish internal audit programs, train internal auditors, conduct internal audits, report audit findings, and verify corrective actions. Internal audits provide objective evidence of system conformance and effectiveness identifying improvement opportunities.

Management review ensures system suitability. We facilitate management review meetings examining quality management system performance, audit results, customer feedback, process performance, and improvement opportunities. Management reviews ensure top management engagement and strategic alignment.

Corrective action processes address non-conformances. We implement corrective action procedures investigating root causes, developing corrective actions, implementing solutions, and verifying effectiveness. Effective corrective action prevents recurrence improving system performance.

Continual improvement drives excellence. We implement improvement methodologies including Plan-Do-Check-Act (PDCA) cycles, kaizen events, Six Sigma projects, and lean initiatives. Continual improvement cultures pursue ever-better performance meeting evolving customer needs and competitive pressures.

ISO 14001 Environmental Management System manages environmental impacts. We implement ISO 14001:2015 establishing environmental policies, identifying environmental aspects, managing environmental impacts, ensuring regulatory compliance, and pursuing environmental performance improvement protecting the environment while supporting business objectives.

Environmental aspects and impacts assessment identifies significant environmental considerations. We facilitate environmental aspects identification, impact evaluation, significance determination, and operational control establishment. Understanding environmental aspects enables organizations to focus resources on most significant environmental impacts.

Environmental objectives and programs drive improvement. We establish environmental objectives, develop environmental programs, allocate resources, assign responsibilities, and track progress. Environmental objectives address significant aspects pursuing measurable environmental performance enhancement.

Operational controls manage environmental impacts. We develop operational controls, emergency preparedness procedures, and monitoring processes ensuring activities with significant environmental aspects are conducted under controlled conditions preventing environmental harm.

ISO 45001 Occupational Health and Safety Management System protects workers. We implement ISO 45001:2018 establishing OH&S policies, identifying hazards and risks, implementing controls, ensuring legal compliance, and promoting worker participation creating safe, healthy work environments.

Hazard identification and risk assessment establishes safety foundations. We facilitate hazard identification using job hazard analysis, safety observations, incident investigation, and worker consultation. Risk assessment evaluates likelihood and severity establishing risk priorities guiding control implementation.

Hierarchy of controls establishes safety measures. We apply elimination, substitution, engineering controls, administrative controls, and personal protective equipment following hierarchy of controls principles. Prioritizing higher-level controls achieves more effective, sustainable risk reduction.

OH&S objectives and programs improve safety performance. We establish safety objectives, develop safety programs, assign responsibilities, provide resources, and monitor progress. Safety objectives drive measurable improvements in injury rates, near-miss reporting, and safety culture.

Worker participation ensures engagement. We establish consultation processes, safety committees, and communication channels enabling worker participation in hazard identification, risk assessment, incident investigation, and system improvement. Worker involvement increases safety ownership and effectiveness.

Integrated management systems combine multiple standards. We implement integrated systems addressing quality, environmental, and safety requirements simultaneously. Integration eliminates duplication, improves efficiency, and creates holistic management approaches addressing interrelated organizational aspects.

Certification audit preparation ensures readiness. We conduct pre-assessment audits, address non-conformances, verify documentation completeness, train personnel, and prepare facilities for certification audits. Thorough preparation maximizes certification success.

Certification body coordination manages audit process. We coordinate with certification bodies, schedule audits, facilitate auditor access, respond to audit findings, and obtain certifications. Effective coordination ensures smooth certification processes.

Surveillance and recertification maintains certificates. We support ongoing compliance through surveillance audits, system maintenance, continual improvement, and recertification activities. Maintaining certifications demonstrates sustained commitment to management system excellence.

Training and awareness builds competency. We provide management system training including awareness training, internal auditor training, process owner training, and specialized training. Training ensures personnel understand requirements and their roles supporting effective system implementation.

Performance measurement tracks improvement. We implement key performance indicators (KPIs), metrics, dashboards, and reporting systems measuring quality, environmental, and safety performance. Data-driven management enables informed decisions and continuous improvement.`,
    features: [
      "ISO 9001 Quality Management Systems",
      "ISO 14001 Environmental Management",
      "ISO 45001 Occupational Health & Safety",
      "Gap analysis and implementation support",
      "Internal audit programs and training",
      "Integrated management system development"
    ]
  },
  {
    id: "hse-management",
    urlSlug: "hse-management",
    title: "HSE Management & Safety Programs",
    titleAr: "إدارة الصحة والسلامة والبيئة",
    shortDesc: "Comprehensive health, safety, and environmental management programs and safety culture development.",
    mainImage: "/image/hmsp.jpg",
    images: ["/image/qhse-2.jpg", "/image/qhse-4.jpg", "/image/qhse-5.jpg"],
    fullDescription: `Our HSE Management & Safety Programs provide comprehensive health, safety, and environmental management solutions creating safe workplaces, protecting the environment, ensuring regulatory compliance, and building strong safety cultures across industrial, construction, and commercial operations.

We develop and implement customized HSE programs addressing organizational risks, regulatory requirements, and industry best practices creating systematic approaches to managing health, safety, and environmental performance throughout organizations and project lifecycles.

HSE policy establishes organizational commitment. We develop HSE policies expressing leadership commitment to protecting workers, communities, and the environment. Policies establish principles, responsibilities, and expectations guiding HSE programs and creating foundations for safety culture development.

HSE management systems structure systematic approaches. We design HSE management systems incorporating policy, planning, implementation, monitoring, review, and improvement. Systematic approaches ensure consistent HSE management across organizations replacing ad-hoc practices with structured processes.

Hazard identification programs detect workplace dangers. We implement hazard identification processes including workplace inspections, job hazard analysis, pre-task planning, and change management. Proactive hazard identification enables prevention rather than reaction reducing injuries and incidents.

Risk assessment prioritizes control efforts. We conduct qualitative and quantitative risk assessments evaluating likelihood and consequence of identified hazards. Risk matrices, risk registers, and risk treatment plans focus resources on highest-priority risks achieving maximum risk reduction.

Job safety analysis (JSA) breaks down task hazards. We facilitate JSA development analyzing job steps, identifying hazards, and establishing controls. JSAs guide safe work execution communicating hazards and controls to workers performing tasks.

Safe work procedures standardize safe practices. We develop safe work procedures, standard operating procedures (SOPs), and safe work method statements documenting approved methods for performing hazardous work. Procedures ensure consistent application of controls reducing variability and risk.

Permit-to-work systems control high-risk activities. We implement permit systems for hot work, confined space entry, working at height, excavation, electrical work, and other high-hazard activities. Permits ensure proper planning, authorization, communication, and control before hazardous work begins.

Personal protective equipment (PPE) programs provide last line of defense. We establish PPE requirements, conduct hazard assessments, specify appropriate PPE, train workers, and monitor compliance. While PPE is lowest hierarchy of control level, proper programs ensure effective use when higher-level controls are insufficient.

Safety training develops competency. We deliver safety training including safety orientation, task-specific training, supervisor safety training, and specialized training for high-risk activities. Training ensures workers understand hazards, controls, and safe work practices before performing tasks.

Behavior-based safety (BBS) improves at-risk behaviors. We implement BBS programs using observations, feedback, and positive reinforcement changing unsafe behaviors. BBS addresses human factors complementing engineering controls creating comprehensive safety approaches.

Safety leadership development engages management. We provide leadership training emphasizing visible commitment, safety communication, hazard recognition, incident investigation, and creating just cultures. Leadership engagement transforms safety from compliance programs to core organizational values.

Contractor safety management extends safety to contractors. We implement contractor prequalification, contractor orientation, contractor supervision, and contractor performance monitoring ensuring contractors work safely meeting same standards as direct employees.

Emergency response planning prepares for incidents. We develop emergency response plans addressing fires, chemical releases, medical emergencies, natural disasters, and security incidents. Plans define roles, responsibilities, response procedures, communication protocols, and recovery actions.

Emergency drills and exercises test readiness. We conduct evacuation drills, tabletop exercises, and full-scale emergency simulations testing plans, training responders, and identifying improvement opportunities. Regular exercises ensure organizations can effectively respond when real emergencies occur.

Incident investigation identifies root causes. We conduct incident investigations using systematic methodologies including root cause analysis, 5-Why analysis, fishbone diagrams, and timeline analysis. Thorough investigations identify causal factors enabling effective corrective actions preventing recurrence.

Safety metrics measure performance. We implement leading indicators (safety observations, near-miss reports, training completion) and lagging indicators (injury rates, lost-time incidents, severity rates) tracking safety performance. Metrics enable data-driven safety management and demonstrate improvement.

Safety audits verify program effectiveness. We conduct safety audits assessing regulatory compliance, program implementation, hazard controls, and management system effectiveness. Audits identify strengths, weaknesses, and improvement opportunities maintaining program integrity.

Occupational health programs protect worker health. We implement health surveillance, exposure monitoring, ergonomics programs, and industrial hygiene assessments addressing occupational health hazards including noise, chemicals, ergonomic stressors, and biological agents.

Environmental compliance ensures regulatory adherence. We establish environmental compliance programs addressing air emissions, water discharges, waste management, hazardous materials, and environmental permits. Compliance programs prevent violations, fines, and environmental harm.

Waste management programs handle waste properly. We develop waste management plans addressing waste minimization, segregation, storage, transportation, and disposal. Proper waste management protects the environment and ensures regulatory compliance.

Environmental monitoring tracks impacts. We implement environmental monitoring programs measuring air quality, water quality, noise levels, and other environmental parameters. Monitoring verifies control effectiveness and detects emerging issues before significant impacts occur.

Sustainability programs improve environmental performance. We develop sustainability initiatives addressing energy efficiency, water conservation, waste reduction, and carbon footprint reduction. Sustainability programs demonstrate environmental stewardship while often reducing operating costs.

Safety culture assessment evaluates organizational safety. We conduct safety culture surveys, focus groups, and interviews assessing attitudes, beliefs, behaviors, and systems. Culture assessments identify cultural strengths and weaknesses guiding culture improvement initiatives.

Safety culture development transforms organizations. We facilitate culture change initiatives including leadership development, communication enhancement, recognition programs, and employee engagement creating cultures where safety is genuinely valued and embedded in daily operations.`,
    features: [
      "HSE management system development",
      "Hazard identification and risk assessment",
      "Safe work procedures and permit systems",
      "Safety training and competency programs",
      "Incident investigation and root cause analysis",
      "Safety culture assessment and development"
    ]
  },
  {
    id: "compliance-auditing",
    urlSlug: "compliance-auditing",
    title: "Compliance Auditing & Regulatory Support",
    titleAr: "التدقيق على الامتثال والدعم التنظيمي",
    shortDesc: "Regulatory compliance audits, permit management, and government authority coordination.",
    mainImage: "/image/cars.jpg",
    images: ["/image/qhse-3.jpg", "/image/qhse-1.jpg", "/image/qhse-6.jpg"],
    fullDescription: `Our Compliance Auditing & Regulatory Support services provide comprehensive regulatory compliance management ensuring organizations meet legal requirements, maintain necessary permits and licenses, and effectively interact with regulatory authorities minimizing compliance risks and avoiding violations, fines, and legal liabilities.

We support organizations navigating complex regulatory landscapes across multiple jurisdictions and regulatory domains including environmental regulations, occupational safety regulations, building codes, labor laws, and industry-specific requirements throughout Saudi Arabia and internationally.

Regulatory compliance assessment identifies obligations. We conduct comprehensive compliance assessments inventorying applicable regulations, identifying specific requirements, evaluating current compliance status, and prioritizing compliance gaps. Assessments establish clear understanding of regulatory obligations guiding compliance program development.

Compliance programs establish systematic adherence. We design compliance management programs incorporating requirement identification, responsibility assignment, compliance monitoring, record keeping, and management review. Systematic programs ensure ongoing compliance rather than reactive responses to violations or inspections.

Legal register development tracks requirements. We establish and maintain legal registers cataloging applicable laws, regulations, permits, and licenses. Legal registers include requirement summaries, compliance evidence, responsible parties, and review frequencies ensuring organizations track and meet all obligations.

Saudi Arabian regulatory compliance addresses local requirements. We support compliance with Saudi Building Code (SBC), Civil Defense requirements, Ministry of Environment, Water and Agriculture (MEWA) regulations, Ministry of Human Resources and Social Development (MHRSD) labor regulations, and local municipality requirements ensuring comprehensive compliance across all regulatory domains.

Environmental permit management obtains and maintains authorizations. We support environmental permit applications, renewals, modifications, and compliance reporting for air quality permits, water discharge permits, waste management licenses, and hazardous materials permits. Permit management ensures organizations maintain authorization for environmental discharges and waste handling.

Occupational safety compliance ensures worker protection. We support compliance with occupational safety and health regulations including hazard communication, lockout/tagout, confined spaces, fall protection, personal protective equipment, and recordkeeping requirements. Safety compliance protects workers while avoiding citations and penalties.

Civil Defense approvals ensure fire and life safety compliance. We support Civil Defense plan review, inspections, approvals, and ongoing compliance for building occupancy, fire protection systems, emergency exits, and life safety systems. Civil Defense compliance enables building occupancy and protects occupants.

Building code compliance ensures structural safety. We support compliance with Saudi Building Code addressing structural requirements, fire protection, means of egress, accessibility, plumbing, mechanical, electrical, and energy efficiency requirements. Building code compliance ensures safe, code-compliant construction and occupancy.

Labor law compliance protects workers' rights. We support compliance with labor regulations addressing employment contracts, working hours, wages, leaves, termination procedures, workplace discrimination, and worker accommodation requirements. Labor compliance protects organizations from labor disputes and penalties.

Compliance audits verify regulatory adherence. We conduct internal compliance audits using regulatory checklists, site inspections, document reviews, and interviews identifying non-compliances and improvement opportunities. Regular audits maintain compliance between regulatory inspections.

Regulatory inspections preparation ensures readiness. We prepare organizations for regulatory inspections including pre-inspection audits, corrective action implementation, document preparation, and personnel training. Preparation minimizes inspection findings and demonstrates compliance commitment.

Regulatory inspection support coordinates with authorities. We accompany inspectors, respond to inquiries, provide documentation, and clarify findings during regulatory inspections. Professional inspection coordination maintains positive regulatory relationships while protecting organizational interests.

Violation response addresses citations. We support responses to violations, notices of violation, and citations including investigating causes, developing corrective actions, preparing written responses, and negotiating with authorities. Effective violation response resolves issues while minimizing penalties.

Compliance reporting meets submission requirements. We prepare and submit regulatory reports including environmental reports, safety statistics, incident notifications, and permit compliance reports. Timely, accurate reporting meets regulatory obligations and maintains good standing with authorities.

Permit applications obtain necessary authorizations. We prepare permit applications including engineering calculations, drawings, operational descriptions, environmental impact assessments, and supporting documentation. Complete, professional applications expedite approval processes.

Authority coordination maintains relationships. We coordinate with regulatory authorities, attend meetings, clarify requirements, request guidance, and maintain ongoing communication. Positive regulatory relationships facilitate compliance and provide access to regulatory expertise.

Regulatory training educates personnel. We provide training on regulatory requirements, compliance procedures, permit conditions, and reporting obligations. Training ensures personnel understand requirements and their responsibilities supporting sustained compliance.

Change management addresses new requirements. We monitor regulatory changes, assess impacts, update compliance programs, implement necessary changes, and communicate updates. Proactive change management ensures organizations maintain compliance as regulations evolve.

International standards compliance supports global operations. We support compliance with international standards including IEC, IEEE, API, NFPA, ASHRAE, and ASTM standards often referenced in contracts and specifications. International standards compliance demonstrates technical competence and quality commitment.

Industry-specific regulations address sector requirements. We support compliance with industry-specific regulations including petroleum regulations, food safety requirements, pharmaceutical regulations, medical device requirements, and telecommunications regulations. Sector-specific expertise ensures compliance with specialized requirements.

Documentation management maintains compliance records. We establish documentation systems organizing permits, licenses, inspection reports, test results, training records, and compliance reports. Proper documentation demonstrates compliance during audits and inspections while supporting compliance management.

Compliance dashboard and reporting provides visibility. We implement compliance dashboards tracking permit expiration dates, inspection schedules, training due dates, and compliance status. Dashboards provide management visibility enabling proactive compliance management.

Regulatory intelligence monitors changes. We monitor regulatory developments, proposed regulations, enforcement trends, and regulatory guidance keeping organizations informed of changes affecting operations. Early awareness enables proactive adaptation rather than reactive compliance.

Gap remediation addresses deficiencies. We develop corrective action plans, implement improvements, modify procedures, provide training, and verify effectiveness addressing compliance gaps identified through assessments, audits, or inspections. Systematic remediation achieves and maintains full compliance.

Third-party certification coordination manages external audits. We coordinate with certification bodies, notified bodies, and approved inspectors facilitating equipment certifications, system certifications, and product approvals required for market access and regulatory compliance.`,
    features: [
      "Regulatory compliance assessments",
      "Environmental permit management",
      "Civil Defense and building code compliance",
      "Compliance audits and inspections",
      "Violation response and corrective actions",
      "Saudi Arabian regulatory support"
    ]
  }
]
  },
  ict: {
  title: "Information & Communication Technology",
  titleAr: "تكنولوجيا المعلومات والاتصالات",
  description: "Complete ICT solutions covering communication systems, networking, wireless, structured cabling, fiber optics, and advanced data-center technologies",
  icon: "fa-network-wired",
  mainImage: "/image/info.jpg",
  urlSlug: "ict",
  subServices: [
    {
      id: "structured-cabling",
      urlSlug: "structured-cabling",
      title: "Structured Cabling Systems",
      titleAr: "أنظمة الكابلات المنظمة",
      shortDesc: "Complete structured cabling infrastructure with Cat6/Cat6A/Cat7 and fiber optic solutions.",
      mainImage: "/image/scs.jpg",
      images: ["/image/ict-1.jpg", "/image/ict-2.jpg", "/image/ict-3.jpg"],
      fullDescription: `Our Structured Cabling Systems provide comprehensive network infrastructure solutions that form the backbone of modern communication systems for commercial buildings, data centers, industrial facilities, and enterprise campuses.

We design and install complete structured cabling systems that support voice, data, video, and building management systems over a unified infrastructure. Our solutions comply with international standards including TIA/EIA-568, ISO/IEC 11801, and EN 50173, ensuring optimal performance and future-proofing your network investment.

Our structured cabling solutions encompass horizontal cabling (work area to telecommunications room), backbone cabling (between telecommunications rooms and equipment rooms), and campus backbone cabling (between buildings). We utilize premium-grade copper cabling including Cat6, Cat6A, and Cat7 cables that support current and future network speeds from 1 Gigabit to 10 Gigabit and beyond.

For high-bandwidth applications and long-distance connections, we install fiber optic cabling systems including single-mode and multimode fiber. Our fiber installations support transmission speeds up to 100 Gbps and distances exceeding 100 kilometers, making them ideal for backbone connections, data center interconnects, and high-performance computing environments.

We implement comprehensive cable management systems including cable trays, ladders, conduits, and pathways that organize and protect cabling infrastructure while facilitating future modifications and expansions. Our installations include proper labeling, documentation, and color-coding schemes that simplify troubleshooting and maintenance.

All telecommunications rooms and equipment rooms are designed and built according to industry best practices, incorporating proper cooling, power distribution, grounding, cable management, and security measures. We install 19-inch rack systems, patch panels, cable organizers, and all necessary termination hardware.

Our testing and certification services include comprehensive performance testing using industry-leading test equipment. We provide detailed test reports documenting channel performance, insertion loss, return loss, NEXT, PSANEXT, and all relevant parameters required for warranty and compliance purposes.

We also offer cable plant management services including documentation systems, labeling schemes, and ongoing maintenance programs that help organizations maintain optimal network performance throughout the infrastructure lifecycle.`,
      features: [
        "Cat6/6A/7 copper cabling installation",
        "Single-mode and multimode fiber optic systems",
        "Telecommunications room design and build",
        "Complete testing and certification",
        "Cable management and pathway systems",
        "25-year manufacturer warranties"
      ]
    },
    {
      id: "fiber-optic-networks",
      urlSlug: "fiber-optic-networks",
      title: "Fiber Optic Networks",
      titleAr: "شبكات الألياف البصرية",
      shortDesc: "High-speed fiber optic network design, installation, splicing, and testing services.",
      mainImage: "/image/fon.jpg",
      images: ["/image/ict-2.jpg", "/image/ict-4.jpg", "/image/ict-5.jpg"],
      fullDescription: `Our Fiber Optic Network services deliver cutting-edge optical fiber solutions for telecommunications, data centers, enterprise networks, and smart city infrastructure projects across Saudi Arabia.

We provide end-to-end fiber optic solutions including network design, fiber cable installation, fusion splicing, termination, testing, and maintenance. Our expertise covers both indoor and outdoor fiber installations, from building backbone systems to long-haul telecommunications networks spanning hundreds of kilometers.

Our fiber optic network designs utilize single-mode fiber (SMF) for long-distance, high-bandwidth applications and multimode fiber (MMF) for shorter distance, high-speed data center and campus networks. We work with various fiber types including OS2 single-mode, OM3, OM4, and OM5 multimode fibers that support transmission speeds from 1 Gbps to 400 Gbps and beyond.

For outdoor fiber installations, we employ various deployment methods including aerial installation on existing utility poles, underground direct burial, duct installation in HDPE conduits, and submarine cable installations. We conduct thorough route surveys and obtain all necessary permits and approvals from relevant authorities.

Our certified fiber optic technicians perform precision fusion splicing using state-of-the-art fusion splicers that achieve splice losses below 0.05 dB. We maintain comprehensive splice documentation including splice loss measurements, splice locations, and fiber identification for each connection point in the network.

Fiber termination services include installation of various connector types including LC, SC, ST, MTP/MPO, and custom connector solutions. We install both factory-terminated patch cords and field-terminated connectors depending on project requirements. All terminations are tested and documented to ensure optimal performance.

We provide comprehensive fiber testing services using Optical Time Domain Reflectometers (OTDR), optical power meters, light sources, and visual fault locators. Our test reports include bidirectional OTDR traces, insertion loss measurements, return loss measurements, and complete fiber characterization data.

Our fiber network solutions include passive optical components such as fiber distribution frames (FDF), optical splitters for PON networks, wavelength division multiplexing (WDM) systems, and optical amplifiers for long-distance transmission. We also install active optical equipment including media converters, optical transceivers, and optical switches.

For data center applications, we design and install high-density fiber systems using MTP/MPO trunk cables, breakout modules, and advanced cable management systems that maximize port density while maintaining accessibility for moves, adds, and changes.`,
      features: [
        "Single-mode and multimode fiber installation",
        "Fusion splicing and termination services",
        "OTDR testing and certification",
        "Underground and aerial fiber deployment",
        "High-density data center fiber systems",
        "24/7 fiber network maintenance and repair"
      ]
    },
    {
      id: "network-infrastructure",
      urlSlug: "network-infrastructure",
      title: "Network Infrastructure Solutions",
      titleAr: "حلول البنية التحتية للشبكات",
      shortDesc: "Complete network infrastructure including switches, routers, firewalls, and wireless systems.",
      mainImage: "/image/nis.jpg",
      images: ["/image/ict-3.jpg", "/image/ict-1.jpg", "/image/ict-6.jpg"],
      fullDescription: `Our Network Infrastructure Solutions provide comprehensive networking systems that enable reliable, secure, and high-performance data communications for organizations of all sizes across various industries in Saudi Arabia.

We design and implement complete network infrastructures incorporating enterprise-grade network switches, routers, firewalls, wireless access points, and network management systems from leading manufacturers including Cisco, Juniper, HPE Aruba, Fortinet, and Palo Alto Networks.

Our network designs follow industry best practices including hierarchical network models with clearly defined core, distribution, and access layers. We implement redundant network paths, link aggregation, and high-availability protocols to ensure maximum uptime and business continuity. Our designs incorporate quality of service (QoS) policies that prioritize critical applications and ensure optimal performance.

For switching infrastructure, we deploy managed Layer 2 and Layer 3 switches with advanced features including VLAN segmentation, spanning tree protocols, multicast support, and comprehensive security features. Our switch deployments support various interface speeds from 1 Gigabit to 100 Gigabit, accommodating current needs while providing scalability for future growth.

Routing infrastructure includes enterprise routers, edge routers, and specialized routing platforms for WAN optimization, SD-WAN deployments, and internet connectivity. We implement dynamic routing protocols including OSPF, BGP, and EIGRP that automatically adapt to network changes and optimize traffic flow.

Security is paramount in our network designs. We implement next-generation firewalls (NGFW) with advanced threat protection, intrusion prevention systems (IPS), web filtering, application control, and VPN capabilities. Our security implementations include network segmentation, access control lists (ACLs), and zero-trust network architectures that protect against both external and internal threats.

Wireless network solutions include enterprise Wi-Fi systems with centralized management, seamless roaming, guest access portals, and location-based services. We conduct comprehensive site surveys using professional RF planning tools to optimize access point placement, channel allocation, and transmit power settings. Our wireless deployments support the latest Wi-Fi standards including Wi-Fi 6 (802.11ax) and Wi-Fi 6E, delivering multi-gigabit wireless speeds and supporting high-density environments.

Network management and monitoring systems provide centralized visibility and control over the entire network infrastructure. We implement network management platforms that monitor device health, bandwidth utilization, security events, and performance metrics. Our monitoring solutions include automated alerting, historical reporting, and predictive analytics that identify potential issues before they impact operations.

We also provide network automation and orchestration solutions that streamline network provisioning, configuration management, and change control processes. Our automation frameworks reduce human error, accelerate deployment times, and ensure consistent configuration across the entire network infrastructure.`,
      features: [
        "Enterprise switching and routing solutions",
        "Next-generation firewall implementation",
        "Wi-Fi 6/6E wireless networks",
        "Network security and segmentation",
        "Centralized network management",
        "SD-WAN and WAN optimization"
      ]
    },
    {
      id: "data-center-solutions",
      urlSlug: "data-center-solutions",
      title: "Data Center Solutions",
      titleAr: "حلول مراكز البيانات",
      shortDesc: "Complete data center infrastructure including servers, storage, virtualization, and cloud solutions.",
      mainImage: "/image/dcs.jpg",
      images: ["/image/ict-4.jpg", "/image/ict-2.jpg", "/image/ict-5.jpg"],
      fullDescription: `Our Data Center Solutions deliver comprehensive infrastructure and services for modern data centers, from small enterprise server rooms to large-scale colocation facilities and hyperscale data centers serving the digital transformation needs of Saudi Arabia.

We provide turnkey data center solutions encompassing physical infrastructure, compute resources, storage systems, networking, virtualization, cloud platforms, and data center management systems. Our designs comply with international standards including TIA-942, Uptime Institute tier classifications, and ISO 27001 security requirements.

Physical infrastructure includes raised floor systems, hot aisle/cold aisle containment, precision cooling systems, uninterruptible power supplies (UPS), power distribution units (PDUs), environmental monitoring systems, and fire suppression systems. We design data centers with modular, scalable architectures that accommodate future growth without disrupting existing operations.

Server infrastructure includes enterprise rack servers, blade servers, and hyper-converged infrastructure (HCI) platforms from leading manufacturers including Dell, HPE, Lenovo, and Cisco. We implement redundant server configurations with automatic failover capabilities that ensure high availability for mission-critical applications.

Storage solutions encompass storage area networks (SAN), network-attached storage (NAS), and software-defined storage (SDS) platforms. We design tiered storage architectures that balance performance and cost by utilizing all-flash arrays for high-performance workloads, hybrid storage for general-purpose applications, and high-capacity disk arrays for archival data.

Virtualization platforms including VMware vSphere, Microsoft Hyper-V, and open-source solutions like KVM enable organizations to maximize hardware utilization, reduce costs, and improve flexibility. We implement virtual desktop infrastructure (VDI) solutions that provide secure, centralized desktop management for remote and office workers.

Cloud solutions include private cloud implementations using OpenStack or VMware Cloud Foundation, hybrid cloud architectures that integrate on-premises infrastructure with public cloud services, and multi-cloud management platforms that provide unified control across multiple cloud providers.

Data center networking includes high-speed spine-leaf network architectures, network virtualization using overlay technologies, and software-defined networking (SDN) that programmatically controls network behavior. We implement data center interconnect (DCI) solutions that enable workload mobility and disaster recovery between geographically distributed data centers.

Backup and disaster recovery solutions protect critical data and applications. We implement comprehensive backup strategies using disk-based backup appliances, tape libraries for long-term archiving, and cloud-based backup services. Our disaster recovery solutions include replication technologies, automated failover systems, and documented recovery procedures that minimize downtime and data loss.

Data center infrastructure management (DCIM) platforms provide real-time monitoring and control over all data center resources including power consumption, cooling efficiency, space utilization, and asset management. Our DCIM implementations include capacity planning tools that predict resource requirements and optimize infrastructure investments.`,
      features: [
        "Tier II/III/IV data center design",
        "Server and storage infrastructure",
        "Virtualization and cloud platforms",
        "High-speed data center networking",
        "Backup and disaster recovery systems",
        "DCIM and monitoring solutions"
      ]
    },
    {
      id: "unified-communications",
      urlSlug: "unified-communications",
      title: "Unified Communications",
      titleAr: "الاتصالات الموحدة",
      shortDesc: "IP telephony, video conferencing, and collaboration platforms for modern workplaces.",
      mainImage: "/image/uc.jpg",
      images: ["/image/ict-5.jpg", "/image/ict-3.jpg", "/image/ict-6.jpg"],
      fullDescription: `Our Unified Communications services integrate voice, video, messaging, and collaboration tools into seamless communication platforms that enhance productivity and enable modern, flexible work environments across Saudi Arabian organizations.

We design and implement comprehensive unified communications (UC) solutions that consolidate multiple communication channels into integrated systems accessible from any device, anywhere. Our solutions support remote work, hybrid work models, and global collaboration while reducing communication costs and improving user experience.

IP telephony systems form the foundation of modern business communications. We deploy enterprise IP PBX systems from leading vendors including Cisco, Avaya, Mitel, and Microsoft Teams Phone System. Our IP telephony implementations include features such as auto-attendants, call routing, voicemail-to-email, presence information, mobile integration, and advanced call center capabilities.

VoIP infrastructure includes Session Border Controllers (SBC) for secure SIP trunking, media gateways for PSTN connectivity, and quality of service (QoS) implementations that ensure excellent voice quality over IP networks. We work with local telecom providers to provision SIP trunking services and number porting from traditional phone lines.

Video conferencing solutions enable face-to-face communication regardless of location. We install room-based video conferencing systems for boardrooms and conference rooms, desktop video solutions for individual users, and large-scale webinar platforms for corporate communications and training. Our video implementations include high-definition cameras, professional audio systems, digital signage displays, and wireless content sharing capabilities.

Unified collaboration platforms including Microsoft Teams, Cisco Webex, and Zoom provide integrated communication tools encompassing instant messaging, presence, file sharing, screen sharing, and project collaboration. We implement these platforms with proper security controls, integration with existing business systems, and comprehensive user training programs.

Contact center solutions transform customer service operations with advanced features including automatic call distribution (ACD), interactive voice response (IVR), call recording, quality monitoring, workforce management, and omnichannel customer engagement across voice, email, chat, social media, and messaging applications.

Mobility solutions enable employees to access communication systems from smartphones and tablets. We implement mobile UC clients that provide seamless handoff between devices, mobile device management (MDM) for security, and integration with mobile carriers for dual-mode phones that switch between cellular and Wi-Fi networks.

Our UC implementations include comprehensive monitoring and management tools that track system performance, user adoption, quality metrics, and usage patterns. We provide detailed analytics that help organizations optimize their communication infrastructure and identify opportunities for improvement.

Integration with business applications including CRM systems, email platforms, directory services, and productivity tools creates unified workflows that streamline business processes and improve efficiency.`,
      features: [
        "Enterprise IP telephony systems",
        "HD video conferencing solutions",
        "Microsoft Teams and collaboration platforms",
        "Contact center and call center solutions",
        "Mobile UC and device integration",
        "SIP trunking and VoIP services"
      ]
    },
    {
      id: "cybersecurity-solutions",
      urlSlug: "cybersecurity-solutions",
      title: "Cybersecurity Solutions",
      titleAr: "حلول الأمن السيبراني",
      shortDesc: "Comprehensive cybersecurity services including threat protection, security monitoring, and compliance.",
      mainImage: "/image/cs.jpg",
      images: ["/image/ict-6.jpg", "/image/ict-1.jpg", "/image/ict-4.jpg"],
      fullDescription: `Our Cybersecurity Solutions provide comprehensive protection against cyber threats, ensuring the confidentiality, integrity, and availability of information systems and data for organizations across all industries in Saudi Arabia.

We offer multilayered security solutions that protect against evolving cyber threats including malware, ransomware, phishing attacks, data breaches, insider threats, and advanced persistent threats (APT). Our security implementations align with international frameworks including NIST Cybersecurity Framework, ISO 27001, and Saudi Arabia's Essential Cybersecurity Controls (ECC).

Network security solutions include next-generation firewalls (NGFW) with advanced threat protection, intrusion prevention systems (IPS), secure web gateways, email security gateways, and DDoS protection services. We implement defense-in-depth strategies with multiple security layers that provide redundant protection if any single control fails.

Endpoint security protects computers, mobile devices, and servers from malware and unauthorized access. We deploy endpoint detection and response (EDR) solutions that provide real-time threat detection, automated response capabilities, and forensic investigation tools. Our endpoint protection includes antivirus, anti-malware, application whitelisting, device control, and full disk encryption.

Security Information and Event Management (SIEM) systems aggregate and analyze security logs from across the entire IT infrastructure. We implement SIEM platforms that correlate events, detect security incidents, generate alerts, and provide comprehensive visibility into security posture. Our SIEM implementations include threat intelligence integration that identifies known malicious actors and attack patterns.

Identity and access management (IAM) solutions control who has access to what resources. We implement single sign-on (SSO), multi-factor authentication (MFA), privileged access management (PAM), and identity governance systems that enforce least-privilege access principles and reduce insider threat risks.

Data loss prevention (DLP) solutions monitor and control data movement across networks, endpoints, and cloud applications. We implement DLP policies that prevent sensitive data exfiltration, enforce compliance requirements, and protect intellectual property and customer information.

Vulnerability management services include regular vulnerability scanning, penetration testing, security assessments, and remediation planning. Our security experts identify weaknesses in applications, systems, and networks before attackers can exploit them.

Security Operations Center (SOC) services provide 24/7 monitoring, threat detection, and incident response capabilities. We offer managed security services that include continuous monitoring, threat hunting, incident analysis, and coordinated response to security events.

Compliance services help organizations meet regulatory requirements including Saudi Arabia's National Cybersecurity Authority (NCA) regulations, SAMA Cybersecurity Framework for financial institutions, SDAIA Cloud Computing Framework, and international standards including GDPR and PCI DSS.

Security awareness training programs educate employees about cyber threats, phishing attacks, social engineering tactics, and security best practices. We provide customized training programs, simulated phishing campaigns, and ongoing security awareness communications.

Our incident response services provide rapid assistance during security breaches. We maintain incident response teams that perform forensic investigations, contain threats, eradicate malware, restore systems, and implement measures to prevent future incidents.`,
      features: [
        "Next-generation firewall and IPS",
        "Endpoint detection and response (EDR)",
        "SIEM and security monitoring",
        "Identity and access management",
        "24/7 SOC and managed security services",
        "Compliance and security assessments"
      ]
    }
  ]
},
elv: {
  title: "ELV Systems",
  titleAr: "أنظمة الجهد المنخفض جداً",
  description: "Extra-low voltage systems including security, access control, and building automation",
  icon: "fa-video",
  mainImage: "/elv.jpg",
  urlSlug: "elv",
  subServices: [
    {
      id: "cctv-surveillance",
      urlSlug: "cctv-surveillance",
      title: "CCTV & Video Surveillance",
      titleAr: "أنظمة المراقبة بالفيديو",
      shortDesc: "Advanced IP and analog CCTV systems with intelligent video analytics and remote monitoring.",
      mainImage: "/image/cvs.jpg",
      images: ["/image/elv-1.jpg", "/image/elv-2.jpg", "/image/elv-3.jpg"],
      fullDescription: `Our CCTV & Video Surveillance services provide comprehensive security monitoring solutions that protect assets, deter crime, and provide valuable forensic evidence for facilities across Saudi Arabia.

We design and install state-of-the-art video surveillance systems utilizing both IP-based and analog camera technologies, depending on project requirements and budget considerations. Our solutions range from small business installations with a handful of cameras to large-scale enterprise deployments with thousands of cameras covering extensive facilities.

Our camera offerings include fixed dome cameras, PTZ (pan-tilt-zoom) cameras, bullet cameras, fisheye panoramic cameras, thermal imaging cameras, and specialized cameras for challenging environments. We select camera specifications including resolution (from 2MP to 4K and beyond), lens focal length, low-light sensitivity, and environmental ratings based on specific surveillance requirements.

IP camera systems leverage existing network infrastructure to transmit high-definition video over standard Ethernet networks. We implement Power over Ethernet (PoE) solutions that eliminate the need for separate power supplies, simplifying installation and reducing costs. Our IP systems support advanced features including intelligent video analytics, remote access, and seamless integration with other security systems.

Video analytics capabilities include motion detection, line crossing detection, intrusion detection, facial recognition, license plate recognition (LPR/ANPR), people counting, heat mapping, and behavior analysis. These intelligent features automate surveillance operations, reduce false alarms, and enable proactive security responses.

Network Video Recorders (NVR) and Digital Video Recorders (DVR) store surveillance footage with redundant storage configurations ensuring data integrity. We implement tiered storage architectures using high-performance drives for recent footage and archival storage for long-term retention. Storage capacity is calculated based on camera count, resolution, frame rate, compression, and retention requirements.

Video management software (VMS) platforms provide centralized control over entire surveillance systems. We implement VMS solutions from leading manufacturers including Milestone, Genetec, Avigilon, and Hikvision that support features such as multi-site management, alarm integration, mobile viewing, and integration with access control and building management systems.

Control room solutions include video wall displays, workstation configurations, and ergonomic operator positions designed for 24/7 security operations. We integrate multiple video sources, create custom display layouts, and implement keyboard/joystick controls for efficient surveillance operations.

For critical infrastructure and high-security applications, we implement redundant recording systems, encrypted video transmission, tamper-resistant cameras, and cybersecurity measures that protect surveillance systems from unauthorized access and cyber attacks.

Maintenance and support services include regular camera cleaning, lens adjustment, firmware updates, hard drive replacements, and system health monitoring to ensure optimal surveillance system performance.`,
      features: [
        "HD IP and analog camera systems",
        "Intelligent video analytics and AI",
        "Network and local recording solutions",
        "Video management software platforms",
        "Remote monitoring and mobile access",
        "Integration with access control systems"
      ]
    },
    {
      id: "access-control",
      urlSlug: "access-control",
      title: "Access Control Systems",
      titleAr: "أنظمة التحكم في الدخول",
      shortDesc: "Comprehensive access control with card readers, biometrics, and visitor management.",
      mainImage: "/image/acs.jpg",
      images: ["/image/elv-2.jpg", "/image/elv-4.jpg", "/image/elv-5.jpg"],
      fullDescription: `Our Access Control Systems provide sophisticated security solutions that manage and monitor who has access to facilities, ensuring only authorized personnel can enter restricted areas while maintaining comprehensive audit trails.

We design and implement enterprise-grade access control systems that protect physical assets, secure sensitive areas, and comply with regulatory requirements for organizations across various industries in Saudi Arabia.

Our access control solutions support multiple credential technologies including proximity cards, smart cards, mobile credentials, biometric authentication (fingerprint, facial recognition, iris scanning), and PIN codes. We implement multi-factor authentication for high-security areas requiring multiple forms of verification.

Access control panels and controllers manage door locks, readers, and authentication decisions. We install scalable systems ranging from standalone single-door controllers to networked enterprise systems managing thousands of doors across multiple sites. Our controllers support various lock types including electromagnetic locks, electric strikes, electrified mortise locks, and electrified panic hardware.

Reader technologies include standard proximity readers, long-range readers for vehicle access, contactless smart card readers supporting multiple technologies, and biometric readers integrated directly into access control systems. We position readers at strategic locations considering user convenience, environmental conditions, and security requirements.

Software platforms provide centralized management of users, credentials, access rights, schedules, and zones. We implement access control management systems that support features including role-based access control, time-based access restrictions, anti-passback rules, and integration with HR systems for automated provisioning and de-provisioning.

Visitor management systems control temporary access for visitors, contractors, and vendors. Our visitor management solutions include self-service kiosks, badge printing, host notification, legal agreement acceptance, watchlist screening, and visitor tracking throughout facilities.

Integration with video surveillance systems provides visual verification of access events, enabling security personnel to review video footage associated with door access, tailgating incidents, and forced entry attempts.

Elevator control systems restrict elevator access based on user credentials and access rights, preventing unauthorized access to specific floors or areas within multi-story buildings.

Parking access control includes vehicle barrier gates, license plate recognition systems, ticket dispensers, payment kiosks, and parking guidance systems that manage vehicle access to parking facilities.

Intrusion detection integration links access control with burglar alarm systems, automatically arming/disarming alarm zones based on access control events and user credentials.

Our access control implementations include comprehensive audit trails logging all access events, credential uses, system changes, and administrative actions. These logs support security investigations, compliance audits, and forensic analysis.

Maintenance services include regular testing of locks and readers, credential management, software updates, and troubleshooting to ensure reliable access control system operation.`,
      features: [
        "Card and biometric authentication",
        "Multi-site centralized management",
        "Visitor management systems",
        "Integration with CCTV and alarms",
        "Mobile credentials and Bluetooth",
        "Comprehensive audit and reporting"
      ]
    },
    {
      id: "intrusion-detection",
      urlSlug: "intrusion-detection",
      title: "Intrusion Detection & Alarm Systems",
      titleAr: "أنظمة كشف التسلل والإنذار",
      shortDesc: "Advanced burglar alarm systems with perimeter protection and 24/7 monitoring.",
      mainImage: "/image/idas.jpg",
      images: ["/image/elv-3.jpg", "/image/elv-1.jpg", "/image/elv-6.jpg"],
      fullDescription: `Our Intrusion Detection & Alarm Systems provide comprehensive burglar alarm and perimeter security solutions that detect unauthorized entry attempts and alert security personnel to potential security breaches.

We design and install sophisticated intrusion detection systems that protect buildings, facilities, and critical infrastructure using multiple layers of detection technologies and intelligent alarm management.

Detection devices include passive infrared (PIR) motion detectors, dual-technology sensors combining PIR and microwave detection, glass break detectors, door/window contacts, vibration sensors, and beam detectors for perimeter protection. We strategically position sensors to provide complete coverage while minimizing false alarms.

Perimeter protection systems detect intrusions before they reach buildings. We install outdoor detection technologies including buried cable sensors, microwave barriers, infrared beam detectors, electric fence systems, and video analytics-based intrusion detection that monitor fence lines, walls, and property boundaries.

Alarm control panels serve as the central processing unit for intrusion detection systems. We install modular, scalable control panels that support wired and wireless zones, integrate with access control systems, provide multiple communication paths to monitoring centers, and include battery backup for operation during power outages.

User interfaces include keypads, touchscreen panels, and mobile applications that allow authorized users to arm/disarm systems, view system status, receive alarm notifications, and control system functions remotely.

Central monitoring station connections ensure 24/7 professional alarm monitoring. We configure multiple communication paths including IP networking, cellular communication, and telephone line connections providing redundant alarm transmission to monitoring centers.

Alarm verification technologies reduce false alarms and improve response efficiency. We implement video verification linking cameras to alarm events, sequential alarm verification requiring multiple sensor activations, and audio verification listening to sounds in protected areas.

Zoning and scheduling capabilities allow different areas to be armed/disarmed independently based on occupancy patterns and operational requirements. We program complex schedules accommodating varying business hours, shift changes, and special events.

Integration with other security systems creates comprehensive security solutions. Our intrusion detection systems interface with access control, video surveillance, lighting control, and fire alarm systems, enabling coordinated security responses and automated building control.

Environmental monitoring adds value beyond security. We integrate sensors monitoring temperature, humidity, water leaks, smoke, carbon monoxide, and other environmental conditions, providing alerts for conditions that could damage property or threaten occupant safety.

Panic buttons and duress alarms provide emergency notification capabilities. We install fixed panic buttons at reception desks and cashier stations, as well as wireless panic buttons and duress codes for personnel working in potentially dangerous situations.

Maintenance and testing services ensure reliable system operation. We conduct regular system tests, battery replacements, sensor cleaning, and firmware updates, documenting all maintenance activities for compliance and audit purposes.`,
      features: [
        "Multi-technology detection devices",
        "Perimeter intrusion detection",
        "24/7 central station monitoring",
        "Video verification and analytics",
        "Environmental monitoring sensors",
        "Mobile app control and notifications"
      ]
    },
    {
      id: "building-automation",
      urlSlug: "building-automation",
      title: "Building Management Systems (BMS)",
      titleAr: "أنظمة إدارة المباني",
      shortDesc: "Intelligent building automation for HVAC, lighting, and energy management.",
      mainImage: "/image/bms.jpg",
      images: ["/image/elv-4.jpg", "/image/elv-2.jpg", "/image/elv-5.jpg"],
      fullDescription: `Our Building Management Systems (BMS) provide intelligent automation and control of mechanical and electrical systems, optimizing building performance, reducing energy consumption, and enhancing occupant comfort.

We design and implement comprehensive BMS solutions that integrate HVAC systems, lighting control, energy management, and building services into unified platforms accessible from centralized workstations, mobile devices, and cloud-based interfaces.

HVAC control systems manage heating, ventilation, and air conditioning equipment including chillers, boilers, air handling units, fan coil units, variable air volume (VAV) boxes, and exhaust fans. We implement advanced control strategies including demand-based ventilation, economizer control, optimal start/stop, and night setback that optimize energy efficiency while maintaining comfortable environments.

Temperature sensors, humidity sensors, pressure sensors, and occupancy sensors provide real-time data enabling precise environmental control. We install direct digital control (DDC) systems with programmable controllers that execute complex control algorithms and communicate via industry-standard protocols including BACnet, Modbus, and LonWorks.

Lighting control systems automate lighting based on occupancy, daylight availability, and time schedules. We implement lighting control strategies including occupancy sensing, daylight harvesting, task tuning, and personal control that reduce lighting energy consumption by up to 60% while improving lighting quality and user satisfaction.

Energy management capabilities include real-time energy monitoring, demand limiting, load shedding, utility tariff management, and comprehensive energy reporting. Our energy management implementations identify energy waste, benchmark performance, and support continuous improvement initiatives.

Integration with utility meters provides detailed energy consumption data broken down by area, equipment type, and time period. We install electrical meters, gas meters, water meters, and thermal energy meters with pulse or communication outputs connected to BMS platforms.

Alarm management consolidates alerts from all building systems into unified alarm displays. We configure alarm priorities, escalation procedures, and notification rules ensuring critical issues receive immediate attention while minimizing alarm fatigue.

Trending and historical data logging capture system performance over time. We configure data logging for critical parameters enabling analysis of system performance, identification of optimization opportunities, and troubleshooting of operational issues.

Graphical user interfaces provide intuitive control and monitoring. We develop custom graphics displaying building floor plans, system schematics, and equipment status with point-and-click navigation enabling operators to efficiently monitor and control entire buildings.

Remote access capabilities allow facility managers to monitor and control building systems from anywhere using web browsers, mobile applications, and cloud-based platforms. Remote access includes secure authentication, encrypted communications, and audit logging.

Integration with other building systems including fire alarms, security systems, and elevators enables advanced features such as automatic HVAC shutdown during fire alarms, lighting control integrated with security systems, and elevator priority control.

Maintenance management modules track preventive maintenance schedules, work orders, equipment history, and spare parts inventory, helping facility teams maintain equipment reliability and extend equipment life.`,
      features: [
        "HVAC automation and optimization",
        "Intelligent lighting control",
        "Real-time energy monitoring",
        "Cloud-based remote access",
        "Integration with fire and security",
        "Comprehensive reporting and analytics"
      ]
    },
    {
      id: "public-address",
      urlSlug: "public-address",
      title: "Public Address & Voice Evacuation",
      titleAr: "أنظمة الإذاعة العامة والإخلاء الصوتي",
      shortDesc: "PA systems and emergency voice evacuation for life safety and mass notification.",
      mainImage: "/image/pave.jpg",
      images: ["/image/elv-5.jpg", "/image/elv-3.jpg", "/image/elv-6.jpg"],
      fullDescription: `Our Public Address & Voice Evacuation systems provide critical communication capabilities for routine announcements, background music, and life-safety emergency notifications in buildings and facilities throughout Saudi Arabia.

We design and install integrated PA/VA systems that combine public address functionality for day-to-day communications with voice evacuation capabilities meeting international fire safety standards including EN 54-16 and NFPA 72.

Voice evacuation systems provide intelligible emergency messages during fire and other emergencies. Our VA implementations include redundant amplifiers, supervised speaker circuits, emergency microphone stations, and automatic message playback triggered by fire alarm systems or manual activation.

Speaker design and placement ensures even sound coverage and high speech intelligibility throughout protected areas. We conduct acoustic modeling and speech intelligibility testing using specialized equipment measuring STI (Speech Transmission Index) values, documenting compliance with EN 60849 requirements for emergency sound systems.

Amplifier systems include redundant power amplifiers with automatic switchover, battery backup ensuring operation during power failures, and supervised outputs continuously monitoring speaker circuit integrity. Our amplifier configurations support distributed amplifier architectures for large facilities and centralized systems for smaller installations.

Zoning capabilities enable targeted announcements to specific areas. We implement flexible zoning allowing different messages, music sources, and volume levels in different zones while maintaining priority override capabilities for emergency announcements.

Integration with fire alarm systems ensures automatic emergency message broadcast when fire alarms activate. We program message sequences, evacuation tones, and phased evacuation procedures complying with local fire codes and building evacuation plans.

Emergency microphone stations allow security personnel and fire wardens to broadcast live announcements during emergencies. We install strategically located emergency microphones with priority override capabilities, pre-recorded message triggers, and all-call functions.

Background music systems enhance ambiance in retail, hospitality, and commercial environments. We integrate streaming services, local music libraries, scheduled playlists, and volume automation maintaining appropriate sound levels throughout the day.

Paging systems allow staff communication and customer notifications. Our paging implementations include desk microphones, telephone paging integration, and automatic announcements for scheduled events or operational requirements.

Network audio systems leverage IP networks for audio distribution. We implement networked audio platforms using standards including Dante, AES67, and AVB enabling flexible audio routing, remote management, and integration with building automation systems.

Voice alarm control panels serve as the central command unit for voice evacuation systems. We install panels from certified manufacturers with features including fault monitoring, battery management, test functions, and event logging meeting EN 54-16 requirements.

Testing and commissioning includes comprehensive verification of system operation, speech intelligibility measurements, battery autonomy tests, and documentation of compliance with applicable standards and regulations.

Maintenance services include regular testing of speakers, amplifiers, batteries, and control equipment, ensuring voice evacuation systems remain functional and compliant throughout their service life.`,
      features: [
        "EN 54-16 compliant voice evacuation",
        "High speech intelligibility design",
        "Redundant amplifiers and power backup",
        "Integration with fire alarm systems",
        "Multi-zone paging and announcements",
        "Background music and audio streaming"
      ]
    },
    {
      id: "parking-guidance",
      urlSlug: "parking-guidance",
      title: "Parking Guidance & Management",
      titleAr: "أنظمة إرشاد وإدارة المواقف",
      shortDesc: "Smart parking systems with guidance, payment, and license plate recognition.",
      mainImage: "/image/pgm.jpg",
      images: ["/image/elv-6.jpg", "/image/elv-1.jpg", "/image/elv-4.jpg"],
      fullDescription: `Our Parking Guidance & Management systems provide intelligent parking solutions that improve parking efficiency, reduce search times, enhance user experience, and optimize parking facility operations.

We design and install comprehensive parking management systems incorporating vehicle detection, guidance signage, access control, payment systems, and management software for parking facilities ranging from small surface lots to large multi-level parking structures.

Vehicle detection sensors identify occupied and vacant parking spaces. We deploy various sensor technologies including ultrasonic sensors, radar sensors, camera-based detection, and ground-embedded magnetic sensors, selecting optimal technologies based on parking layout, environmental conditions, and budget considerations.

Guidance displays direct drivers to available parking. Our implementations include entry signs showing total available spaces, level indicators showing availability by floor, bay-level indicators showing space availability in specific areas, and overhead indicators showing individual space status with red/green lights.

License plate recognition (LPR/ANPR) systems capture vehicle registration numbers for access control, payment automation, and security purposes. We install high-resolution cameras with specialized image processing identifying license plates in various lighting conditions and capturing plates at vehicle speeds up to 120 km/h.

Access control systems manage entry and exit. We install vehicle barriers, boom gates, bollards, and parking guidance terminals controlling access based on permits, pre-booking, payment status, and available capacity. Our access control integrations support various credentials including RFID tags, QR codes, license plate recognition, and mobile applications.

Payment systems support multiple payment methods including cash, credit cards, mobile payments, and contactless payment technologies. We install payment kiosks, pay-on-foot stations, license plate recognition-based payment, and mobile payment applications enabling flexible payment options.

Parking reservation systems allow users to pre-book parking spaces via web portals and mobile applications. Our reservation systems integrate with payment gateways, access control systems, and guidance displays ensuring reserved spaces are protected and guidance reflects reserved status.

Parking management software provides centralized control and monitoring. We implement management platforms supporting features including real-time occupancy monitoring, revenue management, reporting and analytics, user account management, and integration with building management systems.

Electric vehicle (EV) charging integration manages EV charging infrastructure within parking facilities. Our EV integrations include charging station reservations, load management preventing electrical overload, billing integration, and guidance directing EV drivers to available charging spaces.

Violation management systems detect parking violations including overstaying, parking in unauthorized areas, and parking in reserved spaces. We implement automated violation detection using sensors and cameras with notification systems alerting parking enforcement personnel.

Security integration links parking systems with CCTV surveillance and intrusion detection. Our security integrations provide video verification of access events, automated incident detection, and integration with security alarm systems.

Analytics and reporting provide insights into parking utilization, revenue performance, peak demand periods, and user behavior. We configure reports and dashboards supporting operational management and strategic planning decisions.

Wayfinding integration links parking systems with building wayfinding displays providing end-to-end navigation from parking spaces to final destinations within buildings or campuses.

Mobile applications enhance user experience with features including real-time space availability, turn-by-turn navigation to available spaces, space reservation, payment, parking history, and receipt management.`,
      features: [
        "Real-time parking space detection",
        "LED guidance signs and indicators",
        "License plate recognition (LPR/ANPR)",
        "Multiple payment methods and kiosks",
        "Mobile reservation and payment apps",
        "EV charging integration and management"
      ]
    }
  ]
},

av: {
  title: "Audio Visual Systems",
  titleAr: "الأنظمة السمعية والبصرية",
  description: "Professional audio and visual solutions for conferences, training, and entertainment",
  icon: "fa-microphone",
  mainImage: "/image/coming-soon3.jpg",
  urlSlug: "av",
  subServices: [
    {
      id: "conference-systems",
      urlSlug: "conference-systems",
      title: "Conference Room Solutions",
      titleAr: "حلول غرف الاجتماعات",
      shortDesc: "Complete boardroom and conference room AV systems with video conferencing.",
      mainImage: "/image/crs.jpg",
      images: ["/image/av-1.jpg", "/image/av-2.jpg", "/image/av-3.jpg"],
      fullDescription: `Our Conference Room Solutions deliver professional audio visual systems that enable effective meetings, presentations, and video conferences for organizations across Saudi Arabia.

We design and install complete conference room AV systems integrating displays, projectors, audio systems, video conferencing, wireless presentation, lighting control, and automated room control creating seamless user experiences.

Display systems include large-format LED/LCD displays, video walls, interactive displays, and projection systems. We select display technologies based on room size, ambient lighting, viewing distances, and usage requirements. Our installations include professional mounting systems, cable management, and calibration for optimal image quality.

Video conferencing systems enable remote collaboration. We install comprehensive video conferencing solutions including PTZ cameras, ceiling microphone arrays, soundbars, codec equipment, and touch panel controllers supporting platforms including Zoom Rooms, Microsoft Teams Rooms, Cisco Webex, and hardware-based systems from Poly, Logitech, and Yealink.

Audio systems deliver clear, intelligible sound for both in-room participants and remote attendees. We install ceiling speakers, in-ceiling microphones, wireless microphones, and digital signal processors (DSP) that automatically adjust audio levels, eliminate echo, and suppress background noise.

Wireless presentation systems enable easy content sharing from laptops, tablets, and smartphones. We install wireless presentation solutions supporting screen mirroring, multi-user collaboration, annotation, and recording without requiring cables or dongles.

Room control systems provide intuitive one-touch operation. We program touch panel controllers and automation systems that control all AV equipment, lighting, window shades, and room scheduling with simple user interfaces requiring no technical training.

Cable management and connectivity include strategically positioned connection plates, cable access points, HDMI extenders, and cable pathways ensuring clean installations and supporting various source devices.

Lighting control systems adjust room lighting for presentations and video conferences. We integrate automated window shades, dimmable lighting, and preset lighting scenes optimized for different meeting scenarios.

Room scheduling panels installed outside conference rooms display room availability, current meetings, and upcoming reservations. We integrate room scheduling systems with corporate calendar systems including Microsoft Exchange and Google Calendar.

For executive boardrooms, we provide premium solutions including curved video walls, high-end acoustical treatments, automated furniture including motorized tables and lift systems, and sophisticated control systems creating impressive presentation environments.

Training rooms require specialized AV systems supporting instructor presentations, student collaboration, and recording. We install multiple displays, document cameras, lecture capture systems, and interactive technologies enabling effective training delivery.

Installation includes comprehensive cable infrastructure, rack systems, equipment mounting, system programming, calibration, testing, and user training ensuring successful system deployments.

Maintenance and support services include preventive maintenance, firmware updates, troubleshooting, and helpdesk support keeping conference room systems operational and reliable.`,
      features: [
        "4K displays and video walls",
        "Professional video conferencing",
        "Wireless presentation systems",
        "Automated room control",
        "High-quality audio systems",
        "Integration with corporate calendar"
      ]
    },
    {
      id: "digital-signage",
      urlSlug: "digital-signage",
      title: "Digital Signage Solutions",
      titleAr: "حلول اللافتات الرقمية",
      shortDesc: "Dynamic digital signage for corporate communications, wayfinding, and advertising.",
      mainImage: "/image/dss.jpg",
      images: ["/image/av-2.jpg", "/image/av-4.jpg", "/image/av-5.jpg"],
      fullDescription: `Our Digital Signage Solutions provide dynamic visual communication platforms delivering targeted messages, information, and advertisements to audiences in corporate, retail, hospitality, healthcare, education, and transportation environments.

We design and implement comprehensive digital signage systems including displays, media players, content management software, and network infrastructure creating engaging visual experiences that inform, entertain, and influence audiences.

Display technologies include commercial-grade LCD displays, high-brightness outdoor displays, transparent OLED displays, LED video walls, interactive kiosks, and specialized displays for unique applications. We select displays based on viewing environment, content requirements, and installation location.

Media players drive content to displays. We deploy professional media players including standalone players, network players, system-on-chip (SoC) displays with integrated players, and enterprise-grade player appliances supporting various content formats, scheduling capabilities, and remote management.

Content management systems (CMS) provide centralized control over digital signage networks. We implement CMS platforms supporting features including multi-user access, content scheduling, playlist management, emergency alerts, data integration, and analytics tracking viewer engagement and content effectiveness.

Content creation services help organizations develop engaging digital signage content. Our creative services include graphic design, video production, animation, HTML5 content, and template development creating professional content optimized for digital signage displays.

Interactive digital signage adds engagement. We install touchscreen displays, gesture recognition systems, QR code integration, mobile device interaction, and wayfinding systems enabling audience interaction and personalized experiences.

Network infrastructure includes wired and wireless connectivity, content delivery networks (CDN), edge computing for local content caching, and failover mechanisms ensuring reliable content delivery across distributed digital signage networks.

Video walls create impactful visual displays. We design and install video walls using LCD panels, direct-view LED, and projection systems creating large-scale displays for lobbies, control rooms, retail environments, and public spaces.

Outdoor digital signage requires specialized solutions. We install weatherproof displays, high-brightness screens readable in direct sunlight, thermal management systems, and vandal-resistant enclosures for outdoor locations.

Integration with data sources enables dynamic content. We connect digital signage systems to databases, web services, social media feeds, weather services, RSS feeds, and business intelligence systems displaying real-time information.

Retail digital signage solutions include point-of-sale displays, window displays, menu boards, shelf-edge displays, and interactive product catalogs enhancing shopping experiences and driving sales.

Corporate communications applications include lobby displays, employee information systems, meeting room displays, safety messaging, and internal marketing platforms improving employee engagement and corporate culture.

Wayfinding systems help people navigate complex facilities. We implement interactive wayfinding displays with maps, turn-by-turn directions, and integration with building management systems providing dynamic wayfinding based on room scheduling and building events.

Emergency messaging capabilities enable critical communications. We implement emergency alert systems that override normal content with emergency messages triggered by fire alarms, security systems, or manual activation.

Analytics and reporting provide insights into content performance, viewer engagement, and system uptime. We configure analytics tracking content play counts, dwell time, interaction rates, and system health supporting content optimization and ROI measurement.

Installation services include site surveys, mounting, cabling, configuration, testing, and commissioning ensuring professional installations and optimal system performance.`,
      features: [
        "Commercial-grade displays and video walls",
        "Cloud-based content management",
        "Interactive touchscreen kiosks",
        "Real-time data integration",
        "Emergency alert override",
        "Remote monitoring and analytics"
      ]
    },
    {
      id: "auditorium-systems",
      urlSlug: "auditorium-systems",
      title: "Auditorium & Theater Systems",
      titleAr: "أنظمة القاعات والمسارح",
      shortDesc: "Professional AV systems for auditoriums, theaters, and large presentation venues.",
      mainImage: "/image/ats.jpg",
      images: ["/image/av-3.jpg", "/image/av-1.jpg", "/image/av-6.jpg"],
      fullDescription: `Our Auditorium & Theater Systems deliver professional-grade audio visual solutions for performing arts centers, educational theaters, corporate auditoriums, and large presentation venues requiring exceptional sound quality, stunning visuals, and sophisticated control.

We design and install comprehensive theater and auditorium AV systems encompassing sound reinforcement, theatrical lighting, projection systems, stage rigging, and show control creating immersive experiences for audiences and performers.

Sound reinforcement systems provide clear, powerful audio for speech and music. We design acoustically optimized audio systems using line array speakers, point source speakers, subwoofers, and delay speakers creating even coverage and natural sound reproduction throughout seating areas.

Mixing consoles and digital signal processors provide precise audio control. We install professional audio mixing consoles supporting multiple input sources, effect processing, and output routing with comprehensive control over sound reinforcement systems.

Microphone systems include wired and wireless microphones for presenters, performers, and audience Q&A. We deploy handheld microphones, lavalier microphones, headset microphones, boundary microphones, and overhead microphone arrays optimized for various speaking and performance applications.

Theatrical lighting creates atmosphere and directs attention. We install stage lighting systems including LED fixtures, moving lights, conventional theatrical fixtures, followspots, and architectural lighting creating dynamic lighting environments controlled by professional lighting consoles.

Projection systems deliver large-scale visuals. We install high-brightness projectors, large format screens, edge blending systems for seamless wide-screen images, and projection mapping systems creating visual impact for presentations and performances.

Stage rigging systems support lighting, scenery, and special effects. We design and install motorized rigging systems, theatrical rigging, projection screen lifts, and automated curtains with integrated control and safety systems.

Video systems include large LED video walls, IMAG (image magnification) systems capturing and displaying live video of presenters and performers, and multi-camera production systems creating broadcast-quality video for hybrid events.

Show control systems orchestrate complex productions. We program automation systems coordinating audio, video, lighting, rigging, and special effects creating synchronized presentations and theatrical performances with precise timing and repeatability.

Assistive listening systems support hearing-impaired audience members. We install infrared assistive listening systems, hearing loop systems, and FM-based systems complying with ADA requirements and international accessibility standards.

Acoustic treatments optimize sound quality. We specify and install acoustic panels, bass traps, diffusers, and sound isolation materials controlling reverberation, echo, and external noise improving speech intelligibility and music quality.

Control rooms provide centralized operation. We design and build control rooms with technical directors' positions, audio mixing positions, lighting control positions, and video production positions equipped with professional monitoring and control equipment.

Broadcast integration enables live streaming and recording. We implement production systems capturing multi-camera video, audio mixing, graphics overlays, and streaming encoders broadcasting events to remote audiences.

House lighting and emergency systems provide audience illumination. We integrate dimmable house lighting with emergency egress lighting ensuring safe audience evacuation during emergencies while maintaining theatrical capabilities during performances.

Intercom and communication systems connect technical staff. We install wired and wireless intercom systems providing clear communication between control room, stage, backstage, and technical positions coordinating complex productions.

Installation includes comprehensive infrastructure including cable trays, power distribution, equipment racks, patch panels, and cable labeling supporting complex AV systems while maintaining organized, maintainable installations.`,
      features: [
        "Professional line array audio systems",
        "Theatrical lighting and control",
        "High-brightness projection systems",
        "Automated stage rigging",
        "Show control and automation",
        "Assistive listening and accessibility"
      ]
    },
    {
      id: "classroom-av",
      urlSlug: "classroom-av",
      title: "Smart Classroom Solutions",
      titleAr: "حلول الفصول الذكية",
      shortDesc: "Interactive learning environments with displays, recording, and collaboration tools.",
      mainImage: "/image/scso.jpg",
      images: ["/image/av-4.jpg", "/image/av-2.jpg", "/image/av-5.jpg"],
      fullDescription: `Our Smart Classroom Solutions transform traditional learning environments into interactive, technology-enabled spaces that enhance teaching effectiveness, improve student engagement, and support diverse learning styles across educational institutions in Saudi Arabia.

We design and install comprehensive classroom AV systems integrating interactive displays, audio systems, document cameras, lecture capture, and classroom management creating modern learning environments.

Interactive displays replace traditional whiteboards. We install interactive flat panels with touch capabilities, annotation tools, screen sharing, and collaboration features enabling interactive lessons and student participation. Our interactive display solutions include short-throw and ultra-short-throw projectors with interactive pens for large classrooms.

Audio systems ensure clear instructor voice amplification. We install ceiling speakers, soundbars, and classroom amplification systems with wireless microphones ensuring every student clearly hears instruction regardless of seating position.

Document cameras display physical objects, textbooks, and documents. We install high-resolution document cameras with HDMI and USB connectivity enabling teachers to show detailed examples and demonstrate procedures visible to entire classrooms.

Lecture capture systems record and stream lessons. We implement automated recording systems capturing instructor video, audio, presentation content, and annotations creating content for remote students, exam preparation, and make-up instruction.

Wireless presentation systems enable easy content sharing. We install wireless presentation solutions allowing teachers and students to share content from laptops, tablets, and smartphones without cables or technical complexity.

Room control systems provide simple operation. We install touch panel controllers and simplified control interfaces enablingteachers to control all classroom technology with minimal training and technical support.
Classroom management software enables instructor control over student devices. We implement classroom management platforms allowing teachers to monitor student screens, push content, control internet access, and facilitate interactive lessons.
Video conferencing integration enables remote learning. We install video conferencing systems supporting hybrid learning scenarios with remote students participating alongside in-classroom students.
Charging and storage solutions keep devices ready. We install charging carts, charging cabinets, and device management systems for tablets and laptops used in classroom instruction.
Acoustical treatments improve learning environments. We specify acoustic panels, ceiling treatments, and sound masking systems reducing noise distractions and improving speech intelligibility.
Assistive technologies support students with disabilities. We integrate captioning systems, assistive listening devices, adjustable-height desks, and accessible control interfaces ensuring inclusive learning environments.
Integration with learning management systems (LMS) links classroom technology with course content. Our integrations support features including attendance tracking, assignment distribution, and automatic content publishing to LMS platforms.
Flexible furniture arrangements support various teaching styles. We coordinate AV installations with flexible seating, movable desks, and collaborative workspaces accommodating lecture, group work, and active learning scenarios.
Teacher training and support services ensure successful technology adoption. We provide instructor training, technical documentation, helpdesk support, and ongoing professional development supporting educators using classroom technology effectively.
Installation includes infrastructure planning, cable management, equipment mounting, system programming, testing, and commissioning ensuring reliable, user-friendly classroom AV systems.`,       
features: [        
 "Interactive displays and projectors",       
   "Automated lecture capture",       
     "Wireless presentation and collaboration",      
        "Classroom audio reinforcement",       
          "Video conferencing for hybrid learning",     
              "Integration with learning management"
              ]  
              },     
             {       
                 id: "broadcast-studios",       
                 urlSlug: "broadcast-studios",       
                 title: "Broadcast & Production Studios",       
                 titleAr: "استوديوهات البث والإنتاج",       
                 shortDesc: "Professional broadcast studios with cameras, lighting, and production equipment.",      
                  mainImage: "/image/bps.jpg",       
                  images: ["/image/av-5.jpg", "/image/av-3.jpg", "/image/av-6.jpg"],       
                  fullDescription: `Our Broadcast & Production Studios deliver professional television and video production facilities enabling organizations to create high-quality video content for internal communications, marketing, training, and broadcasting.
We design and build complete broadcast studios and production control rooms including studio infrastructure, camera systems, lighting, audio, video production equipment, and broadcast automation creating end-to-end production capabilities.
Studio infrastructure includes acoustic treatments, lighting grids, cyclorama backgrounds, set construction, and studio flooring creating controlled production environments with professional appearance and excellent technical characteristics.
Camera systems include broadcast-quality studio cameras, robotic PTZ cameras, and cinema cameras. We install multi-camera setups with camera control units (CCU), camera robotics, teleprompters, and camera support equipment including pedestals, jibs, and sliders.
Studio lighting systems provide professional illumination. We install LED studio lights, Fresnel lights, softboxes, and lighting control systems enabling key light, fill light, and backlight configurations creating professional lighting for on-camera talent.
Production switchers enable live video production. We install video switchers supporting multiple camera inputs, graphics overlays, chroma key, transitions, and multi-viewer outputs enabling live production and recording.
Graphics systems create professional on-screen graphics. We implement character generators, graphics engines, and virtual set systems adding lower thirds, tickers, weather graphics, and virtual backgrounds to productions.
Audio production includes mixing consoles, microphones, audio processing, and monitoring. We install broadcast audio consoles, studio microphones, mic processors, and studio monitors creating pristine audio for video productions.
Video routing and distribution infrastructure connects production equipment. We install video routers, frame synchronizers, format converters, and distribution amplifiers enabling flexible signal routing throughout production facilities.
Recording and playback systems capture and play video content. We install video servers, replay systems, clip players, and playout automation systems supporting recorded content insertion and playback during productions.
Intercom and communication systems connect production staff. We install wired and wireless intercom systems, IFB systems, and production communication platforms enabling clear communication between control room, studio floor, and remote locations.
Streaming and encoding systems deliver content online. We implement streaming encoders, CDN integration, and multi-platform streaming supporting live streaming to corporate portals, YouTube, social media, and custom applications.
Master control and playout automation systems manage broadcast workflows. We install automation systems controlling video playout, commercial insertion, graphics, and station identification creating professional broadcast operations.
Remote production capabilities enable field production. We deploy mobile production systems including portable switchers, wireless video transmission, bonded cellular systems, and satellite uplink creating production capabilities beyond studio environments.
Monitoring and quality control equipment includes broadcast monitors, waveform monitors, vectorscopes, and audio meters ensuring technical quality throughout production workflows.
Integration with asset management systems organizes media libraries. We implement media asset management (MAM) systems supporting video ingestion, metadata tagging, search, and archive creating organized media libraries.
Installation includes comprehensive infrastructure including power distribution, backup power, cooling, cable infrastructure, equipment racks, and technical furniture creating professional production facilities.`,      
features: [        
 "Multi-camera broadcast systems",        
  "Professional studio lighting",         
  "Live production switchers",         
  "Graphics and virtual set systems",        
   "Streaming and encoding platforms",         
   "Production automation and control"       ]   
     },    
      {      
      id: "sound-masking",      
       urlSlug: "sound-masking",      
        title: "Sound Masking & Acoustic Solutions",       
        titleAr: "حلول إخفاء الصوت والصوتيات",      
         shortDesc: "Acoustic treatments and sound masking systems for privacy and noise control.",      
          mainImage: "/image/smas.jpg",      
           images: ["/image/av-6.jpg", "/image/av-1.jpg", "/image/av-4.jpg"],       
           fullDescription: `Our Sound Masking & Acoustic Solutions provide comprehensive noise control and speech privacy systems that improve workplace productivity, protect confidential communications, and create comfortable acoustic environments in offices, healthcare facilities, and commercial spaces.
We design and install sound masking systems and acoustic treatments that address noise distractions, speech privacy concerns, and acoustic comfort creating productive environments that protect sensitive conversations.
Sound masking systems emit engineered background sound that reduces speech intelligibility and minimizes distractions from conversations and office noise. We install direct-field sound masking systems with ceiling-mounted emitters creating uniform masking sound throughout protected areas.
Acoustic modeling and design ensures optimal performance. We conduct acoustic measurements, analyze speech intelligibility, and model sound propagation creating designs that achieve target privacy levels and acoustic comfort.
Masking zones provide customized coverage. We create multiple masking zones with independent volume control accommodating varying acoustic requirements in different areas including open offices, private offices, conference rooms, and corridors.
Control systems provide centralized management. We install networked sound masking controllers supporting features including zone programming, scheduling, volume adjustment, and remote monitoring ensuring consistent operation and easy management.
Acoustic treatments complement sound masking. We specify and install acoustic ceiling tiles, wall panels, hanging baffles, and acoustic furniture absorbing sound energy and reducing reverberation creating comfortable acoustic environments.
Speech privacy measurement verifies system performance. We conduct articulation index (AI) measurements and privacy index calculations documenting compliance with privacy requirements and industry standards including ASTM E1130 and ANSI S3.5.
Healthcare privacy applications support HIPAA compliance. We design sound masking systems for healthcare facilities protecting patient privacy in examination rooms, nurse stations, waiting areas, and corridors meeting healthcare privacy requirements.
Financial services applications protect confidential information. We implement sound masking and acoustic treatments in banking centers, financial planning offices, and call centers protecting sensitive financial conversations.
Corporate applications improve workplace productivity. We install sound masking systems in open-plan offices, conference rooms, and executive areas reducing noise distractions and protecting confidential business discussions.
Legal and government applications support security requirements. We design high-privacy acoustic solutions for law offices, courthouses, embassies, and government facilities protecting attorney-client privilege and classified information.
Audio frequency optimization ensures comfort. We tune masking spectra to frequencies that effectively mask speech while maintaining comfort and avoiding irritation creating pleasant background sound environments.
Integration with building automation systems enables intelligent control. We connect sound masking systems to building management systems supporting occupancy-based control, scheduling, and energy management.
Paging integration allows emergency announcements. We design sound masking systems with paging override capabilities ensuring emergency announcements are clearly heard while maintaining privacy during normal operations.
Maintenance and adjustment services ensure ongoing performance. We provide regular system testing, masking level verification, emitter replacement, and system optimization maintaining effective sound masking throughout system life.
Installation includes comprehensive planning, ceiling surveys, emitter placement, cable infrastructure, system programming, tuning, and documentation ensuring professional installations and optimal acoustic performance.`,
features: [
"Direct-field sound masking systems",
"Acoustic treatments and panels",
"Speech privacy measurement",
"Multi-zone control and scheduling",
"Healthcare HIPAA compliance",
"Integration with building automation"
]
}
]
},
firefighting: {
title: "Fire Fighting",
titleAr: "مكافحة الحرائق",
description: "Advanced fire protection and suppression systems",
icon: "fa-fire",
mainImage: "/image/service-hvac.jpg",
urlSlug: "firefighting",
subServices: [
{
id: "fire-alarm",
urlSlug: "fire-alarm",
title: "Fire Alarm Systems",
titleAr: "أنظمة إنذار الحريق",
shortDesc: "Intelligent fire detection and alarm systems with advanced addressable technology.",
mainImage: "/image/fas.jpg",
images: ["/image/fire-1.jpg", "/image/fire-2.jpg", "/image/fire-3.jpg"],
fullDescription: `Our Fire Alarm Systems provide comprehensive fire detection and notification solutions protecting lives and property in buildings and facilities across Saudi Arabia, ensuring early fire detection and rapid emergency response.
We design and install fire alarm systems complying with Saudi Building Code (SBC 801), NFPA 72 National Fire Alarm and Signaling Code, and local Civil Defense requirements, ensuring code compliance and optimal system performance.
Addressable fire alarm systems provide precise fire location identification. We install intelligent addressable panels that individually monitor each device, providing exact location information and reducing false alarms through intelligent algorithms that analyze multiple sensor inputs.
Smoke detectors identify fire at early stages. We install photoelectric smoke detectors, ionization smoke detectors, and multi-criteria detectors combining multiple sensing technologies optimizing detection for various fire types and environments.
Heat detectors provide reliable detection in harsh environments. We install fixed-temperature heat detectors and rate-of-rise heat detectors suitable for areas where smoke detectors would generate false alarms including kitchens, parking garages, and industrial areas.
Flame detectors provide rapid response to open fires. We install UV/IR flame detectors for specialized applications including petroleum facilities, aircraft hangars, and areas with high ceilings where smoke may not reach conventional detectors quickly.
Manual call points enable occupants to report fires. We install break-glass manual stations at exits and strategic locations throughout buildings providing manual fire alarm activation capabilities.
Notification appliances alert building occupants. We install horn/strobe combinations, voice evacuation speakers, and visual notification devices ensuring occupants are alerted regardless of location or hearing ability, complying with accessibility requirements.
Fire alarm control panels serve as system command centers. We install advanced control panels with network capabilities, battery backup, redundant power supplies, and comprehensive monitoring ensuring reliable system operation.
Voice evacuation systems provide intelligible emergency instructions. We integrate voice alarm systems with fire detection allowing pre-recorded and live voice messages guiding occupants during evacuation.
Integration with building systems enables automated response. We connect fire alarm systems to HVAC shutdown, elevator recall, door hold-open release, emergency lighting activation, and security systems creating coordinated emergency responses.
Mass notification capabilities warn of various emergencies. We implement systems capable of alerting occupants to fires, severe weather, security threats, and other emergencies using existing fire alarm infrastructure.
Remote monitoring services provide 24/7 supervision. We connect fire alarm systems to central monitoring stations using multiple communication paths including IP networks, cellular, and telephone lines ensuring rapid emergency response.
Aspiration smoke detection protects sensitive environments. We install very early warning smoke detection systems (VESDA) for data centers, museums, archives, and clean rooms detecting smoke at incipient stages.
Wireless fire alarm systems simplify installation. We deploy wireless detectors and devices for retrofit installations, historic buildings, and locations where wired connections are impractical reducing installation time and costs.
Testing and commissioning verifies system operation. We conduct comprehensive tests including detector sensitivity testing, circuit verification, battery load testing, and emergency communication testing documenting all results.
Maintenance services ensure ongoing reliability. We provide regular inspection, testing, detector cleaning, battery replacement, and system upgrades maintaining fire alarm systems in optimal operating condition.`,       
features: [
"Addressable fire detection systems",        
 "Multi-criteria intelligent detectors",        
  "Voice evacuation integration",         
  "Remote monitoring and supervision",         
  "Integration with building systems",         
  "NFPA 72 and SBC 801 compliance"      
   ]     
  },     
  {       
  id: "sprinkler-systems",       
  urlSlug: "sprinkler-systems",       
  title: "Automatic Sprinkler Systems",       
  titleAr: "أنظمة الرشاشات الأوتوماتيكية",       
  shortDesc: "Wet, dry, pre-action, and deluge sprinkler systems for fire suppression.",       
  mainImage: "/image/aps.jpg",       
  images: ["/image/fire-2.jpg", "/image/fire-4.jpg", "/image/fire-5.jpg"],       
  fullDescription: `Our Automatic Sprinkler Systems provide reliable, automatic fire suppression protecting buildings and contents through rapid fire control and extinguishment, significantly reducing fire damage and life safety risks.
We design and install sprinkler systems complying with NFPA 13 (Standard for the Installation of Sprinkler Systems), NFPA 25 (Inspection, Testing, and Maintenance), Saudi Building Code, and insurance requirements ensuring code-compliant installations.
Wet pipe sprinkler systems provide simple, reliable fire protection. We install wet systems with water-filled pipes connected to fire sprinkler heads that operate individually when heat activates them, providing immediate response to fires.
Dry pipe sprinkler systems protect unheated spaces. We install dry systems using compressed air or nitrogen holding back water until sprinkler activation, protecting parking garages, warehouses, and outdoor areas from freezing damage.
Pre-action sprinkler systems provide double-interlock protection. We install pre-action systems requiring both fire detection activation and sprinkler head operation before water discharge, protecting data centers, museums, and areas with valuable contents from accidental discharge.
Deluge systems provide rapid-area protection. We install deluge systems with open sprinkler heads and control valves that release water throughout entire areas simultaneously, protecting high-hazard areas including aircraft hangars, chemical storage, and flammable liquid areas.
Sprinkler head selection optimizes performance. We specify sprinkler heads based on application including standard response, quick response, extended coverage, residential, and special application sprinklers ensuring appropriate fire protection.
Hydraulic calculations ensure adequate water supply. We perform comprehensive hydraulic calculations determining water supply requirements, pipe sizing, and system demand ensuring adequate pressure and flow throughout sprinkler systems.
Fire pumps provide required water pressure. We install electric and diesel fire pumps with controllers, jockey pumps, and comprehensive testing/monitoring capabilities ensuring reliable water supply for sprinkler systems.
Water storage includes fire water tanks and reservoirs. We design and install water storage facilities with adequate capacity for sprinkler system demand including fire department connections and testing capabilities.
Backflow preventers protect water supplies. We install backflow prevention devices preventing contamination of potable water supplies from fire protection systems complying with water utility requirements.
Fire department connections enable supplemental water supply. We install fire department connections (FDC) at accessible locations allowing fire departments to supply additional water to sprinkler systems during emergencies.
Monitoring and supervision provide status indication. We integrate sprinkler system supervisory switches monitoring valve position, water flow, air pressure, and tank level with fire alarm systems and building management systems.
Seismic bracing protects systems during earthquakes. We install comprehensive seismic bracing for sprinkler piping, equipment, and hangers complying with NFPA 13 seismic requirements ensuring system integrity during seismic events.
Testing and commissioning verifies installation. We conduct hydrostatic testing, main drain tests, flow tests, valve operation tests, and fire pump tests documenting system performance and code compliance.
Inspection and maintenance services ensure reliability. We provide regular sprinkler system inspections including quarterly, annual, and five-year testing requirements maintaining systems in code-compliant operating condition.
Retrofits and upgrades modernize existing systems. We upgrade obsolete sprinkler systems, replace deteriorated piping, install corrosion-resistant materials, and upgrade to current code requirements.`,       
features: [        
   "Wet, dry, pre-action, and deluge systems",        
    "Hydraulic calculations and design",        
     "Fire pump installation and testing",        
      "Seismic bracing and protection",        
       "NFPA 13 and NFPA 25 compliance",        
        "Comprehensive testing and commissioning"     
        ]    
       },     
       {      
        id: "fm200-systems",       
         urlSlug: "fm200-systems",       
         title: "Clean Agent Fire Suppression",       
         titleAr: "أنظمة الإطفاء بالعوامل النظيفة",       
         shortDesc: "FM-200, Novec 1230, and CO2 gas suppression systems for sensitive equipment.",       
         mainImage: "/image/cafs.jpg",       
         images: ["/image/fire-3.jpg", "/image/fire-1.jpg", "/image/fire-6.jpg"],       
         fullDescription: `Our Clean Agent Fire Suppression systems provide advanced fire protection for data centers, telecommunications facilities, server rooms, control rooms, and other areas containing sensitive electronic equipment where water-based suppression would cause unacceptable damage.
We design and install gaseous fire suppression systems using clean agents including FM-200 (HFC-227ea), Novec 1230 (FK-5-1-12), and Inergen (IG-541) that extinguish fires without leaving residue, minimizing downtime and equipment damage.
FM-200 systems provide rapid fire suppression. We install FM-200 systems that extinguish fires in 10 seconds or less through heat absorption and chemical reaction, protecting electronics, documents, and valuable assets without water damage.
Novec 1230 systems offer environmentally preferred protection. We install Novec systems with zero ozone depletion potential and minimal global warming impact providing sustainable fire suppression for environmentally conscious organizations.
Inergen systems use inert gas mixtures. We install Inergen systems that extinguish fires by reducing oxygen concentration while maintaining breathable atmosphere levels, providing safe fire protection in normally occupied areas.
CO2 fire suppression protects special hazards. We install carbon dioxide systems for flammable liquid storage, engine rooms, and industrial processes providing rapid fire extinguishment through oxygen displacement.
System design calculations ensure adequate protection. We perform agent quantity calculations, discharge time analysis, pressure calculations, and hazard analysis determining proper system sizing for protected areas.
Detection and control systems activate suppression. We integrate advanced fire detection with clean agent release controls including abort switches, manual release stations, and discharge indicators ensuring safe, reliable system operation.
Pre-discharge alarms provide evacuation warnings. We install audible and visual pre-discharge alarms giving personnel time to evacuate protected areas before agent discharge, ensuring occupant safety.
Enclosure integrity testing verifies protection. We conduct room integrity tests measuring air leakage rates ensuring protected spaces maintain agent concentration for required suppression times.
Pressure relief venting protects structures. We design and install pressure relief vents preventing structural damage from pressure increases during agent discharge.
Agent storage includes cylinders and manifolds. We install high-pressure storage cylinders, valve manifolds, and distribution piping delivering agent throughout protected spaces.
Battery room protection requires special considerations. We design suppression systems for battery rooms addressing hydrogen accumulation, ventilation requirements, and electrical considerations.
Data center protection includes structured approaches. We implement zoning strategies, sub-floor protection, and coordination with HVAC shutdown protecting entire data center environments.
Testing and commissioning includes discharge testing. We conduct full discharge tests when required, enclosure integrity tests, detector sensitivity tests, and control verification documenting system readiness.
Maintenance services ensure reliability. We provide regular system inspections including cylinder weighing, pressure monitoring, detector testing, and control verification maintaining code-compliant systems.
Recharge services restore discharged systems. We provide rapid agent recharge, cylinder replacement, and system restoration returning fire suppression systems to service quickly after discharge events.`,
features: [         
  "FM-200, Novec 1230, and Inergen systems",         
  "Data center and server room protection",        
   "Fast-acting fire suppression",        
    "Environmentally responsible agents",         
    "Integration with fire detection",         
    "NFPA 2001 compliance"       
    ]    
     },    
      {       
     id: "foam-systems",       
     urlSlug: "foam-systems",       
     title: "Foam Fire Suppression Systems",       
     titleAr: "أنظمة الإطفاء بالرغوة",       
     shortDesc: "Foam suppression for flammable liquids, aircraft hangars, and petrochemical facilities.",       
     mainImage: "/image/ffss.jpg",       
     images: ["/image/fire-4.jpg", "/image/fire-2.jpg", "/image/fire-5.jpg"],       
     fullDescription: `Our Foam Fire Suppression Systems provide specialized fire protection for flammable liquid hazards, aircraft hangars, petrochemical facilities, and industrial processes where conventional water-based suppression is ineffective.
We design and install foam systems complying with NFPA 11 (Standard for Low-, Medium-, and High-Expansion Foam), NFPA 409 (Aircraft Hangars), and industry-specific requirements providing effective fire suppression for challenging hazards.
Low-expansion foam systems protect flammable liquid storage. We install foam-water sprinkler systems, foam-water deluge systems, and fixed foam application systems protecting tank farms, loading racks, and process areas.
High-expansion foam systems provide volumetric protection. We install high-expansion foam generators that rapidly fill large spaces with foam providing fire suppression and vapor control for aircraft hangars, warehouses, and LNG facilities.
Foam concentrate selection matches hazards. We specify foam concentrates including AFFF (aqueous film-forming foam), AR-AFFF (alcohol-resistant), fluoroprotein, and fluorine-free foam based on fuel types and environmental considerations.
Aircraft hangar systems meet NFPA 409 requirements. We design comprehensive hangar protection systems including overhead foam-water deluge, under-wing foam application, and hangar door protection providing complete aircraft fire protection.
Proportioning systems ensure correct foam concentration. We install various proportioning methods including in-line inductors, balanced pressure proportioners, and pump proportioners maintaining proper foam concentrate percentages.
Storage and distribution infrastructure includes foam concentrate storage tanks, pumps, piping, and delivery systems. We design systems ensuring adequate foam supply for required discharge duration.
Foam discharge devices include foam makers, foam chambers, foam monitors, and specialized nozzles. We select discharge devices optimized for specific applications and hazards.
Helipad foam systems protect helicopter operations. We install foam suppression systems for helipad platforms including deluge systems, foam monitors, and remote actuation meeting aviation fire protection requirements.
Loading rack protection prevents fuel transfer fires. We design foam systems for tank truck and rail car loading facilities including automatic detection, foam application, and spillage control.
Process area protection addresses industrial hazards. We install foam systems protecting chemical processes, refining operations, and manufacturing facilities handling flammable liquids.
Testing and commissioning includes foam discharge tests. We conduct foam application tests, concentrate sample testing, proportioner verification, and detector testing documenting system performance.
Foam concentrate maintenance ensures readiness. We provide concentrate testing, storage tank inspection, proportioner calibration, and concentrate replacement maintaining foam system effectiveness.
Environmental considerations address foam disposal. We design systems considering foam runoff containment, treatment requirements, and environmental regulations managing foam disposal responsibly.
Training services prepare personnel. We provide operator training, emergency response procedures, and system operation instruction ensuring facility staff can effectively use foam suppression systems.
Integration with fire detection and alarm systems coordinates emergency response. We connect foam systems with detection, alarms, and auxiliary shutdown systems creating comprehensive fire protection strategies.`,       
features: [         
  "Low and high-expansion foam systems",         
  "Aircraft hangar protection",         
  "Flammable liquid storage protection",         
  "Automatic foam proportioning",        
   "NFPA 11 and NFPA 409 compliance",         
   "Environmental foam options"       
   ]
  },   
   {      
   id: "kitchen-suppression",       
   urlSlug: "kitchen-suppression",      
    title: "Kitchen Fire Suppression",      
     titleAr: "أنظمة إطفاء حرائق المطابخ",      
      shortDesc: "Automatic kitchen fire suppression systems for commercial cooking operations.",      
       mainImage: "/image/kfs.jpg",       
       images: ["/image/fire-5.jpg", "/image/fire-3.jpg", "/image/fire-6.jpg"],       
       fullDescription: `Our Kitchen Fire Suppression Systems provide specialized fire protection for commercial kitchens, restaurants, hotels, hospitals, and institutional food service operations protecting cooking equipment and preventing grease fires.
We design and install kitchen suppression systems complying with NFPA 96 (Standard for Ventilation Control and Fire Protection of Commercial Cooking Operations), NFPA 17A (Standard for Wet Chemical Extinguishing Systems), and local fire codes ensuring comprehensive cooking equipment protection.
Wet chemical suppression extinguishes grease fires. We install wet chemical systems using potassium-based agents that saponify cooking oils creating a barrier that prevents re-ignition while cooling hot surfaces.
Detection systems use specialized technologies. We install fusible link detection, pneumatic detection, and linear heat detection optimized for high-temperature cooking environments ensuring reliable fire detection.
Nozzle placement protects all hazards. We design nozzle layouts protecting fryers, ranges, grills, ovens, char-broilers, and exhaust hoods ensuring complete coverage of cooking equipment.
Automatic fuel/power shutoff prevents fire spread. We integrate gas valve shutoff, electric power disconnection, and solid fuel equipment shutdown with suppression system activation eliminating fuel sources.
Hood and duct protection prevents fire spread. We install nozzles within exhaust hoods and ductwork suppressing fires in grease accumulation areas preventing fire spread through ventilation systems.
Manual release stations provide backup activation. We install manual pull stations accessible to kitchen staff providing manual system activation if automatic detection fails or for early fire intervention.
System design considers appliance configurations. We design custom protection schemes for varied cooking equipment layouts ensuring proper agent coverage and suppression effectiveness.
Pre-engineered systems simplify installation. We install UL-300 listed pre-engineered systems for standard cooking configurations providing cost-effective protection for typical kitchen layouts.
Integration with fire alarm systems coordinates response. We connect kitchen suppression to building fire alarms ensuring building-wide notification when kitchen systems activate.
Exhaust system cleaning requirements are coordinated. We specify cleaning frequencies, duct access points, and fire protection measures supporting comprehensive kitchen fire safety programs.
Testing and inspection ensure readiness. We conduct semi-annual inspections including manual activation tests, detector inspection, nozzle verification, and agent cylinder weighing maintaining code-compliant systems.
Agent replacement after discharge restores protection. We provide rapid system recharge, nozzle cleaning, fusible link replacement, and system testing returning kitchens to service quickly.
Retrofits address equipment changes. We modify existing systems accommodating new cooking equipment, layout changes, and equipment replacements maintaining adequate fire protection.
Training services educate kitchen staff. We provide fire safety training, system operation instruction, and emergency procedures ensuring kitchen personnel understand fire protection systems and proper response.
Portable fire extinguishers complement fixed systems. We provide Class K wet chemical extinguishers positioned throughout kitchens for manual fire fighting of small fires.`,        
features: [        
 "Wet chemical suppression systems",        
  "UL-300 listed protection",        
   "Automatic fuel/power shutoff",        
    "Hood and duct fire suppression",         
    "NFPA 96 and NFPA 17A compliance",        
     "Semi-annual inspection service"       
     ]    
      },    
      {       
      id: "fire-pumps",      
       urlSlug: "fire-pumps",       
       title: "Fire Pump Systems",       
       titleAr: "أنظمة مضخات الحريق",       
       shortDesc: "Electric and diesel fire pumps with controllers and complete pump room installations.",       
       mainImage: "/image/fps.jpg",       
       images: ["/image/fire-6.jpg", "/image/fire-1.jpg", "/image/fire-4.jpg"],       
       fullDescription: `Our Fire Pump Systems provide reliable water supply for fire sprinkler systems, standpipe systems, and fire hydrant networks ensuring adequate water pressure and flow for fire suppression systems in buildings and facilities.
We design and install fire pump systems complying with NFPA 20 (Standard for the Installation of Stationary Pumps for Fire Protection), ensuring code-compliant installations that deliver reliable fire protection water supply.
Electric motor-driven fire pumps provide primary fire protection. We install horizontal split case pumps, vertical turbine pumps, and vertical inline pumps driven by electric motors with automatic controllers ensuring reliable operation.
Diesel engine-driven fire pumps provide backup or primary power. We install diesel fire pumps with complete fuel systems, cooling systems, exhaust systems, and starting systems providing fire pump operation independent of building electrical power.
Fire pump controllers provide automatic operation. We install electric fire pump controllers and diesel engine controllers with automatic start capabilities, pressure sensors, and comprehensive monitoring ensuring pumps start automatically when needed.
Jockey pumps maintain system pressure. We install small jockey pumps that maintain normal system pressure preventing unnecessary fire pump starts while ensuring instant water availability.
Suction supply arrangements ensure adequate water. We design and install suction piping, suction tanks, and connections to water mains providing reliable water supply to fire pumps under all conditions.
Discharge piping includes proper components. We install discharge piping with check valves, OS&Y valves, pressure gauges, test headers, and flow meters enabling testing and operation verification.
Fire pump rooms meet code requirements. We design pump rooms with proper ventilation, drainage, lighting, and environmental conditions ensuring optimal fire pump installation conditions.
Testing and commissioning verifies performance. We conduct comprehensive fire pump acceptance tests including rated flow tests, churn tests, peak flow tests, and controller function tests documenting pump performance curves.
Weekly testing maintains readiness. We implement automatic weekly test programs that run fire pumps verifying readiness without full flow discharge reducing testing burden.
Flow testing validates system performance. We conduct annual full-flow tests measuring pump performance at churn, rated flow, and peak flow conditions documenting continued code compliance.
Remote monitoring supervises operation. We install monitoring systems that transmit pump operation, trouble conditions, and supervisory signals to monitoring stations and building management systems.
Redundant fire pumps provide reliability. We design systems with multiple fire pumps providing backup capability ensuring fire protection water supply even if primary pumps fail.
Maintenance services ensure reliability. We provide regular pump maintenance including lubrication, coupling alignment, seal inspection, diesel engine maintenance, and battery testing keeping fire pumps operational.
Emergency repair services minimize downtime. We maintain emergency response capabilities providing rapid fire pump repair, component replacement, and restoration services.
Retrofits and upgrades modernize installations. We replace obsolete fire pumps, upgrade controllers, install monitoring systems, and modify installations meeting current code requirements.`,
features: [
"Electric and diesel fire pumps",
"NFPA 20 compliant installations",
"Automatic controllers and monitoring",
"Complete pump room design",
"Annual flow testing and certification",
"24/7 emergency repair service"
]
}
]
},
maintenance: {
title: "Maintenance & Operations",
titleAr: "الصيانة والعمليات",
description: "Facility maintenance and operational support",
icon: "fa-wrench",
mainImage: "/image/service-maint.jpg",
urlSlug: "maintenance",
subServices: [
{
id: "preventive-maintenance",
urlSlug: "preventive-maintenance",
title: "Preventive Maintenance Programs",
titleAr: "برامج الصيانة الوقائية",
shortDesc: "Scheduled maintenance programs reducing downtime and extending equipment life.",
mainImage: "/image/pmp.jpg",
images: ["/image/maint-1.jpg", "/image/maint-2.jpg", "/image/maint-3.jpg"],
fullDescription: `Our Preventive Maintenance Programs provide systematic, scheduled maintenance services that reduce equipment failures, minimize downtime, extend asset life, and optimize facility performance across industrial, commercial, and institutional facilities.
We develop and implement comprehensive preventive maintenance programs covering all facility systems including electrical, mechanical, HVAC, plumbing, fire protection, and building automation ensuring reliable operation and regulatory compliance.
Maintenance scheduling is customized to equipment requirements. We create maintenance calendars based on manufacturer recommendations, operational demands, regulatory requirements, and equipment criticality ensuring appropriate maintenance frequencies.
Electrical system maintenance includes regular inspection and testing of switchgear, transformers, circuit breakers, UPS systems, generators, lighting systems, and power distribution equipment. We perform thermographic surveys, insulation resistance testing, contact resistance measurements, and protective device testing.
Mechanical system maintenance covers HVAC equipment, pumps, motors, compressors, cooling towers, and process equipment. We conduct bearing lubrication, belt replacement, alignment checks, vibration analysis, and performance testing maintaining optimal mechanical system operation.
HVAC maintenance programs optimize comfort and efficiency. We service air handling units, chillers, boilers, fan coil units, VAV boxes, and control systems including filter changes, coil cleaning, refrigerant management, and control calibration.
Plumbing system maintenance prevents failures. We inspect and service water supply systems, drainage systems, fixtures, pumps, water heaters, and backflow preventers maintaining reliable plumbing infrastructure.
Fire protection system maintenance ensures life safety. We conduct inspections and testing of fire alarm systems, sprinkler systems, fire pumps, emergency lighting, and fire extinguishers maintaining code-compliant fire protection.
Building automation system maintenance includes controller verification, sensor calibration, software updates, and sequence of operations verification optimizing automated building control.
Roof maintenance prevents water infiltration. We conduct roof inspections, drainage cleaning, membrane repairs, and preventive treatments extending roof life and preventing costly water damage.
Predictive maintenance technologies identify emerging issues. We utilize vibration analysis, infrared thermography, ultrasonic testing, and oil analysis detecting equipment problems before failures occur.
Maintenance documentation tracks all activities. We maintain detailed maintenance records including work orders, inspection reports, test results, parts replacement history, and recommendations supporting asset management decisions.
Regulatory compliance testing ensures code adherence. We conduct required testing and inspections mandated by local authorities, insurance companies, and regulatory agencies maintaining facility compliance.
Emergency response capabilities minimize downtime. We maintain 24/7 emergency response providing rapid service for critical failures ensuring minimal disruption to operations.
Parts inventory management ensures availability. We maintain critical spare parts inventories, manage vendor relationships, and expedite procurement ensuring rapid equipment restoration.
Training services develop in-house capabilities. We provide technical training to facility staff, share best practices, and transfer knowledge building client maintenance competencies.
Performance reporting demonstrates value. We provide regular reports documenting maintenance activities, equipment performance trends, cost analysis, and recommendations supporting continuous improvement.`,       
features: [         
"Comprehensive multi-trade maintenance",         
"Customized maintenance schedules",         
"Predictive maintenance technologies",         
"24/7 emergency response",         
"Regulatory compliance testing",         
"Detailed maintenance documentation"      
]
},
{       
id: "facility-management",
urlSlug: "facility-management",
title: "Integrated Facility Management",
titleAr: "إدارة المرافق المتكاملة",
shortDesc: "Complete facility management including maintenance, operations, and support services.",       
mainImage: "/image/ifm.jpg",
images: ["/image/maint-2.jpg", "/image/maint-4.jpg", "/image/maint-5.jpg"],
fullDescription: `Our Integrated Facility Management services provide comprehensive facility operations and maintenance solutions enabling organizations to focus on core business while we manage all aspects of facility performance, maintenance, and support services.
We deliver integrated FM services covering hard services (technical maintenance), soft services (housekeeping, security, landscaping), and facility administration creating single-source facility management solutions.
Technical maintenance encompasses all building systems. We provide maintenance for electrical, mechanical, HVAC, plumbing, fire protection, elevators, building automation, and specialized equipment ensuring reliable facility operations.
HVAC operations optimization reduces energy costs. We manage HVAC systems implementing energy-efficient operating strategies, monitoring performance, and adjusting systems based on occupancy and weather conditions.
Energy management programs reduce utility costs. We monitor energy consumption, identify waste, implement conservation measures, and track savings delivering measurable cost reductions.
Housekeeping services maintain clean environments. We provide cleaning services for offices, common areas, restrooms, floors, windows, and specialized areas maintaining professional facility appearance.
Security services protect assets and people. We manage access control, surveillance systems, security personnel, visitor management, and incident response ensuring secure facilities.
Landscaping and grounds maintenance enhance property appearance. We maintain lawns, irrigation systems, plantings, hardscapes, and outdoor amenities presenting attractive facility exteriors.
Pest control services protect health and property. We implement integrated pest management programs preventing and eliminating pest problems without excessive chemical usage.
Waste management services ensure proper disposal. We manage waste collection, recycling programs, hazardous waste handling, and contractor coordination supporting environmental compliance.
Space management optimizes facility utilization. We track space allocation, manage moves and changes, maintain space databases, and analyze utilization supporting real estate decisions.
Helpdesk services provide single-point contact. We operate helpdesk facilities receiving service requests, dispatching technicians, tracking work orders, and communicating status ensuring responsive service.
Vendor management coordinates contractors. We manage relationships with specialized contractors, negotiate agreements, oversee performance, and ensure quality maintaining comprehensive vendor networks.
Asset management tracks facility investments. We maintain asset registers, track maintenance history, plan capital replacements, and optimize asset lifecycle costs supporting financial planning.
Sustainability programs support environmental goals. We implement green cleaning, energy conservation, water management, waste reduction, and environmental reporting supporting corporate sustainability objectives.
Regulatory compliance ensures code adherence. We maintain facility compliance with building codes, fire codes, health regulations, environmental regulations, and safety standards avoiding violations and penalties.
Performance reporting provides transparency. We deliver regular reports documenting service levels, cost performance, energy consumption, project completion, and recommendations demonstrating value.`,
features: [
"Hard and soft facility services",
"Energy management and optimization",
"Security and access control",
"Housekeeping and grounds maintenance",
"Helpdesk and work order management",
"Vendor coordination and management"
]     
},    
{
id: "shutdown-maintenance",
urlSlug: "shutdown-maintenance",
title: "Plant Shutdowns & Turnarounds",
titleAr: "توقفات المصانع والصيانة الدورية",
shortDesc: "Planned shutdown maintenance for industrial facilities and process plants.",
mainImage: "/image/pst.jpg",
images: ["/image/maint-3.jpg", "/image/maint-1.jpg", "/image/maint-6.jpg"],
fullDescription: `Our Plant Shutdowns & Turnarounds services provide comprehensive planning, coordination, and execution of scheduled maintenance outages for industrial facilities, refineries, petrochemical plants, and power generation facilities.
We manage all aspects of shutdown projects including planning, scheduling, resource management, execution, and project closeout ensuring safe, efficient completion within budget and timeline constraints.
Shutdown planning begins months in advance. We develop detailed scope definitions, work breakdowns, resource requirements, material lists, and execution strategies ensuring thorough preparation.
Critical path scheduling optimizes duration. We create detailed schedules identifying critical paths, parallel work opportunities, and resource leveling minimizing shutdown duration and production losses.
Resource mobilization assembles skilled teams. We recruit and mobilize specialized tradespeople, supervisors, engineers, and support personnel providing adequate resources for shutdown execution.
Safety planning ensures incident-free execution. We develop comprehensive safety plans including hazard assessments, permit systems, emergency procedures, and safety training protecting workers and facilities.
Equipment isolation implements lockout/tagout. We develop and execute isolation procedures ensuring equipment is safely isolated from energy sources, process materials, and utilities before work begins.
Inspection services identify maintenance needs. We coordinate non-destructive testing, equipment inspection, pressure vessel certification, and condition assessment documenting equipment condition.
Maintenance execution includes major overhauls. We perform equipment overhauls, component replacements, preventive maintenance, modifications, and repairs maximizing maintenance accomplished during outages.
Quality control ensures work quality. We implement inspection programs, witness testing, documentation requirements, and quality audits verifying maintenance work meets specifications.
Coordination meetings maintain alignment. We conduct daily coordination meetings, safety briefings, and progress reviews keeping all stakeholders informed and aligned throughout shutdowns.
Material management ensures availability. We procure materials, manage inventory, coordinate deliveries, and control materials supporting efficient maintenance execution without delays.
Contractor management coordinates multiple teams. We manage numerous specialty contractors, coordinate interfaces, resolve conflicts, and ensure collaboration maintaining project momentum.
Commissioning and startup restore operations. We develop startup procedures, conduct system checks, witness equipment startups, and coordinate transitions returning facilities to operation safely.
Post-shutdown reviews capture lessons learned. We conduct project reviews documenting performance, identifying improvement opportunities, and capturing knowledge supporting future shutdowns.
Cost control maintains budgets. We track costs, manage change orders, control expenditures, and report financial performance ensuring shutdown projects remain within approved budgets.
Documentation deliverables provide records. We compile maintenance records, inspection reports, test certificates, as-built drawings, and closeout documentation maintaining comprehensive project records.`,
features: [
"Comprehensive shutdown planning",
"Critical path scheduling",
"Multi-trade resource mobilization",
"Safety management and permits",
"Equipment inspection and overhaul",
"On-time, on-budget execution"
]
}
]
}
};


// Main App Component
const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');
  const [currentService, setCurrentService] = useState(null);
  const [currentSubService, setCurrentSubService] = useState(null);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [counters, setCounters] = useState({ years: 0, projects: 0, clients: 0 });
  const [showAllServices, setShowAllServices] = useState(false);
  const servicesRef = useRef(null);
  const dropdownTimerRef = useRef(null);
const fullArabicName = "مؤسسة حصة عبدالله عوض الزهراني للمقاولات";
    const fullEnglishName = "Hessa Abdullah Awadh Al-Zahrani Contracting Est.";

    const mainServices = [
      { id: 1, title: "Electrical Works", image: "/image/service-electrical.jpg", details: "Industrial power distribution, efficient lighting design, substation construction, and high-voltage cable installation.", serviceKey: "electrical" },
      { id: 2, title: "Civil Works & Infrastructure", image: "/image/service-civil.jpg", details: "Foundations, structural steel erection, infrastructure, and site preparation.", serviceKey: "civil" },
      { id: 3, title: "Mechanical & Plumbing", image: "/image/service-mech.jpg", details: "Piping, HVAC ducting, plumbing systems, and fire protection installations.", serviceKey: "mechanical" },
      { id: 4, title: "Fire Fighting", image: "/image/service-hvac.jpg", details: "Design and install industrial HVAC, chiller units, and fire suppression systems.", serviceKey: "firefighting" },
      { id: 5, title: "Instrumentation Systems", image: "/image/service-inst.jpg", details: "Field instruments, control valves, DCS/PLC panel installations, and loop checking.", serviceKey: "instrumentation" },
      { id: 6, title: "Telecom & Data Networks", image: "/image/service-telecom.jpg", details: "Fiber optics, copper systems, CCTV, and tower erections.", serviceKey: "telecom" },
      { id: 7, title: "Maintenance & Operations", image: "/image/service-maint.jpg", details: "Long-term maintenance, facility management, shutdowns, and plant operations.", serviceKey: "maintenance" },
      { id: 8, title: "QHSE Compliance", image: "/image/service-qhse.jpg", details: "Certified Quality, Health, Safety & Environmental standards and audits.", serviceKey: "qhse" },
      { id: 9, title: "Information & Communication Technology", image: "/image/info.jpg", details: "Complete ICT solutions covering communication systems, networking, wireless, structured cabling, fiber optics, and advanced data-center technologies.", serviceKey: "ict" },
      { id: 10, title: "ELV Solution", image: "/image/elv.jpg", details: "Preventive maintenance, facility management, shutdowns, and complete plant operations.", serviceKey: "elv" },
      { id: 11, title: "Audio Visual System", image: "/image/avs.jpg", details: "Advanced audio-visual solutions for conferencing, automation, e-learning, smart classrooms, digital signage, and security applications.", serviceKey: "av" },
    ];

    const visibleServices = showAllServices ? mainServices : mainServices.slice(0, 6);

    useEffect(() => {
      const handleScroll = () => {
        setScrolled(window.scrollY > 50);
        setShowBackToTop(window.scrollY > 300);
        
        const elements = document.querySelectorAll('.fade-in-section');
        elements.forEach(el => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.85) {
            el.classList.add('is-visible');
          }
        });
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateCounters();
          }
        });
      }, { threshold: 0.5 });

      const statsSection = document.getElementById('stats-section');
      if (statsSection) observer.observe(statsSection);

      return () => observer.disconnect();
    }, []);

    useEffect(() => {
    const path = location.pathname;
    
    if (path === '/' || path === '') {
      setCurrentPage('home');
      setCurrentService(null);
      setCurrentSubService(null);
    } else if (path.startsWith('/service/')) {
      const parts = path.split('/').filter(Boolean);
      
      if (parts.length === 2) {
        // Service page (e.g., /service/electrical)
        setCurrentPage('service');
        setCurrentService(parts[1]);
        setCurrentSubService(null);
      } else if (parts.length === 3) {
        // Sub-service page (e.g., /service/electrical/power-distribution)
        setCurrentPage('subservice');
        setCurrentService(parts[1]);
        setCurrentSubService(parts[2]);
      }
    }
    
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [location.pathname]);

    const animateCounters = () => {
      const targets = { years: 3, projects: 45, clients: 97 };
      const increment = { years: targets.years / 50, projects: targets.projects / 50, clients: targets.clients / 50 };
      let frame = 0;

      const animate = () => {
        frame++;
        setCounters({
          years: Math.min(Math.floor(increment.years * frame), targets.years),
          projects: Math.min(Math.floor(increment.projects * frame), targets.projects),
          clients: Math.min(Math.floor(increment.clients * frame), targets.clients)
        });

        if (frame < 50) requestAnimationFrame(animate);
      };

      animate();
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const navigateToPage = (page) => {
      navigate("/");
      setCurrentPage(page);
      setCurrentService(null);
      setCurrentSubService(null);
      setMobileMenuOpen(false);
      setServicesDropdownOpen(false);
      window.scrollTo(0, 0);
    };

    const navigateToService = (serviceKey) => {
        navigate(`/service/${serviceKey}`);
      setCurrentPage('service');
      setCurrentService(serviceKey);
      setCurrentSubService(null);
      setMobileMenuOpen(false);
      setServicesDropdownOpen(false);
      window.scrollTo(0, 0);
    };

    const navigateToSubService = (serviceKey, subServiceSlug) => {
      navigate(`/service/${serviceKey}/${subServiceSlug}`);
      setCurrentPage('subservice');
      setCurrentService(serviceKey);
      setCurrentSubService(subServiceSlug);
      setMobileMenuOpen(false);
      setServicesDropdownOpen(false);
      window.scrollTo(0, 0);
    };
    const navigateToSection = (sectionId) => {
  if (currentPage !== 'home') {
    setCurrentPage('home');
    setCurrentService(null);
    setCurrentSubService(null);
    setMobileMenuOpen(false);
    setServicesDropdownOpen(false);
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  } else {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setMobileMenuOpen(false);
    setServicesDropdownOpen(false);
  }
};

    const toggleServices = () => {
      setShowAllServices(!showAllServices);
      if (!showAllServices && servicesRef.current) {
        setTimeout(() => {
          servicesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    };

    const toggleServicesDropdown = (e) => {
      e.preventDefault();
      setServicesDropdownOpen(!servicesDropdownOpen);
    };

    const handleServicesMouseEnter = () => {
      if (dropdownTimerRef.current) {
        clearTimeout(dropdownTimerRef.current);
      }
      setServicesDropdownOpen(true);
    };

    const handleServicesMouseLeave = () => {
      dropdownTimerRef.current = setTimeout(() => {
        setServicesDropdownOpen(false);
      }, 150);
    };

    const customStyles = `
      * { 
  box-sizing: border-box; 
  margin: 0; 
  padding: 0; 
}

body { 
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
  overflow-x: hidden;
  scroll-behavior: smooth;
}

:root {
  --primary-color: #002B5B;
  --accent-color: rgba(227, 27, 35, 1);
  --text-dark: #d41616ff;
  --text-light: #720202ff;
  --bg-light: #f8fafaff;
}

.modern-navbar {
  background: linear-gradient(135deg, #002B5B 0%, #001a3d 100%);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.navbar-scrolled {
  padding: 8px 0 !important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
}

.navbar-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 15px;
  color: white;
  text-decoration: none;
  cursor: pointer;
}

.logo-icon {
  width: 50px;
  height: 50px;
  background: var(--accent-color);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.logo-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.logo-text h1 {
  font-size: 16px;
  color: rgba(219, 0, 0, 1) ;
  margin: 0;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 1px 1px 2px rgba(184, 4, 4, 0.5);
}

.logo-text p {
  font-size: 18px;
  color: rgba(255, 255, 255, 1);
  margin: 0;
  direction: rtl;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 50px;
}

.nav-links {
  display: flex;
  gap: 5px;
  list-style: none;
  align-items: center;
}

.nav-links a,
.nav-links button {
  color: white;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 14px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
}

.nav-links a:hover,
.nav-links button:hover {
  background: var(--accent-color);
  color: white;
  transform: translateY(-2px);
}

.services-dropdown {
  position: relative;
}

.services-dropdown-btn {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 5px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(36, 23, 153, 0.2);
  min-width: 280px;
  max-height: 700px;  
  overflow-y: auto;   
  overflow-x: hidden;
  overflow: hidden;
  animation: dropdownSlide 0.2s ease;
  z-index: 1001;
}

@keyframes dropdownSlide {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.dropdown-menu button {
  width: 100%;
  background: none;
  border: none;
  padding: 15px 20px;
  text-align: left;
  cursor: pointer;
  color: var(--primary-color);
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #21004dff;
}

.dropdown-menu button:last-child {
  border-bottom: none;
}

.dropdown-menu button:hover {
  background: var(--bg-light);
  padding-left: 25px;
  color: var(--accent-color);
}

.dropdown-menu button i {
  color: var(--accent-color);
  font-size: 18px;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 22px;
  cursor: pointer;
}

.mobile-menu {
  display: none;
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #fc343eff 0%, #eef2f7ff 100%);
  padding: 0px;
  box-shadow: 0 10px 30px rgba(1, 2, 73, 0.3);
  z-index: 999;
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  pointer-events: auto !important;
}

.mobile-menu.active {
  display: block;
  animation: slideDown 0.3s ease;
}

.mobile-menu a,
.mobile-services-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
  text-decoration: none;
  padding: 15px;
  border-radius: 0x; !important;
  margin-bottom:  0px; !important;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #c62828 0%, #8B0000 100%) !important;
  border: none; !important;
   border-bottom: 1px solid rgba(29, 2, 59, 0.9) !important;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  font-family: inherit;
  pointer-events: auto !important; 
  position: relative; 
  z-index: 10
}

.mobile-services-btn {
  justify-content: space-between;
}

.mobile-menu a:hover,
.mobile-services-btn:hover {
  background: linear-gradient(135deg, #ff7070e8 0%, #a80202ff ) !important;
  color: black !important;
  transform: translateX(0px);
}

.mobile-dropdown {
  margin-left: 20px;
  margin-bottom: 10px;
}

.mobile-dropdown button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  width: 100%;
  background: rgba(44, 4, 138, 0.82);
  border: none;
  color: white;
  padding: 4px 8px;
  border-radius: 18px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.mobile-dropdown button:hover {
  background: var(--accent-color);
  color: white;
}

.service-name-en {
  font-size: 16px;
  font-weight: 600;
  direction: rtl;
}

.service-name-ar {
  font-size: 11px;
  opacity: 100%;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.hero-section {
  position: relative;
  height: 100vh;
  min-height: 250px;
  margin-top: 55px;
  overflow: hidden;
  background: #fcf9f9ff;
}

.hero-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.6);
}

.hero-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  padding: 20px;
  z-index: 2;
}

.hero-content h1 {
  font-size: 56px;
  font-weight: 800;
  margin-bottom: 20px;
  color: var(--accent-color);
  text-shadow: 2px 2px 10px rgba(245, 242, 242, 0.5);
  animation: fadeInUp 1s ease;
}

.hero-content p {
  font-size: 24px;
  margin-bottom: 40px;
  max-width: 800px;
  animation: fadeInUp 1.2s ease;
  line-height: 1.6;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  animation: fadeInUp 1.4s ease;
  flex-wrap: wrap;
  justify-content: center;
}

.btn-primary, .btn-secondary, .btn-social {
  padding: 15px 40px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: inherit;
}

.btn-primary {
  background: var(--accent-color);
  color: white;
}

.btn-primary:hover {
  background: #c71820;
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(227,27,35,0.3);
}

.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background: white;
  color: var(--primary-color);
  transform: translateY(-3px);
}

.btn-social {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  color: white;
}

.btn-social:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(37,211,102,0.3);
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(30px); } 
  to { opacity: 1; transform: translateY(0); }
}

.social-connect-modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  z-index: 10000;
  align-items: center;
  justify-content: center;
}

.social-connect-modal.active {
  display: flex;
  animation: fadeIn 0.3s ease;
}

.social-connect-content {
  background: white;
  padding: 40px;
  border-radius: 20px;
  max-width: 400px;
  width: 90%;
  position: relative;
  animation: modalSlideUp 0.3s ease;
}

@keyframes modalSlideUp {
  from { opacity: 0; transform: translateY(50px); }
  to { opacity: 1; transform: translateY(0); }
}

.close-social-modal {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-light);
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-social-modal:hover {
  color: var(--primary-color);
  transform: rotate(90deg);
}

.social-connect-content h3 {
  text-align: center;
  color: var(--primary-color);
  margin-bottom: 30px;
  font-size: 28px;
}

.social-icons-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.social-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 30px 20px;
  border-radius: 15px;
  text-decoration: none;
  color: white;
  transition: all 0.3s ease;
  font-weight: 600;
}

.social-icon i {
  font-size: 48px;
}

.social-icon.whatsapp {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
}

.social-icon.whatsapp:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(37,211,102,0.3);
}

.social-icon.linkedin {
  background: linear-gradient(135deg, #0077B5 0%, #00669C 100%);
}

.social-icon.linkedin:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0,119,181,0.3);
}

.stats-section {
  background: linear-gradient(135deg, var(--primary-color) 0%, #001a3d 100%);
  padding: 80px 20px;
  color: white;
}

.stats-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  text-align: center;
}

.stat-item {
  padding: 30px;
  border-radius: 15px;
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.stat-item:hover {
  transform: translateY(-10px);
  background: rgba(255,255,255,0.15);
  box-shadow: 0 15px 35px rgba(0,0,0,0.2);
  border-color: var(--accent-color);
}

.stat-number {
  font-size: 56px;
  font-weight: 800;
  color: var(--accent-color);
  margin-bottom: 10px;
}

.stat-label {
  font-size: 18px;
  font-weight: 500;
  opacity: 0.9;
}

.stat-icon {
  font-size: 48px;
  margin-bottom: 20px;
  color: var(--accent-color);
}

.content-section {
  max-width: 1400px;
  margin: 0 auto;
  padding: 100px 30px;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 42px;
  color: var(--primary-color);
  margin-bottom: 15px;
  font-weight: 700;
  position: relative;
  display: inline-block;
}

.section-header h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: var(--accent-color);
  border-radius: 2px;
}

.section-header .underline {
  width: 100px;
  height: 4px;
  background: var(--accent-color);
  margin: 0 auto 20px;
  border-radius: 2px;
}

.section-header p {
  font-size: 18px;
  color: var(--text-light);
  max-width: 700px;
  margin: 0 auto;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.service-card {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
  transition: all 0.4s ease;
  position: relative;
  border: 2px solid transparent;
  cursor: pointer;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(8, 10, 87, 0.2);
  border-color: var(--accent-color);
}

.service-image-container {
  position: relative;
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.service-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.service-card:hover .service-image {
  transform: scale(1.1);
}

.service-badge {
  position: absolute;
  top: 20px;
  left: 20px;
  background: var(--accent-color);
  color: white;
  padding: 8px 20px;
  border-radius: 25px;
  font-weight: 700;
  font-size: 14px;
  z-index: 2;
}

.service-content {
  padding: 30px;
}

.service-content h3 {
  font-size: 24px;
  color: var(--primary-color);
  margin-bottom: 15px;
  font-weight: 700;
}

.service-content p {
  color: var(--text-light);
  line-height: 1.7;
  font-size: 15px;
}

.show-more-btn {
  display: block;
  margin: 40px auto 0;
  padding: 15px 40px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.show-more-btn:hover {
  background: var(--accent-color);
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(24, 7, 102, 0.3);
}

.mv-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 40px;
}

.mv-card {
  background: linear-gradient(135deg, var(--primary-color) 0%, #001a3d 100%);
  padding: 40px;
  border-radius: 15px;
  color: white;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.mv-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0,0,0,0.25);
  border-color: var(--accent-color);
}

.mv-card h3 {
  font-size: 28px;
  color: var(--accent-color);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.mv-card p {
  line-height: 1.8;
  font-size: 16px;
}

.contact-section {
  background: var(--bg-light);
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  margin-top: 40px;
}

.contact-info {
  background: white;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(241, 237, 237, 0.99);
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.contact-info:hover {
  border-color: var(--accent-color);
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 30px;
}

.contact-icon {
  width: 50px;
  height: 50px;
  background: var(--accent-color);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  flex-shrink: 0;
}

.contact-details h4 {
  color: var(--primary-color);
  margin-bottom: 5px;
  font-size: 18px;
}

.contact-details p,
.contact-details a {
  color: var(--text-light);
  margin: 0;
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-details a:hover {
  color: var(--accent-color);
}

.contact-form {
  background: white;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(36, 27, 155, 0.1);
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.contact-form:hover {
  border-color: var(--accent-color);
}

.form-group {
  margin-bottom: 25px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 15px;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--accent-color);
  box-shadow: 0 0 0 3px rgba(199, 19, 25, 0.1);
}

.form-group textarea {
  min-height: 150px;
  resize: vertical;
}

.submit-btn {
  width: 100%;
  padding: 15px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.submit-btn:hover {
  background: var(--accent-color);
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(2, 2, 2, 0.3);
}

.footer {
  background: linear-gradient(135deg, var(--primary-color) 0%, #000814 100%);
  color: white;
  padding: 60px 30px 30px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section h3 {
  color: var(--accent-color);
  margin-bottom: 20px;
  font-size: 20px;
}

.footer-section p,
.footer-section a,
.footer-section button {
  color: rgba(255, 255, 255, 1);
  line-height: 2.2;
  text-decoration: none;
  display: block;
  margin-bottom: 15px;
  transition: all 0.3s ease;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  background: none;
  border: none;
  text-align: left;
  padding: 0;
}

.footer-section a:hover,
.footer-section button:hover {
  color: var(--accent-color);
  transform: translateX(5px);
}

.footer-bottom {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(114, 10, 10, 1);
  color: rgba(255, 255, 255, 1);
}

.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: var(--accent-color);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 5px 15px rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
  z-index: 999;
  display: none;
}

.back-to-top.show {
  display: block;
  animation: fadeIn 0.3s ease;
}

.back-to-top:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(255, 255, 255, 1);
}

.floating-social-icons {
  position: fixed;
  bottom: 90px;
  right: 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 999;
}

.floating-social-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  animation: fadeIn 0.3s ease;
  text-decoration: none;
}

.floating-social-btn.whatsapp {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
}

.floating-social-btn.linkedin {
  background: linear-gradient(135deg, #5019e7ff 0%, #00669C 100%);
}

.floating-social-btn:hover {
  transform: translateY(-5px) scale(1.1);
  box-shadow: 0 10px 25px rgba(3, 138, 156, 0.56);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.fade-in-section {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.fade-in-section.is-visible {
  opacity: 1;
  transform: translateY(0);
}

.cert-container {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(248, 248, 248, 0.1);
  margin-top: 40px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.cert-container:hover {
  border-color: var(--accent-color);
}

.cert-image {
  max-width: 800px;
  width: 100%;
  height: auto;
  border-radius: 10px;
  border: 4px solid var(--accent-color);
}

.service-page-header {
  background: linear-gradient(135deg, #002B5B 0%, #001a3d 100%);
  padding: 80px 20px;
  text-align: center;
  color: white;
  margin-top: 80px;
}

.service-page-header h1 {
  font-size: 48px;
  margin-bottom: 20px;
  color: var(--accent-color);
}

.service-page-header p {
  font-size: 18px;
  max-width: 800px;
  margin: 0 auto;
}

html, body {
    max-width: 100% !important;
    overflow-x: hidden !important;
}

* {
    box-sizing: border-box;
}

@media (max-width: 992px) {
    /* Navigation: Switches to Mobile Menu */
    .nav-links { 
        display: none; 
    }
    
    .mobile-menu-btn { 
        display: block; 
    }

    /* Hero Section: Font size adjusted for large phones/small tablets */
    .hero-content h1 { 
        font-size: 40px; 
        line-height: 1.2;
    }
    
    .hero-content p { 
        font-size: 18px; 
    }
    
    /* Layout Adjustments */
    .contact-grid { 
        grid-template-columns: 1fr; 
    }
    
    .section-header h2 { 
        font-size: 36px; 
    }
    
    .services-grid {
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    }
    
    .social-icons-grid {
        grid-template-columns: 1fr;
    }

    /* General Padding */
    .content-section { 
        padding: 60px 25px; 
    }
}
    

@media (max-width: 600px) {
    
    /* Hero Section: Smaller Text */
    .hero-content h1 { 
        font-size: 28px; 
        line-height: 1.2;
    }
    
    .hero-content p { 
        font-size: 15px; 
    }
    
    /* Hero Buttons: Stacked Layout */
    .hero-buttons { 
        flex-direction: column; 
        width: 100%; 
        align-items: stretch;
        gap: 12px; 
        margin-top: 15px;
    }
    
    /* Button Sizing */
    .btn-primary, .btn-secondary, .btn-social { 
        width: 100%; 
        justify-content: center;
        text-align: center;
        padding: 12px 0; 
    }
    
    /* CRITICAL NAVBAR FIX - Horizontal Scrolling Removed */
    .navbar {
        width: 100%;
        overflow-x: hidden;
    }
    
    .navbar-content {
        padding: 8px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        max-width: 100%;
    }
    
    /* Logo Container - Prevents Overflow */
    .logo {
        display: flex;
        align-items: center;
        max-width: calc(100% - 60px); /* Space for hamburger button */
        flex-shrink: 1;
        min-width: 0; /* Allows flex item to shrink below content size */
    }
    
    /* Logo Icon Size */
    .logo-icon { 
        width: 28px; 
        height: 28px; 
        flex-shrink: 0;
        margin-right: 6px;
    }
    
    /* MAIN FIX: Logo Text Wrapping */
    .logo-text {
        white-space: normal !important; 
        word-break: break-word !important;
        overflow-wrap: break-word !important;
        flex: 1;
        min-width: 0;
        line-height: 1.1;
    }

    .logo-text h1 { 
        font-size: 11px; 
        margin: 0;
        font-weight: 600;
    }
    
    .logo-text p { 
        font-size: 8px; 
        margin: 0;
        margin-top: 2px;
    }

    /* Mobile Menu Button */
    .mobile-menu-btn {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
    }

    /* CRITICAL FIX: Mobile Menu Vertical Layout */
    .mobile-menu {
        position: fixed;
        top: 60px;
        left: 0;
        right: 0;
        width: 100%;
        max-width: 100%;
        padding: 0;
        display: none; /* Hidden by default */
        flex-direction: column;
        overflow-y: auto;
        overflow-x: hidden;
        max-height: calc(100vh - 60px);
        z-index: 1000;
    }
        
    
    /* Show menu when active */
    .mobile-menu.active {
        display: flex !important;
    }
    
    /* CRITICAL: Forces Vertical Stacking of Menu Items */
    .mobile-menu a,
    .mobile-services-btn {
        display: block !important;
        width: 100% !important;
        padding: 16px 20px !important;
        font-size: 16px;
        text-align: left;
        text-decoration: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        transition: background-color 0.3s;
        background-color: #c62828 !important; /* Service wala red background */
        color: white !important;
        border: none !important;
        cursor: pointer;
    }

    .mobile-menu a:hover,
    .mobile-services-btn:hover {
        background-color: #a32020 !important; /* Darker red on hover */
    }

    /* Service Submenu - Same background as parent */
    .mobile-services-submenu {
        display: flex;
        flex-direction: column;
        width: 100%;
        background-color: #000000ff !important; /* Same red background */
    }

    .mobile-services-submenu a {
        padding-left: 40px !important;
        font-size: 14px;
        background-color: #ce1515ff !important; /* Slightly darker for submenu */
    }

    .mobile-services-submenu a:hover {
        background-color: #1a1919ff !important;
    }

    /* Service Details Text Sizes */
    .service-name-ar {
        font-size: 16px;
    }

    .service-name-en {
        font-size: 11px;
    }

    /* General Padding */
    .content-section { 
        padding: 40px 15px; 
    }

    /* Floating Icons & Back to Top Button */
    .floating-social-icons {
        right: 15px;
        bottom: 70px;
    }

    .back-to-top {
        right: 15px;
        bottom: 15px;
    }

    .service-page-header h1 {
        font-size: 28px;
        text-align: center;
    }

    /* Section Headers */
    .section-header h2 {
        font-size: 28px;
    }

    /* Ensure all grids are single column */
    .services-grid,
    .contact-grid,
    .social-icons-grid {
        grid-template-columns: 1fr !important;
    }
}
    
    `;     
// ==================== SERVICE DETAIL PAGE ====================
  if (currentPage === 'service' && currentService) {
    const service = servicesData[currentService];
    
    if (!service) {
      return (
        <div>
          <style>{customStyles}</style>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />
          <p style={{ textAlign: 'center', marginTop: '100px' }}>Service not found</p>
        </div>
      );
    }

    return (
      <div>
        <style>{customStyles}</style>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />

        <nav className={`modern-navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
          <div className="navbar-content">
            <div className="logo-section" onClick={() => navigateToPage('home')}>
              <div className="logo-icon">
                <img src="/image/logo.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
              <div className="logo-text">
                <h1>{fullEnglishName}</h1>
                <p>{fullArabicName}</p>
              </div>
            </div>
            
            <ul className="nav-links">
              <li><button onClick={() => navigateToSection('home')}>Home</button></li>
              <li 
                className="services-dropdown"
                onMouseEnter={handleServicesMouseEnter}
                onMouseLeave={handleServicesMouseLeave}
              >
                <button className="services-dropdown-btn" onClick={toggleServicesDropdown}>
                  Services <i className={`fas fa-chevron-${servicesDropdownOpen ? 'up' : 'down'}`}></i>
                </button>
                {servicesDropdownOpen && (
                  <div className="dropdown-menu" onMouseEnter={handleServicesMouseEnter} onMouseLeave={handleServicesMouseLeave}>
                    {Object.keys(servicesData).map(key => (
                      <button key={key} onClick={() => navigateToService(key)}>
                        <i className={`fas ${servicesData[key].icon}`}></i> {servicesData[key].title}
                      </button>
                    ))}
                  </div>
                )}
              </li>
              <li><button onClick={() => navigateToSection('about')}>About</button></li>
              <li><button onClick={() => navigateToSection('mission')}>Mission/Vision</button></li>
              <li><button onClick={() => navigateToSection('certificates')}>Certificates</button></li>
              <li><button onClick={() => navigateToSection('contact')}>Contact</button></li>
            </ul>
            
            <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
            </button>
          </div>
        </nav>

        <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <button onClick={() => navigateToSection('home')} style={{textAlign: 'left'}}>
            <i className="fas fa-home"></i> Home
          </button>
          <button className="mobile-services-btn" onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)}>
            <span><i className="fas fa-briefcase"></i> Services</span>
            <i className={`fas fa-chevron-${servicesDropdownOpen ? 'up' : 'down'}`}></i>
          </button>
          {servicesDropdownOpen && (
            <div className="mobile-dropdown">
              {Object.keys(servicesData).map(key => (
                <button key={key} onClick={() => navigateToService(key)}>
                  <span className="service-name-ar">{servicesData[key].titleAr}</span>
                  <span className="service-name-en">{servicesData[key].title}</span>
                </button>
              ))}
            </div>
          )}
          <button onClick={() => navigateToSection('about')} style={{textAlign: 'left'}}>
            <i className="fas fa-info-circle"></i> About
          </button>
          <button onClick={() => navigateToSection('mission')} style={{textAlign: 'left'}}>
            <i className="fas fa-bullseye"></i> Mission/Vision
          </button>
          <button onClick={() => navigateToSection('certificates')} style={{textAlign: 'left'}}>
            <i className="fas fa-certificate"></i> Certificates
          </button>
          <button onClick={() => navigateToSection('contact')} style={{textAlign: 'left'}}>
            <i className="fas fa-envelope"></i> Contact
          </button>
        </div>

        <div className="service-page-header">
          <h1>{service.title}</h1>
          <p>{service.description}</p>
        </div>

        <section className="content-section">
          {service.subServices && service.subServices.length > 0 ? (
            <>
              <div className="section-header">
                <h2>Our {service.title} Services</h2>
                <div className="underline"></div>
                <p>Comprehensive solutions tailored to your needs</p>
              </div>
              <div className="services-grid">
                {service.subServices.map((subService, index) => (
                  <div 
                    key={subService.id} 
                    className="service-card fade-in-section" 
                    style={{ animationDelay: `${index * 0.1}s` }}
                    onClick={() => navigateToSubService(currentService, subService.urlSlug)}
                  >
                    <div className="service-image-container">
                      <img src={subService.mainImage} alt={subService.title} className="service-image" 
                        onError={(e) => {
                          e.target.style.background = '#1b6fcfff';
                          e.target.style.display = 'none';
                        }}
                      />
                      <div className="service-badge">{subService.title}</div>
                    </div>
                    <div className="service-content">
                      <h3>{subService.title}</h3>
                      <p>{subService.shortDesc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <i className={`fas ${service.icon}`} style={{ fontSize: '80px', color: 'var(--accent-color)', marginBottom: '20px' }}></i>
              <h2 style={{ color: 'var(--primary-color)', marginBottom: '20px' }}>Coming Soon</h2>
              <p style={{ fontSize: '18px', color: 'var(--text-light)', maxWidth: '600px', margin: '0 auto' }}>
                Detailed information about our {service.title} services will be available soon. Contact us for more information.
              </p>
              <button onClick={() => navigateToSection('contact')} className="btn-primary" style={{ marginTop: '30px' }}>
                <i className="fas fa-envelope"></i> Contact Us
              </button>
            </div>
          )}
        </section>

        <footer className="footer">
          <div className="footer-content">
            <div className="footer-section">
              <h3>{fullEnglishName}</h3>
              <p style={{ direction: 'rtl' }}>{fullArabicName}</p>
            </div>
            <div className="footer-section">
              <h3>Quick Links</h3>
              <button onClick={() => navigateToSection('home')} style={{ background: 'none', border: 'none', padding: 0, textAlign: 'left' }}>Home</button>
              <button onClick={() => navigateToSection('contact')} style={{ background: 'none', border: 'none', padding: 0, textAlign: 'left' }}>Contact</button>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 {fullEnglishName}. All Rights Reserved.</p>
          </div>
        </footer>

        {showBackToTop && (
          <>
            <div className="floating-social-icons">
              <a href="https://wa.me/966506780687" target="_blank" rel="noopener noreferrer" className="floating-social-btn whatsapp">
                <i className="fab fa-whatsapp"></i>
              </a>
              <a href="https://www.linkedin.com/company/hessa-abdullah-awadh-al-zahrani-contracting-co/" target="_blank" rel="noopener noreferrer" className="floating-social-btn linkedin">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
            <button className="back-to-top show" onClick={scrollToTop}>
              <i className="fas fa-arrow-up"></i>
            </button>
          </>
        )}
      </div>
    );
  }

  // ==================== SUB-SERVICE DETAIL PAGE ====================
  if (currentPage === 'subservice' && currentService && currentSubService) {
    const service = servicesData[currentService];
    const subService = service?.subServices?.find(s => s.urlSlug === currentSubService);
    
    if (!subService) {
      return (
        <div>
          <style>{customStyles}</style>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />
          <p style={{ textAlign: 'center', marginTop: '100px' }}>Service not found</p>
        </div>
      );
    }

    return (
      <div>
        <style>{customStyles}</style>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />

        <nav className={`modern-navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
          <div className="navbar-content">
            <div className="logo-section" onClick={() => navigateToPage('home')}>
              <div className="logo-icon">
                <img src="/image/logo.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
              <div className="logo-text">
                <h1>{fullEnglishName}</h1>
                <p>{fullArabicName}</p>
              </div>
            </div>
            
            <ul className="nav-links">
              <li><button onClick={() => navigateToSection('home')}>Home</button></li>
              <li><button onClick={() => navigateToService(currentService)}>Back to {service.title}</button></li>
              <li><button onClick={() => navigateToSection('contact')}>Contact</button></li>
            </ul>
            
            <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
            </button>
          </div>
        </nav>

        <div className="service-page-header">
          <h1>{subService.title}</h1>
          <p>{subService.shortDesc}</p>
        </div>

        <section className="content-section">
          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            <div style={{ marginBottom: '40px' }}>
              <img src={subService.mainImage} alt={subService.title} 
                style={{ width: '100%', height: '400px', objectFit: 'cover', borderRadius: '15px' }}
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            </div>

            <div style={{ fontSize: '17px', lineHeight: '1.8', color: 'var(--text-light)', whiteSpace: 'pre-line' }}>
              {subService.fullDescription}
            </div>

            {subService.features && subService.features.length > 0 && (
              <div style={{ marginTop: '40px', padding: '40px', background: 'var(--bg-light)', borderRadius: '15px' }}>
                <h3 style={{ color: 'var(--primary-color)', marginBottom: '20px', fontSize: '28px' }}>Key Features</h3>
                <div style={{ display: 'grid', gap: '15px' }}>
                  {subService.features.map((feature, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
                      <i className="fas fa-check-circle" style={{ fontSize: '24px', color: 'var(--accent-color)', marginTop: '3px' }}></i>
                      <p style={{ margin: 0, fontSize: '16px' }}>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ marginTop: '40px', textAlign: 'center' }}>
              <button onClick={() => navigateToSection('contact')} className="btn-primary">
                <i className="fas fa-envelope"></i> Contact Us for This Service
              </button>
            </div>
          </div>
        </section>

        <footer className="footer">
          <div className="footer-content">
            <div className="footer-section">
              <h3>{fullEnglishName}</h3>
              <p style={{ direction: 'rtl' }}>{fullArabicName}</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 {fullEnglishName}. All Rights Reserved.</p>
          </div>
        </footer>

        {showBackToTop && (
          <>
            <div className="floating-social-icons">
              <a href="https://wa.me/966506780687" target="_blank" rel="noopener noreferrer" className="floating-social-btn whatsapp">
                <i className="fab fa-whatsapp"></i>
              </a>
              <a href="https://www.linkedin.com/company/hessa-abdullah-awadh-al-zahrani-contracting-co/" target="_blank" rel="noopener noreferrer" className="floating-social-btn linkedin">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
            <button className="back-to-top show" onClick={scrollToTop}>
              <i className="fas fa-arrow-up"></i>
            </button>
          </>
        )}
      </div>
    );
  }
// ==================== HOME PAGE ====================
  return (
    <div>
      <style>{customStyles}</style>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />

      <nav className={`modern-navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
        <div className="navbar-content">
          <div className="logo-section" onClick={() => navigateToPage('home')}>
            <div className="logo-icon">
              <img src="/image/logo.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </div>
            <div className="logo-text">
              <h1>{fullEnglishName}</h1>
              <p>{fullArabicName}</p>
            </div>
          </div>
          
          <ul className="nav-links">
            <li><button onClick={() => navigateToPage('home')}>Home</button></li>
            <li 
              className="services-dropdown"
              onMouseEnter={handleServicesMouseEnter}
              onMouseLeave={handleServicesMouseLeave}
            >
              <button className="services-dropdown-btn" onClick={toggleServicesDropdown}>
                Services <i className={`fas fa-chevron-${servicesDropdownOpen ? 'up' : 'down'}`}></i>
              </button>
              {servicesDropdownOpen && (
                <div className="dropdown-menu" onMouseEnter={handleServicesMouseEnter} onMouseLeave={handleServicesMouseLeave}>
                  {Object.keys(servicesData).map(key => (
                    <button key={key} onClick={() => navigateToService(key)}>
                      <i className={`fas ${servicesData[key].icon}`}></i> {servicesData[key].title}
                    </button>
                  ))}
                </div>
              )}
            </li>
           <li><button onClick={() => navigateToSection('about')}>About</button></li>
<li><button onClick={() => navigateToSection('mission')}>Mission/Vision</button></li>
<li><button onClick={() => navigateToSection('certificates')}>Certificates</button></li>
<li><button onClick={() => navigateToSection('contact')}>Contact</button></li>

          </ul>
          
          <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <button onClick={() => { navigateToPage('home'); setMobileMenuOpen(false); }} style={{textAlign: 'left'}}>
          <i className="fas fa-home"></i> Home
        </button>
        <button className="mobile-services-btn" onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)}>
          <span><i className="fas fa-briefcase"></i> Services</span>
          <i className={`fas fa-chevron-${servicesDropdownOpen ? 'up' : 'down'}`}></i>
        </button>
        {servicesDropdownOpen && (
          <div className="mobile-dropdown">
            {Object.keys(servicesData).map(key => (
              <button key={key} onClick={() => navigateToService(key)}>
                <span className="service-name-ar">{servicesData[key].titleAr}</span>
                <span className="service-name-en">{servicesData[key].title}</span>
              </button>
            ))}
          </div>
        )}
        <button onClick={() => { navigateToSection('about'); setMobileMenuOpen(false); }}>
  <i className="fas fa-info-circle"></i> About
</button>

<button onClick={() => { navigateToSection('mission'); setMobileMenuOpen(false); }}>
  <i className="fas fa-bullseye"></i> Mission/Vision
</button>

<button onClick={() => { navigateToSection('certificates'); setMobileMenuOpen(false); }}>
  <i className="fas fa-certificate"></i> Certificates
</button>

<button onClick={() => { navigateToSection('contact'); setMobileMenuOpen(false); }}>
  <i className="fas fa-envelope"></i> Contact
</button>

      </div>

      {/* Hero Section */}
      <section className="hero-section" id="home">
        <img src="/image/header-banner.jpg" alt="Hero Background" className="hero-image" />
        <div className="hero-content">
          <h1>Building Excellence Since 2022</h1>
          <p>Leading Saudi Arabian Contracting Company delivering world-class construction solutions with unmatched quality and innovation</p>
          <div className="hero-buttons">
           <button onClick={() => navigateToSection('services')} className="btn-primary">Explore Services</button>
<button onClick={() => navigateToSection('contact')} className="btn-secondary">Get In Touch</button>
            <button className="btn-social" onClick={() => {
              const modal = document.querySelector('.social-connect-modal');
              if (modal) modal.classList.add('active');
            }}>
              <i className="fas fa-share-alt"></i> Social Connect
            </button>
          </div>
        </div>
      </section>

      {/* Social Connect Modal */}
      <div className="social-connect-modal">
        <div className="social-connect-content">
          <button className="close-social-modal" onClick={(e) => {
            e.target.closest('.social-connect-modal').classList.remove('active');
          }}>
            <i className="fas fa-times"></i>
          </button>
          <h3>Connect With Us</h3>
          <div className="social-icons-grid">
            <a href="https://wa.me/966506780687" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp">
              <i className="fab fa-whatsapp"></i>
              <span>WhatsApp</span>
            </a>
            <a href="https://www.linkedin.com/company/hessa-abdullah-awadh-al-zahrani-contracting-co/" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
              <i className="fab fa-linkedin"></i>
              <span>LinkedIn</span>
            </a>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <section className="stats-section" id="stats-section">
        <div className="stats-container">
          <div className="stat-item">
            <div className="stat-icon"><i className="fas fa-calendar-alt"></i></div>
            <div className="stat-number">{counters.years}+</div>
            <div className="stat-label">Years of Excellence</div>
          </div>
          <div className="stat-item">
            <div className="stat-icon"><i className="fas fa-project-diagram"></i></div>
            <div className="stat-number">{counters.projects}+</div>
            <div className="stat-label">Completed Projects</div>
          </div>
          <div className="stat-item">
            <div className="stat-icon"><i className="fas fa-handshake"></i></div>
            <div className="stat-number">{counters.clients}%</div>
            <div className="stat-label">Satisfied Clients</div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="content-section fade-in-section" id="mission">
        <div className="section-header">
          <h2>Mission & Vision</h2>
          <div className="underline"></div>
          <p>Our commitment to excellence and innovation</p>
        </div>
        <div className="mv-container">
          <div className="mv-card">
            <h3><i className="fas fa-bullseye"></i> Our Mission</h3>
            <p>To deliver world-class construction solutions that reflect quality, safety, and innovation. We strive to exceed client expectations through professional excellence and cutting-edge engineering practices.</p>
          </div>
          <div className="mv-card">
            <h3><i className="fas fa-eye"></i> Our Vision</h3>
            <p>To become one of the leading contracting establishments in the Kingdom of Saudi Arabia, recognized for reliability, technical excellence, and sustainable development practices.</p>
          </div>
        </div>
      </section>
     
      {/* Services Section */}
      <section className="content-section fade-in-section" id="services" ref={servicesRef} style={{ background: 'var(--bg-light)' }}>
        <div className="section-header">
          <h2>Our Services & Expertise</h2>
          <div className="underline"></div>
          <p>Delivering comprehensive engineering and contracting solutions across multiple disciplines</p>
        </div>  
        <div className="services-grid">
          {visibleServices.map((service, index) => (
            <div 
              key={service.id} 
              className="service-card fade-in-section" 
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => navigateToService(service.serviceKey)}
            >
              <div className="service-image-container">
                <img src={service.image} alt={service.title} className="service-image" 
                  onError={(e) => {
                    e.target.style.background = '#002B5B';
                    e.target.style.display = 'none';
                  }}
                />
                <div className="service-badge">{service.title}</div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.details}</p>
              </div>
            </div>
          ))}
        </div>
        <button onClick={toggleServices} className="show-more-btn">
          {showAllServices ? "Show Less" : "Show More"}
        </button>
      </section>

      {/* About Section */}
      <section className="content-section fade-in-section" id="about">
        <div className="section-header">
          <h2>About Us</h2>
          <div className="underline"></div>
          <p>Excellence in Engineering & Construction</p>
        </div>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center', lineHeight: '1.8', fontSize: '17px', color: 'var(--text-light)' }}>
          <p>Hessa Abdullah Awadh Al-Zahrani Contracting Est. delivers exceptional engineering and contracting services across Saudi Arabia. Our expertise covers Electrical, Mechanical, Civil, and Infrastructure works — ensuring excellence in every project.</p>
          <p style={{ marginTop: '20px' }}>With a commitment to quality, safety, and innovation, we have established ourselves as a trusted partner in the Kingdom's construction industry.</p>
        </div>
      </section>

      {/* QHSE Policy */}
      <section className="content-section fade-in-section" style={{ background: 'var(--bg-light)' }}>
        <div className="section-header">
          <h2>QHSE Policy</h2>
          <div className="underline"></div>
          <p>Quality, Health, Safety & Environment Commitment</p>
        </div>
        <div style={{ maxWidth: '900px', margin: '0 auto', background: 'white', padding: '40px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <div style={{ display: 'grid', gap: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
              <i className="fas fa-check-circle" style={{ fontSize: '24px', color: 'var(--accent-color)', marginTop: '5px' }}></i>
              <p style={{ margin: '0', fontSize: '16px', color: 'var(--text-light)' }}>Control quality system & technical operational standards</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
              <i className="fas fa-check-circle" style={{ fontSize: '24px', color: 'var(--accent-color)', marginTop: '5px' }}></i>
              <p style={{ margin: '0', fontSize: '16px', color: 'var(--text-light)' }}>Provide quality standard compliance across all projects</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
              <i className="fas fa-check-circle" style={{ fontSize: '24px', color: 'var(--accent-color)', marginTop: '5px' }}></i>
              <p style={{ margin: '0', fontSize: '16px', color: 'var(--text-light)' }}>Ensure safe system of work and worker protection</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
              <i className="fas fa-check-circle" style={{ fontSize: '24px', color: 'var(--accent-color)', marginTop: '5px' }}></i>
              <p style={{ margin: '0', fontSize: '16px', color: 'var(--text-light)' }}>Improve quality, safe, healthy and environment behavioral practice & culture</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
              <i className="fas fa-check-circle" style={{ fontSize: '24px', color: 'var(--accent-color)', marginTop: '5px' }}></i>
              <p style={{ margin: '0', fontSize: '16px', color: 'var(--text-light)' }}>Perform all activities in line with environmental justice</p>
            </div>
          </div>
        </div>
      </section>
 
        {/* Certificates */}
        <section className="content-section fade-in-section" id="certificates">
          <div className="section-header">
            <h2>Certificates & Compliance</h2>
            <div className="underline"></div>
            <p>Certified to international standards of safety and quality</p>
          </div>
          <div className="cert-container">
            <img src="/image/hessa.gi" alt="Certificates" className="cert-image" 
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        </section>

      {/* Contact Section */}
      <section className="content-section contact-section fade-in-section" id="contact">
        <div className="section-header">
          <h2>Get In Touch</h2>
          <div className="underline"></div>
          <p>Ready to start your project? Contact us today</p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h3 style={{ color: 'var(--primary-color)', marginBottom: '30px', fontSize: '24px' }}>
              Contact Information
            </h3>

            <div className="contact-item">
              <div className="contact-icon"><i className="fas fa-phone"></i></div>
              <div className="contact-details">
                <h4>Phone</h4>
                <p><a href="tel:0133124387">0133124387</a></p>
                <p><a href="tel:+966506780687">+966 50 6780687</a></p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon"><i className="fas fa-envelope"></i></div>
              <div className="contact-details">
                <h4>Email</h4>
                <p><a href="mailto:info@haazksa.com">info@haazksa.com</a></p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon"><i className="fas fa-map-marker-alt"></i></div>
              <div className="contact-details">
                <h4>Address</h4>
                <p>PO Box: 7588</p>
                <p>Hamza Bin Abdul Mutallib</p>
                <p>Al-Urazia Al Grabi</p>
                <p>Riyadh 14312, Kingdom of Saudi Arabia</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon"><i className="fas fa-id-card"></i></div>
              <div className="contact-details">
                <h4>CR Number</h4>
                <p>1010207577</p>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <h3 style={{ color: 'var(--primary-color)', marginBottom: '30px', fontSize: '24px' }}>
              Send Us a Message
            </h3>

            <form action="https://formsubmit.co/info@haazksa.com" method="POST">
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="table" />

              <div className="form-group">
                <input type="text" placeholder="Your Name" required name="Name" />
              </div>

              <div className="form-group">
                <input type="email" placeholder="Your Email" required name="Email" />
              </div>

              <div className="form-group">
                <input type="text" placeholder="Subject" required name="Subject" />
              </div>

              <div className="form-group">
                <textarea placeholder="Your Message" required name="Message"></textarea>
              </div>

              <button type="submit" className="submit-btn">
                <i className="fas fa-paper-plane"></i> Send Message
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{fullEnglishName}</h3>
            <p style={{ direction: 'rtl' }}>{fullArabicName}</p>
            <p style={{ marginTop: '20px' }}>
              Leading contracting company delivering excellence in engineering and construction across Saudi Arabia.
            </p>
          </div>

          <div className="footer-section">
  <h3>Quick Links</h3>
  <button onClick={() => navigateToSection('home')}>Home</button>
  <button onClick={() => navigateToSection('services')}>Services</button>
  <button onClick={() => navigateToSection('about')}>About Us</button>
  <button onClick={() => navigateToSection('mission')}>Mission & Vision</button>
  <button onClick={() => navigateToSection('contact')}>Contact</button>
</div>

          <div className="footer-section">
            <h3>Contact Info</h3>
            <p><i className="fas fa-phone"></i> <a href="tel:0133124387">0133124387</a></p>
            <p><i className="fas fa-mobile-alt"></i> <a href="tel:+966506780687">+966 50 6780687</a></p>
            <p><i className="fas fa-envelope"></i> <a href="mailto:info@haazksa.com">info@haazksa.com</a></p>
            <p><i className="fas fa-map-marker-alt"></i> Riyadh 14312, KSA</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 {fullEnglishName}. All Rights Reserved.</p>
          <p style={{ marginTop: '10px' }}>
            Powered by <span style={{ color: 'var(--accent-color)', fontWeight: 'bold' }}>MD ARIB USMANI</span>
          </p>
        </div>
      </footer>

      {/* Floating Social Icons & Back to Top */}
      {showBackToTop && (
        <div className="floating-social-icons">
          <a 
            href="https://wa.me/966506780687" 
            target="_blank" 
            rel="noopener noreferrer"
            className="floating-social-btn whatsapp"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
          <a 
            href="https://www.linkedin.com/company/hessa-abdullah-awadh-al-zahrani-contracting-co/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="floating-social-btn linkedin"
          >
            <i className="fab fa-linkedin"></i>
          </a>
        </div>
      )}

      <button 
        className={`back-to-top ${showBackToTop ? 'show' : ''}`}
        onClick={scrollToTop}
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    </div>
  );
};

export default App;